window.theme = window.theme || {};
window.slate = window.slate || {};

window.lazySizesConfig = window.lazySizesConfig || {};
lazySizesConfig.expFactor = 4;

(function() {
  var $ = jQuery;

  slate.utils = {
    /**
     * _.defaultTo from lodash
     * Checks `value` to determine whether a default value should be returned in
     * its place. The `defaultValue` is returned if `value` is `NaN`, `null`,
     * or `undefined`.
     * Source: https://github.com/lodash/lodash/blob/master/defaultTo.js
     *
     * @param {*} value - Value to check
     * @param {*} defaultValue - Default value
     * @returns {*} - Returns the resolved value
     */
    defaultTo: function(value,defaultValue) {
      return (value == null || value !== value) ? defaultValue : value;
    }
  };

  slate.a11y = {

    /**
     * Traps the focus in a particular container
     *
     * @param {object} options - Options to be used
     * @param {jQuery} options.$container - Container to trap focus within
     * @param {jQuery} options.$elementToFocus - Element to be focused when focus leaves container
     * @param {string} options.namespace - Namespace used for new focus event handler
     */
    trapFocus: function(options) {
      var eventName = options.namespace
        ? 'focusin.' + options.namespace
        : 'focusin';

      if (!options.$elementToFocus) {
        options.$elementToFocus = options.$container;
      }

      options.$container.attr('tabindex','-1');
      options.$elementToFocus.focus();

      $(document).off('focusin');

      $(document).on(eventName,function(evt) {
        if (options.$container[0] !== evt.target && !options.$container.has(evt.target).length) {
          options.$container.focus();
        }
      });
    },

    /**
     * Removes the trap of focus in a particular container
     *
     * @param {object} options - Options to be used
     * @param {jQuery} options.$container - Container to trap focus within
     * @param {string} options.namespace - Namespace used for new focus event handler
     */
    removeTrapFocus: function(options) {
      var eventName = options.namespace
        ? 'focusin.' + options.namespace
        : 'focusin';

      if (options.$container && options.$container.length) {
        options.$container.removeAttr('tabindex');
      }

      $(document).off(eventName);
    },


    // Not from Slate, but fit in the a11y category
    lockMobileScrolling: function(namespace,$element) {
      if ($element) {
        var $el = $element;
      } else {
        var $el = $(document.documentElement).add('body');
      }
      $el.on('touchmove' + namespace,function() {
        return false;
      });
    },

    unlockMobileScrolling: function(namespace,$element) {
      if ($element) {
        var $el = $element;
      } else {
        var $el = $(document.documentElement).add('body');
      }
      $el.off(namespace);
    }
  };

  theme.Sections = function Sections() {
    this.constructors = {};
    this.instances = [];

    $(document)
      .on('shopify:section:load',this._onSectionLoad.bind(this))
      .on('shopify:section:unload',this._onSectionUnload.bind(this))
      .on('shopify:section:select',this._onSelect.bind(this))
      .on('shopify:section:deselect',this._onDeselect.bind(this))
      .on('shopify:block:select',this._onBlockSelect.bind(this))
      .on('shopify:block:deselect',this._onBlockDeselect.bind(this));
  };

  theme.Sections.prototype = Object.assign({},theme.Sections.prototype,{
    createInstance: function(container,constructor,customScope) {
      var $container = $(container);
      var id = $container.attr('data-section-id');
      var type = $container.attr('data-section-type');

      constructor = constructor || this.constructors[type];

      if (typeof constructor === 'undefined') {
        return;
      }

      // If custom scope passed, check to see if instance
      // is already initialized so we don't double up
      if (customScope) {
        var instanceExists = this._findInstance(id);
        if (instanceExists) {
          return;
        }
      }

      var instance = Object.assign(new constructor(container),{
        id: id,
        type: type,
        container: container
      });

      this.instances.push(instance);
    },

    _onSectionLoad: function(evt,subSection,subSectionId) {
      if (AOS) {
        AOS.refreshHard();
      }
      var container = subSection ? subSection : $('[data-section-id]',evt.target)[0];

      if (!container) {
        return;
      }

      this.createInstance(container);

      var instance = subSection ? subSectionId : this._findInstance(evt.detail.sectionId);

      if (!subSection) {
        this._loadSubSections();
      }

      // Run JS only in case of the section being selected in the editor
      // before merchant clicks "Add"
      if (instance && typeof instance.onLoad === 'function') {
        instance.onLoad(evt);
      }
    },

    _loadSubSections: function() {
      if (AOS) {
        AOS.refreshHard();
      }
      $('[data-subsection]').each(function(evt,el) {
        this._onSectionLoad(null,el,$(el).data('section-id'));
      }.bind(this));
    },

    _onSectionUnload: function(evt) {
      var instance = this._removeInstance(evt.detail.sectionId);
      if (instance && typeof instance.onUnload === 'function') {
        instance.onUnload(evt);
      }
    },

    _onSelect: function(evt) {
      var instance = this._findInstance(evt.detail.sectionId);

      if (instance && typeof instance.onSelect === 'function') {
        instance.onSelect(evt);
      }
    },

    _onDeselect: function(evt) {
      var instance = this._findInstance(evt.detail.sectionId);

      if (instance && typeof instance.onDeselect === 'function') {
        instance.onDeselect(evt);
      }
    },

    _onBlockSelect: function(evt) {
      var instance = this._findInstance(evt.detail.sectionId);

      if (instance && typeof instance.onBlockSelect === 'function') {
        instance.onBlockSelect(evt);
      }
    },

    _onBlockDeselect: function(evt) {
      var instance = this._findInstance(evt.detail.sectionId);

      if (instance && typeof instance.onBlockDeselect === 'function') {
        instance.onBlockDeselect(evt);
      }
    },

    _findInstance: function(id) {
      for (var i = 0; i < this.instances.length; i++) {
        if (this.instances[i].id === id) {
          return this.instances[i];
        }
      }
    },

    _removeInstance: function(id) {
      var i = this.instances.length;
      var instance;

      while (i--) {
        if (this.instances[i].id === id) {
          instance = this.instances[i];
          this.instances.splice(i,1);
          break;
        }
      }

      return instance;
    },

    register: function(type,constructor,$scope) {
      var afterLoad = false;
      this.constructors[type] = constructor;
      var $sections = $('[data-section-type=' + type + ']');

      if ($scope) {
        $sections = $('[data-section-type=' + type + ']',$scope);
      }

      $sections.each(function(index,container) {
        this.createInstance(container,constructor,$scope);
      }.bind(this));
    }
  });


  /**
   * Currency Helpers
   * -----------------------------------------------------------------------------
   * A collection of useful functions that help with currency formatting
   *
   * Current contents
   * - formatMoney - Takes an amount in cents and returns it as a formatted dollar value.
   *
   * Alternatives
   * - Accounting.js - http://openexchangerates.github.io/accounting.js/
   *
   */

  theme.Currency = (function() {
    var moneyFormat = '${{amount}}';

    function formatMoney(cents,format) {
      if (typeof cents === 'string') {
        cents = cents.replace('.','');
      }
      var value = '';
      var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
      var formatString = (format || moneyFormat);

      function formatWithDelimiters(number,precision,thousands,decimal) {
        precision = slate.utils.defaultTo(precision,2);
        thousands = slate.utils.defaultTo(thousands,',');
        decimal = slate.utils.defaultTo(decimal,'.');

        if (isNaN(number) || number == null) {
          return 0;
        }

        number = (number / 100.0).toFixed(precision);

        var parts = number.split('.');
        var dollarsAmount = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g,'$1' + thousands);
        var centsAmount = parts[1] ? (decimal + parts[1]) : '';

        return dollarsAmount + centsAmount;
      }

      switch (formatString.match(placeholderRegex)[1]) {
        case 'amount':
          value = formatWithDelimiters(cents,2);
          break;
        case 'amount_no_decimals':
          value = formatWithDelimiters(cents,0);
          break;
        case 'amount_with_comma_separator':
          value = formatWithDelimiters(cents,2,'.',',');
          break;
        case 'amount_no_decimals_with_comma_separator':
          value = formatWithDelimiters(cents,0,'.',',');
          break;
        case 'amount_no_decimals_with_space_separator':
          value = formatWithDelimiters(cents,0,' ');
          break;
      }

      return formatString.replace(placeholderRegex,value);
    }

    function getBaseUnit(variant) {
      if (!variant) {
        return;
      }

      if (!variant.unit_price_measurement || !variant.unit_price_measurement.reference_value) {
        return;
      }

      return variant.unit_price_measurement.reference_value === 1
        ? variant.unit_price_measurement.reference_unit
        : variant.unit_price_measurement.reference_value +
        variant.unit_price_measurement.reference_unit;
    }

    return {
      formatMoney: formatMoney,
      getBaseUnit: getBaseUnit
    };
  })();


  /**
   * Image Helper Functions
   * -----------------------------------------------------------------------------
   * A collection of functions that help with basic image operations.
   *
   */

  theme.Images = (function() {

    /**
     * Find the Shopify image attribute size
     *
     * @param {string} src
     * @returns {null}
     */
    function imageSize(src) {
      if (!src) {
        return '620x'; // default based on theme
      }

      var match = src.match(/.+_((?:pico|icon|thumb|small|compact|medium|large|grande)|\d{1,4}x\d{0,4}|x\d{1,4})[_\.@]/);

      if (match !== null) {
        return match[1];
      } else {
        return null;
      }
    }

    /**
     * Adds a Shopify size attribute to a URL
     *
     * @param src
     * @param size
     * @returns {*}
     */
    function getSizedImageUrl(src,size) {
      if (size == null) {
        return src;
      }

      if (size === 'master') {
        return this.removeProtocol(src);
      }

      var match = src.match(/\.(jpg|jpeg|gif|png|bmp|bitmap|tiff|tif)(\?v=\d+)?$/i);

      if (match != null) {
        var prefix = src.split(match[0]);
        var suffix = match[0];

        return this.removeProtocol(prefix[0] + '_' + size + suffix);
      }

      return null;
    }

    function removeProtocol(path) {
      return path.replace(/http(s)?:/,'');
    }

    return {
      imageSize: imageSize,
      getSizedImageUrl: getSizedImageUrl,
      removeProtocol: removeProtocol
    };
  })();

  slate.Variants = (function() {

    function Variants(options) {
      this.$container = options.$container;
      this.variants = options.variants;
      this.singleOptionSelector = options.singleOptionSelector;
      this.originalSelectorId = options.originalSelectorId;
      this.enableHistoryState = options.enableHistoryState;
      this.currentVariant = this._getVariantFromOptions();
      if (this.currentVariant)
      	window.lastVariantId = this.currentVariant.id;
      if (options.variants.length > 0) {
        $(this.singleOptionSelector,this.$container).on('change',this._onSelectChange.bind(this));
      }
      $(".currentVariant").trigger( "click" );
    }

    Variants.prototype = Object.assign({},Variants.prototype,{

      _getCurrentOptions: function() {

        var currentOptions = $.map($(this.singleOptionSelector,this.$container),function(element) {

          var $element = $(element);

          var type = $element.attr('type');
          var currentOption = {};

          if (type === 'radio' || type === 'checkbox') {

            if ($element[0].checked) {
              currentOption.value = $element.val();
              currentOption.index = $element.data('index');

              return currentOption;
            } else {
              return false;
            }
          } else {
            currentOption.value = $element.val();
            currentOption.index = $element.data('index');

            return currentOption;
          }
        });

        // remove any unchecked input values if using radio buttons or checkboxes
        currentOptions = this._compact(currentOptions);

        return currentOptions;
      },

      _getVariantFromOptions: function() {
        var selectedValues = this._getCurrentOptions();
        var variants = this.variants;
        var found = false;

        variants.forEach(function(variant) {
          var match = true;
          var options = variant.options;

          selectedValues.forEach(function(option) {
            if (match) {
              match = (variant[option.index] === option.value);
            }
          });

          if (match) {
            found = variant;
          }
        });
        this._promoTaggingYo(found);
        return found || null;
      },
      _onSelectChange: function() {
        var variant = this._getVariantFromOptions();

        this.$container.trigger({
          type: 'variantChange',
          variant: variant
        });
        if (!variant) {
          return;
        }
        this._updateMasterSelect(variant);
        this._updateImages(variant);
        this._updatePrice(variant);
        this._updateUnitPrice(variant);
        this._updateSKU(variant);
        this.currentVariant = variant;

        if (variant.featured_image) {
          $('#sticky-product-image').attr('src', variant.featured_image.src)  
        }
        $('#add-to-cart-variant-sticky').val(variant.id);
        
        if (this.enableHistoryState) {
          this._updateHistoryState(variant);
        }
      },
      _promoTaggingYo: function(variant)
      {
        // LDclient.waitForInitialization().then(() => {
        //   let variation;
        //   let tags = window.dataLayerData.product.tags;        
        //   let ESTTime = new Date(new Date().toLocaleString('en-US', {timeZone: 'America/New_York'}));
        //   let PSTTime = new Date(new Date().toLocaleString('en-US', {timeZone: 'America/Los_Angeles'}));
            
        //   const promoVariation = LDclient.variationDetail('pdp-promo-badge');
        //   if (promoVariation.value === 'PDP Promo Badge Control') {
        //     variation = 1;
        //   } else if (promoVariation.value === 'PDP Promo Badge Variant B') {
        //     variation = 2;
        //   } else if (promoVariation.value === 'PDP Promo Badge Variant C') {
        //     variation = 3;
        //   }
          
        //   for(let v=0;v<tags.length;v++)
        //   {
        //     if (tags[v].indexOf("promo_") > -1)
        //     {          
        //       let promo = tags[v].split("_");
        //       let code = promo[4];
        //       let startD = new Date(promo[2]);
        //       let endD = new Date(promo[3]);
        //       if (ESTTime >= startD && PSTTime < endD) 
        //       {              
        //         if (promo[promo.length - 1] === 'private') 
        //         {
        //            if (typeof customerID !== 'undefined') {
        //              code = promo[1]              
        //            } else {
        //              code = '<div style="margin-top: 4px;"><svg style="margin-right: 4px" width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M2.36357 12H9.6363C9.93753 12 10.1818 11.7558 10.1818 11.4545V5.27273C10.1818 4.97149 9.93753 4.72727 9.6363 4.72727H9.09084V3.09091C9.09084 1.38658 7.70426 0 5.99993 0C4.29561 0 2.90902 1.38658 2.90902 3.09091V4.72727H2.36357C2.06233 4.72727 1.81812 4.97149 1.81812 5.27273V11.4545C1.81812 11.7558 2.06233 12 2.36357 12ZM6.54539 8.54494V9.27273C6.54539 9.57396 6.30117 9.81818 5.99993 9.81818C5.6987 9.81818 5.45448 9.57396 5.45448 9.27273V8.54494C5.23382 8.37895 5.09084 8.11498 5.09084 7.81818C5.09084 7.31691 5.49866 6.90909 5.99993 6.90909C6.50121 6.90909 6.90902 7.31691 6.90902 7.81818C6.90902 8.11498 6.76604 8.37895 6.54539 8.54494ZM3.99993 3.09091C3.99993 1.98811 4.89713 1.09091 5.99993 1.09091C7.10273 1.09091 7.99993 1.98811 7.99993 3.09091V4.72727H3.99993V3.09091Z" fill="#9F005B"/></svg>Sign in for extra savings</div>'
        //            }
        //         } 
        //         else 
        //         {                    
        //           if (promo[1].indexOf("%") > -1 && promo[1].toLowerCase().indexOf("code") > -1 && promo[1].indexOf("+") == -1)
        //            {                   
        //              let firstSplit = promo[1].split('%');
        //              let secondSplit = firstSplit[0].split(' ');
        //              let d = parseInt(secondSplit.slice(-1));
        //              if (Number.isInteger(d))
        //              {
        //                let discper = d/100;
        //                let discamount = Math.floor((variant.price * discper) * 100)/100;
        //                let p = (variant.price - discamount)/100;
        //                let indexPos = promo[1].indexOf("Off") + 4;
        //                let ss = ` (only $${p.toFixed(2).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')}) `;
        //                let f = promo[1];

        //                console.log(variation)

        //                if (variation === 1) {
        //                  code = f;
        //                }
  
        //                if (variation === 2) {
        //                  code = `Only $${p.toFixed(2).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')} ` + f.substr(indexPos);
        //                }
  
        //                if (variation === 3) {
        //                  code = f.substr(0, indexPos) + ss + f.substr(indexPos); 
        //                }
        //              }
        //              else
        //              {
        //                code = promo[1];
        //              }
        //            }
        //           else
        //           {
        //             code = promo[1];
        //           }
        //         }
        //         //$("#pdp-promo").remove();
        //         $("#promoplaceholder").html(`<div class="pdp-promo" id="pdp-promo" style="padding:10px 0px">${code}</div>`);
        //         break;
        //       }
        //     }
        //   }
        // }).catch(err => {});
         
      },
      _updateImages: function(variant) {
        var variantImage = variant.featured_image || {};
        var currentVariantImage = this.currentVariant.featured_image || {};

        if (!variant.featured_image || variantImage.src === currentVariantImage.src) {
          return;
        }
        else {
          //variant.featured_image = this.currentImage;
        }
        this.$container.trigger({
          type: 'variantImageChange',
          variant: variant
        });
      },

      _updatePrice: function(variant) {
        setTimeout(function() {
          if (variant.compare_at_price - variant.price > 1500) {
            $('.pdp-savings-calculation').each(function() {
              $(this).text(`You're saving ${window.theme.Currency.formatMoney(variant.compare_at_price - variant.price, window.theme.settings.moneyFormat)}`);
            })
          };
        }, 100)
        
        if (variant.price === this.currentVariant.price && variant.compare_at_price === this.currentVariant.compare_at_price) {
          return;
        }

        this.$container.trigger({
          type: 'variantPriceChange',
          variant: variant
        });
      },

      _updateUnitPrice: function(variant) {
        if (variant.unit_price === this.currentVariant.unit_price) {
          return;
        }

        this.$container.trigger({
          type: 'variantUnitPriceChange',
          variant: variant
        });
      },

      _updateSKU: function(variant) {
        if (variant.sku === this.currentVariant.sku) {
          return;
        }

        this.$container.trigger({
          type: 'variantSKUChange',
          variant: variant
        });
      },

      _updateHistoryState: function(variant) {
        if (!history.replaceState || !variant) {
          return;
        }

        //var newurl = window.location.protocol + '//' + window.location.host + window.location.pathname + '?variant=' + variant.id;
        //window.history.replaceState({path: newurl}, '', newurl);
      },

      _updateMasterSelect: function(variant) {
        $(this.originalSelectorId,this.$container).val(variant.id);
      },

      // _.compact from lodash
      // https://github.com/lodash/lodash/blob/4d4e452ade1e78c7eb890968d851f837be37e429/compact.js
      _compact: function(array) {
        var index = -1,
          length = array == null ? 0 : array.length,
          resIndex = 0,
          result = [];

        while (++index < length) {
          var value = array[index];
          if (value) {
            result[resIndex++] = value;
          }
        }
        return result;
      }
    });

    return Variants;
  })();

  slate.rte = {
    init: function() {
      slate.rte.wrapTable();
      slate.rte.wrapVideo();
      slate.rte.imageLinks();
    },

    wrapTable: function() {
      $('.rte table').wrap('<div class="table-wrapper"></div>');
    },

    wrapVideo: function() {
      var $iframeVideo = $('.rte iframe[src*="youtube.com/embed"], .rte iframe[src*="player.vimeo"]');
      var $iframeReset = $iframeVideo.add('iframe#admin_bar_iframe');

      $iframeVideo.each(function() {
        // Add wrapper to make video responsive
        if (!$(this).parents('.video-wrapper').length) {
          $(this).wrap('<div class="video-wrapper"></div>');
        }
      });

      $iframeReset.each(function() {
        // Re-set the src attribute on each iframe after page load
        // for Chrome's "incorrect iFrame content on 'back'" bug.
        // https://code.google.com/p/chromium/issues/detail?id=395791
        // Need to specifically target video and admin bar
        this.src = this.src;
      });
    },

    // Remove CSS that adds animated underline under image links
    imageLinks: function() {
      $('.rte a img').parent().addClass('rte__image');
    }
  };


  theme.Modals = (function() {
    function Modal(id,name,options) {
      var defaults = {
        close: '.js-modal-close',
        open: '.js-modal-open-' + name,
        openClass: 'modal--is-active',
        closingClass: 'modal--is-closing',
        bodyOpenClass: 'modal-open',
        bodyOpenSolidClass: 'modal-open--solid',
        bodyClosingClass: 'modal-closing',
        closeOffContentClick: true
      };

      this.id = id;
      this.$modal = $('#' + id);

      if (!this.$modal.length) {
        return false;
      }

      this.nodes = {
        $parent: $('html').add('body'),
        $modalContent: this.$modal.find('.modal__inner')
      };

      this.config = Object.assign(defaults,options);
      this.modalIsOpen = false;
      this.$focusOnOpen = this.config.focusOnOpen ? $(this.config.focusOnOpen) : this.$modal;
      this.isSolid = this.config.solid;

      this.init();
    }

    Modal.prototype.init = function() {
      var $openBtn = $(this.config.open);

      // Add aria controls
      $openBtn.attr('aria-expanded','false');

      $(this.config.open).on('click',this.open.bind(this));
      this.$modal.find(this.config.close).on('click',this.close.bind(this));

      // Close modal if a drawer is opened
      $('body').on('drawerOpen',function() {
        this.close();
      }.bind(this));
    };

    Modal.prototype.open = function(evt) {
      // Keep track if modal was opened from a click, or called by another function
      var externalCall = false;

      // don't open an opened modal
      if (this.modalIsOpen) {
        return;
      }

      // Prevent following href if link is clicked
      if (evt) {
        evt.preventDefault();
      } else {
        externalCall = true;
      }

      // Without this, the modal opens, the click event bubbles up to $nodes.page
      // which closes the modal.
      if (evt && evt.stopPropagation) {
        evt.stopPropagation();
        // save the source of the click, we'll focus to this on close
        this.$activeSource = $(evt.currentTarget);
      }

      if (this.modalIsOpen && !externalCall) {
        this.close();
      }

      this.$modal
        .prepareTransition()
        .addClass(this.config.openClass);
      this.nodes.$parent.addClass(this.config.bodyOpenClass);

      if (this.isSolid) {
        this.nodes.$parent.addClass(this.config.bodyOpenSolidClass);
      }

      this.modalIsOpen = true;

      slate.a11y.trapFocus({
        $container: this.$modal,
        $elementToFocus: this.$focusOnOpen,
        namespace: 'modal_focus'
      });

      if (this.$activeSource && this.$activeSource.attr('aria-expanded')) {
        this.$activeSource.attr('aria-expanded','true');
      }

      $('body')
        .trigger('modalOpen')
        .trigger('modalOpen.' + this.id);

      this.bindEvents();
    };

    Modal.prototype.close = function() {
      // don't close a closed modal
      if (!this.modalIsOpen) {
        return;
      }

      // deselect any focused form elements
      $(document.activeElement).trigger('blur');

      this.$modal
        .prepareTransition()
        .removeClass(this.config.openClass)
        .addClass(this.config.closingClass);
      this.nodes.$parent.removeClass(this.config.bodyOpenClass);
      this.nodes.$parent.addClass(this.config.bodyClosingClass);
      var o = this;
      window.setTimeout(function() {
        o.nodes.$parent.removeClass(o.config.bodyClosingClass);
        o.$modal.removeClass(o.config.closingClass);
      },500); // modal close css transition

      if (this.isSolid) {
        this.nodes.$parent.removeClass(this.config.bodyOpenSolidClass);
      }

      this.modalIsOpen = false;

      slate.a11y.removeTrapFocus({
        $container: this.$modal,
        namespace: 'modal_focus'
      });

      if (this.$activeSource && this.$activeSource.attr('aria-expanded')) {
        this.$activeSource.attr('aria-expanded','false').focus();
      }

      $('body').trigger('modalClose.' + this.id);

      this.unbindEvents();
    };

    Modal.prototype.bindEvents = function() {
      // Pressing escape closes modal
      this.nodes.$parent.on('keyup.modal',function(evt) {
        if (evt.keyCode === 27) {
          this.close();
        }
      }.bind(this));

      if (this.config.closeOffContentClick) {
        // Clicking outside of the modal content also closes it
        this.$modal.on('click.modal',this.close.bind(this));

        // Exception to above: clicking anywhere on the modal content will NOT close it
        this.nodes.$modalContent.on('click.modal',function(evt) {
          evt.stopImmediatePropagation();
        });
      }
    };

    Modal.prototype.unbindEvents = function() {
      this.nodes.$parent.off('.modal');

      if (this.config.closeOffContentClick) {
        this.$modal.off('.modal');
        this.nodes.$modalContent.off('.modal');
      }
    };

    return Modal;
  })();

  theme.Drawers = (function() {
    function Drawer(id,name,ignoreScrollLock) {
      this.config = {
        id: id,
        close: '.js-drawer-close',
        open: '.js-drawer-open-' + name,
        openClass: 'js-drawer-open',
        closingClass: 'js-drawer-closing',
        activeDrawer: 'drawer--is-open',
        namespace: '.drawer-' + name
      };

      this.$nodes = {
        parent: $(document.documentElement).add('body'),
        page: $('#MainContent')
      };

      this.$drawer = $('#' + id);

      if (!this.$drawer.length) {
        return false;
      }

      this.isOpen = false;
      this.ignoreScrollLock = ignoreScrollLock;
      this.init();
    };

    Drawer.prototype = Object.assign({},Drawer.prototype,{
      init: function() {
        var $openBtn = $(this.config.open);

        // Add aria controls
        $openBtn.attr('aria-expanded','false');

        $openBtn.on('click',this.open.bind(this));
        this.$drawer.find(this.config.close).on('click',this.close.bind(this));

        // Close modal if a drawer is opened
        $('body').on('modalOpen',function() {
          this.close();
        }.bind(this));
      },

      open: function(evt) {
        if (evt) {
          evt.preventDefault();
        }

        if (this.isOpen) {
          return;
        }

        // Without this the drawer opens, the click event bubbles up to $nodes.page which closes the drawer.
        if (evt && evt.stopPropagation) {
          evt.stopPropagation();
          // save the source of the click, we'll focus to this on close
          this.$activeSource = $(evt.currentTarget);
        }

        this.$drawer.prepareTransition().addClass(this.config.activeDrawer);

        this.$nodes.parent.addClass(this.config.openClass);
        this.isOpen = true;

        slate.a11y.trapFocus({
          $container: this.$drawer,
          namespace: 'drawer_focus'
        });

        $('body')
          .trigger('drawerOpen')
          .trigger('drawerOpen.' + this.config.id);

        if (this.$activeSource && this.$activeSource.attr('aria-expanded')) {
          this.$activeSource.attr('aria-expanded','true');
        }

        this.bindEvents();
      },

      close: function() {
        if (!this.isOpen) {
          return;
        }

        // deselect any focused form elements
        $(document.activeElement).trigger('blur');

        this.$drawer.prepareTransition().removeClass(this.config.activeDrawer);

        this.$nodes.parent.removeClass(this.config.openClass);
        this.$nodes.parent.addClass(this.config.closingClass);
        var o = this;
        window.setTimeout(function() {
          o.$nodes.parent.removeClass(o.config.closingClass);
        },500);

        this.isOpen = false;

        slate.a11y.removeTrapFocus({
          $container: this.$drawer,
          namespace: 'drawer_focus'
        });

        if (this.$activeSource && this.$activeSource.attr('aria-expanded')) {
          this.$activeSource.attr('aria-expanded','false');
        }

        this.unbindEvents();
      },

      bindEvents: function() {
        if (!this.ignoreScrollLock) {
          slate.a11y.lockMobileScrolling(this.config.namespace,this.$nodes.page);
        }

        // Clicking out of drawer closes it.
        // Check to see if clicked on element in drawer
        // because of any drawer built witin #MainContent
        this.$nodes.page.on('click' + this.config.namespace,function(evt) {
          var $target = $(evt.target);
          var doNotClose = this.elementInsideDrawer($target);
          if (!doNotClose) {
            this.close();
            return false;
          }

        }.bind(this));

        // Pressing escape closes drawer
        this.$nodes.parent.on('keyup' + this.config.namespace,function(evt) {
          if (evt.keyCode === 27) {
            this.close();
          }
        }.bind(this));
      },

      unbindEvents: function() {
        if (!this.ignoreScrollLock) {
          slate.a11y.unlockMobileScrolling(this.config.namespace,this.$nodes.page);
        }
        this.$nodes.parent.off(this.config.namespace);
        this.$nodes.page.off(this.config.namespace);
      },

      // Check if clicked element is inside the drawer
      elementInsideDrawer: function($el) {
        return this.$drawer.find($el).length;
      }
    });

    return Drawer;
  })();

  theme.cart = {
    getCart: function() {
      return $.getJSON('/cart.js');
    },

    changeItem: function(key,qty) {
      return this._updateCart({
        type: 'POST',
        url: '/cart/change.js',
        data: 'quantity=' + qty + '&id=' + key,
        dataType: 'json'
      });
    },

    addItemFromForm: function(data) {
      
      return this._updateCart({
        type: 'POST',
        url: '/cart/add.js',
        data: data,
        dataType: 'json'
      });
    },

    _updateCart: function() {
      
      return $.ajax(params)
        .then(function(cart) {
          return cart;
        }.bind(this));
    },

    updateNote: function(note) {
      var params = {
        type: 'POST',
        url: '/cart/update.js',
        data: 'note=' + theme.cart.attributeToString(note),
        dataType: 'json',
        success: function(cart) { },
        error: function(XMLHttpRequest,textStatus) { }
      };

      $.ajax(params);
    },

    updateCurrency: function(code) {
      var params = {
        type: 'POST',
        url: '/cart/update.js',
        data: 'currency=' + code,
        dataType: 'json',
        success: function(cart) {
          location.reload(); // required for multi-currency feature to update
        },
        error: function(XMLHttpRequest,textStatus) { }
      };

      $.ajax(params);
    },

    attributeToString: function(attribute) {
      if ((typeof attribute) !== 'string') {
        attribute += '';
        if (attribute === 'undefined') {
          attribute = '';
        }
      }
      return $.trim(attribute);
    }
  };

  $(function() {
    // Add a loading indicator on the cart checkout button (/cart and drawer)
    $('body').on('click','.cart__checkout',function() {
      $(this).addClass('btn--loading');

      window.dataLayerData.cart.products.forEach((product) => {
        if (window.storePickupvendors.includes(product.vendor)) {
          setCookie("shopify_pay","false",-1);
          setCookie("shopify_pay_redirect","false",-1);
        }
      });
    });

    $('body').on('change','textarea[name="note"]',function() {
      var newNote = $(this).val();
      theme.cart.updateNote(newNote);
    });


    // Custom JS to prevent checkout without confirming terms and conditions
    $('body').on('click','.cart__checkout--ajax',function(evt) {
      if ($('#CartAgree').is(':checked')) {
      } else {
        alert(theme.strings.cartTermsConfirmation);
        $(this).removeClass('btn--loading');
        return false;
      }
    });

    $('body').on('click','.cart__checkout--page',function(evt) {
      if ($('#CartPageAgree').is(':checked')) {
      } else {
        alert(theme.strings.cartTermsConfirmation);
        $(this).removeClass('btn--loading');
        return false;
      }
    });
  });

  theme.QtySelector = (function() {
    var classes = {
      input: '.js-qty__num',
      plus: '.js-qty__adjust--plus',
      minus: '.js-qty__adjust--minus'
    };

    function QtySelector($el,options) {
      this.$wrapper = $el;
      this.$input = $el.find(classes.input);
      this.$plus = $el.find(classes.plus);
      this.$minus = $el.find(classes.minus);
      this.minValue = this.$input.attr('min') || 1;

      var defaults = {
        namespace: null,
        key: this.$input.data('id')
      };

      this.options = Object.assign(defaults,options);

      this.initEventListeners();
    };

    QtySelector.prototype = Object.assign({},QtySelector.prototype,{
      initEventListeners: function() {
        this.$plus.on('click',function() {
          if (this.$input.val() > 2)
            return;
          var qty = this.validateQty(this.$input.val());
          this.addQty(qty);
        }.bind(this));

        this.$minus.on('click',function() {
          var qty = this.validateQty(this.$input.val());
          this.subtractQty(qty);
        }.bind(this));

        this.$input.on('change',function() {
          var qty = this.validateQty(this.$input.val());
          this.changeQty(qty);
        }.bind(this));
      },

      addQty: function(number) {
        var qty = number + 1;
        this.changeQty(qty);
      },

      subtractQty: function(number) {
        var qty = number - 1;
        if (qty <= this.minValue) {
          qty = this.minValue;
        }
        this.changeQty(qty);
      },

      changeQty: function(qty) {
        this.$input.val(qty);
        $('body').trigger('qty' + this.options.namespace,[this.options.key,qty]);
      },

      validateQty: function(number) {
        if ((parseFloat(number) == parseInt(number)) && !isNaN(number)) {
          // We have a valid number!
        } else {
          // Not a number. Default to 1.
          number = 1;
        }
        return parseInt(number);
      }
    });

    return QtySelector;
  })();

  theme.CartDrawer = (function() {
    var config = {
      namespace: '.ajaxcart'
    };

    var selectors = {
      drawer: '#CartDrawer',
      container: '#CartContainer',
      template: '#CartTemplate',
      fixedFooter: '.drawer__footer--fixed',
      fixedInnerContent: '.drawer__inner--has-fixed-footer',
      cartBubble: '.cart-link__bubble'
    };

    function CartDrawer() {
      this.status = {
        loaded: false,
        loading: false
      };

      this.drawer = new theme.Drawers('CartDrawer','cart');

      // Prep handlebars template
      var source = $(selectors.template).html();
      this.template = Handlebars.compile(source);

      // Build cart on page load so it's ready in the drawer
      theme.cart.getCart().then(this.buildCart.bind(this));

      this.initEventListeners();
    };

    CartDrawer.prototype = Object.assign({},CartDrawer.prototype,{
      initEventListeners: function() {
        $('body').on('updateCart' + config.namespace,this.initQtySelectors.bind(this));
        $('body').on('updateCart' + config.namespace,this.sizeFooter.bind(this));
        $('body').on('updateCart' + config.namespace,this.updateCartNotification.bind(this));
        $('body').on('drawerOpen.CartDrawer',this.sizeFooter.bind(this));

        $(window).on('resize' + config.namespace,$.debounce(150,this.sizeFooter.bind(this)));

        $('body').on('added.ajaxProduct',function() {
          theme.cart.getCart().then(function(cart) {
            this.buildCart(cart,true);
          }.bind(this));
        }.bind(this));
      },

      buildCart: function(cart,openDrawer) {
        this.loading(true);
        this.emptyCart();


        if (cart.item_count === 0) {
          $(selectors.container).append('<p class="appear-animation appear-delay-3">' + theme.strings.cartEmpty + '</p>');
        } else {
          var items = [];
          var item = {};
          var data = {};
          var animation_row = 1;
          window.cartoverlimit = false;
          $.each(cart.items,function(index,product) {
            if (product.quantity > 2)
            {
              window.cartoverlimit = true;
              //$(".cart__checkout").remove();
            }
            var prodImg;
            if (product.image !== null) {
              prodImg = product.image.replace(/(\.[^.]*)$/,"_200x$1");
            } else {
              prodImg = '//cdn.shopify.com/s/assets/admin/no-image-medium-cc9732cb976dd349a0df1d39816fbcc7.gif';
            }
            if (product.properties !== null) {
              $.each(product.properties,function(key,value) {
                if (key.charAt(0) === '_' || !value) {
                  delete product.properties[key];
                }
                else {
                  if (key == "Return") {
                    product.properties[key] = product.properties[key];
                  }
                  else {
                    if (product.properties[key].length > 1)
                      product.properties[key] = product.properties[key];
                  }
                }
              });
            }

            // If we have line-item discount, add formattedAmount to discount object
            var amount = 0;
            if (product.line_level_discount_allocations.length !== 0) {
              for (var discount in product.line_level_discount_allocations) {
                amount = product.line_level_discount_allocations[discount].amount;

                product.line_level_discount_allocations[discount].formattedAmount = theme.Currency.formatMoney(amount,theme.settings.moneyFormat);
              }
            }

            animation_row += 2;
            var fSale = false;
            var pType = product.product_type.replace(/\//g,"-");
            var tURL = "/collections/" + pType + "/products/" + product.handle;
            //product.url_formatted = "/collections/" + pType + "/products/" + product.handle;
            item = {
              key: product.key,
              url: tURL,
              img: prodImg,
              animationRow: animation_row,
              name: product.product_title,
              variation: product.variant_title,
              properties: product.properties,
              itemQty: product.quantity,
              price: theme.Currency.formatMoney(product.price,theme.settings.moneyFormat),
              unitPrice: theme.Currency.formatMoney(product.unit_price,theme.settings.moneyFormat),
              unitBase: theme.Currency.getBaseUnit(product),
              discountedPrice: theme.Currency.formatMoney((product.price - (product.total_discount / product.quantity)),theme.settings.moneyFormat),
              discounts: product.line_level_discount_allocations,
              discountsApplied: product.line_level_discount_allocations.length === 0 ? false : true,
              vendor: product.vendor,
              finalSale: true,
              gift_card: product.gift_card,
              variantId: product.variant_id,
            };

            items.push(item);
          });

          animation_row += 2;

          // If we have cart discount, add a formattedAmount to the discount object
          var cartAmount = 0;
          if (cart.cart_level_discount_applications.length !== 0) {
            for (var cartDiscount in cart.cart_level_discount_applications) {
              cartAmount = cart.cart_level_discount_applications[cartDiscount].total_allocated_amount;

              cart.cart_level_discount_applications[cartDiscount].formattedAmount = theme.Currency.formatMoney(cartAmount,theme.settings.moneyFormat);
            }
          }

          data = {
            items: items,
            note: cart.note,
            lastAnimationRow: animation_row,
            cartDiscounts: cart.cart_level_discount_applications,
            cartDiscountsApplied: cart.cart_level_discount_applications.length === 0 ? false : true,
            totalPrice: theme.Currency.formatMoney(cart.total_price,theme.settings.moneyFormat)
          };

          $(selectors.container).append(this.template(data));
        }

        this.status.loaded = true;
        this.loading(false);

        if (theme.settings.currenciesEnabled) {
          theme.currencySwitcher.ajaxrefresh();
        }

        $('body').trigger('updateCart' + config.namespace,cart);

        if (window.Shopify && Shopify.StorefrontExpressButtons) {
          Shopify.StorefrontExpressButtons.initialize();

          // Resize footer after arbitrary delay for buttons to load
          setTimeout(function() {
            this.sizeFooter();
          }.bind(this),800);
        }
        if (window.cartoverlimit)
        {
          $(".cart__checkout").hide();
        }
        else
        {
          $(".cart__checkout").show();
        }
        // If specifically asked, open the cart drawer (only happens after product added from form)
        if (openDrawer === true) {
          if (location.href.indexOf("keelo") > -1) {
            this.drawer.open();
            window.upsellOpen(items[0].name);
          }
          else {
            this.drawer.open();

            window.nostojs(function(api) {
              api.loadRecommendations();
            });
          }
          if ((typeof window?.loyalty?.loadLoyaltyForBagDrawer) === 'function') {
            window?.loyalty?.loadLoyaltyForBagDrawer(cart);
          }
        }
      },

      initQtySelectors: function() {
        $(selectors.container).find('.js-qty__wrapper').each(function(index,el) {
          var selector = new theme.QtySelector($(el),{
            namespace: '.cart-drawer'
          });
        }.bind(this));

        $('body').on('qty.cart-drawer',this.updateItem.bind(this));
      },

      updateItem: function(evt,key,qty) {
        if (this.status.loading) {
          return;
        }

        this.loading(true);

        theme.cart.changeItem(key,qty)
          .then(function(cart) {
            this.updateSuccess(cart);
            if ((typeof window?.loyalty?.loadLoyaltyForBagDrawer) === 'function') {
              window?.loyalty?.loadLoyaltyForBagDrawer(cart);
            }
          }.bind(this))
          .catch(function(XMLHttpRequest) {
            this.updateError(XMLHttpRequest);
          }.bind(this))
          .always(function() {
            this.loading(false);
          }.bind(this));
      },

      loading: function(state) {
        this.status.loading = state;

        if (state) {
          $(selectors.container).addClass('is-loading');
        } else {
          $(selectors.container).removeClass('is-loading');
        }
      },

      emptyCart: function() {
        $(selectors.container).empty();
      },

      updateSuccess: function(cart) {
        this.buildCart(cart);

        window.nostojs(function(api) {
          api.loadRecommendations();
        });
      },

      updateError: function(XMLHttpRequest) {
        if (XMLHttpRequest.responseJSON && XMLHttpRequest.responseJSON.description) {
          console.warn(XMLHttpRequest.responseJSON.description);
        }
      },

      // Update elements after cart is updated
      sizeFooter: function() {
        // Stop if our drawer doesn't have a fixed footer
        if (!$(selectors.drawer).hasClass('drawer--has-fixed-footer')) {
          return;
        }

        // Elements are reprinted regularly so selectors are not cached
        var $cartFooter = $(selectors.drawer).find(selectors.fixedFooter).removeAttr('style');
        var $cartInner = $(selectors.drawer).find(selectors.fixedInnerContent).removeAttr('style');
        var cartFooterHeight = $cartFooter.outerHeight();

        if ($(window).width() < 769) {
          cartFooterHeight += 20
        }

        $cartInner.css('bottom',cartFooterHeight);
        $cartFooter.css('height',cartFooterHeight);
      },

      updateCartNotification: function(evt,cart) {
        if (cart.items.length > 0) {
          $(selectors.cartBubble).addClass('cart-link__bubble--visible');
        } else {
          $(selectors.cartBubble).removeClass('cart-link__bubble--visible');
        }
      }
    });

    return CartDrawer;
  })();

  theme.AjaxProduct = (function() {
    var status = {
      loading: false
    };

    function ProductForm($form) {
      this.$form = $form;
      this.$addToCart = this.$form.find('.add-to-cart');

      if (this.$form.length) {
        this.$form.on('submit',this.addItemFromForm.bind(this));
      }
    };
    ProductForm.prototype = Object.assign({},ProductForm.prototype,{
      addItemFromForm: function(evt,callback) {
        evt.preventDefault();
        var c = 0;

        $.ajaxSetup({ async: true });
        if (status.loading) {
          return;
        }

        // Loading indicator on add to cart button
        this.$addToCart.addClass('btn--loading');

        status.loading = true;

        var data = this.$form.serialize();

        let url = new URL("https://keelo.com?" + data);
        if (url.searchParams.has("id"))
        {
          let vid = url.searchParams.get("id");
          for(let l=0;l<variantPartnerSkuMap.length;l++)
          {
            if (variantPartnerSkuMap[l].variantId == vid)
            {
              data+=`&properties%5B_partnerSku=${variantPartnerSkuMap[l].partnerSku}`;
              break;
            }
          }
        } 

        theme.cart.addItemFromForm(data)
          .then(function(product) {
            this.sleep(200).then(() => {
              this.success(product);
              //getAddOns(product);
            });
            if (window.storePickupvendors.includes(product.vendor)) {
              setCookie("shopify_pay","false",-1);
              setCookie("shopify_pay_redirect","false",-1);
            }
          }.bind(this))
          .catch(function(XMLHttpRequest) {
            this.error(XMLHttpRequest);
          }.bind(this))
          .always(function() {
            status.loading = false;
            this.$addToCart.removeClass('btn--loading');
          }.bind(this));
      },
      sleep: function(time) {
        return new Promise((resolve) => setTimeout(resolve,time));
      },

      success: function(product) {
        ssp('track', 'addVariantToCart', {
          productId: product.product_id.toString(),
          quantity: 1,
          variantId: product.sku
        });
        closeItem();
       // closeLookModal();
        this.$form.find('.errors').remove();
        $('body').trigger('added.ajaxProduct');

        window.nostojs(function(api) {
          api.loadRecommendations({});
        });
      },

      error: function(XMLHttpRequest) {
        this.$form.find('.errors').remove();

        if (XMLHttpRequest.responseJSON && XMLHttpRequest.responseJSON.description) {
          console.warn(XMLHttpRequest.responseJSON.description);

          this.$form.prepend('<div class="errors text-center">' + XMLHttpRequest.responseJSON.description + '</div>');
        }
      }
    });

    return ProductForm;
  })();

  theme.collapsibles = (function() {

    var selectors = {
      trigger: '.collapsible-trigger',
      module: '.collapsible-content',
      moduleInner: '.collapsible-content__inner'
    };

    var classes = {
      hide: 'hide',
      open: 'is-open',
      autoHeight: 'collapsible--auto-height'
    };

    var namespace = '.collapsible';

    var isTransitioning = false;

    function init() {
      $(selectors.trigger).each(function() {
        var $el = $(this);
        var state = $el.hasClass(classes.open);
        $el.attr('aria-expanded',state);
      });

      // Event listeners (hack for modals)
      $('body, .modal__inner')
        .off(namespace)
        .on('click' + namespace,selectors.trigger,function() {

          if (isTransitioning) {
            return;
          }

          isTransitioning = true;
          var $el = $(this);
          var isOpen = $el.hasClass(classes.open);
          if (!isOpen && !$(this).parent().hasClass("mobile-nav__child-item")) {
            $(selectors.trigger).each(function() {
              var $el = $(this);
              var moduleId = $el.attr('aria-controls');
              var $module = $('#' + moduleId);
              $module.removeClass(classes.open).prepareTransition().css('height',0);
              $el.removeClass(classes.open);
            });
          }

          var moduleId = $el.attr('aria-controls');
          var $module = $('#' + moduleId);
          var height = $module.find(selectors.moduleInner).outerHeight();
          var isAutoHeight = $el.hasClass(classes.autoHeight);

          // If isAutoHeight, set the height to 0 just after setting the actual height
          // so the closing animation works nicely
          if (isOpen && isAutoHeight) {
            setTimeout(function() {
              height = 0;
              setTransitionHeight($module,height,isOpen,isAutoHeight);
            },0);
          }
          if (isOpen && !isAutoHeight) {
            height = 0;
          }

          $el.attr('aria-expanded',!isOpen).toggleClass(classes.open,!isOpen);

          setTransitionHeight($module,height,isOpen,isAutoHeight);
        });
    }

    function setTransitionHeight($module,height,isOpen,isAutoHeight) {
      $module
        .removeClass(classes.hide)
        .prepareTransition()
        .css('height',height)
        .toggleClass(classes.open,!isOpen);

      if (!isOpen && isAutoHeight) {
        var o = $module;
        window.setTimeout(function() {
          o.css('height','auto');
          isTransitioning = false;
        },350);
      } else {
        isTransitioning = false;
      }
    }

    return {
      init: init
    };
  })();

  theme.headerNav = (function() {

    var $parent = $(document.documentElement).add('body');
    var $page = $('#MainContent');
    var selectors = {
      wrapper: '.header-wrapper',
      siteHeader: '.site-header',
      searchBtn: '.site-header__search-input',
      closeSearch: '.close-search',
      searchContainer: '.site-header__search-input',
      logoContainer: '.site-header__logo',
      logo: '.site-header__logo img',
      navigation: '.site-navigation',
      navContainerWithLogo: '.header-item--logo',
      navItems: '.site-nav__item',
      navLinks: '.site-nav__link',
      navLinksWithDropdown: '.site-nav__link--has-dropdown',
      navDropdownLinks: '.site-nav__dropdown-link--second-level'
    };

    var classes = {
      hasDropdownClass: 'site-nav--has-dropdown',
      hasSubDropdownClass: 'site-nav__deep-dropdown-trigger',
      dropdownActive: 'is-focused',
      overlaidBodyClass: 'overlaid-header',
      stickyBodyClass: 'sticky-header'
    };

    var config = {
      namespace: '.siteNav',
      wrapperOverlayed: false,
      overlayedClass: 'is-light',
      stickyEnabledClass: 'header-wrapper--sticky',
      stickyEnabled: false,
      stickyActive: false,
      stickyClass: 'site-header--stuck',
      openTransitionClass: 'site-header--opening',
      lastScroll: 0
    };

    // Elements used in resize functions, defined in init
    var $window;
    var $navContainerWithLogo;
    var $logoContainer;
    var $nav;
    var $wrapper;
    var $siteHeader;

    function init() {
      $window = $(window);
      $navContainerWithLogo = $(selectors.navContainerWithLogo);
      $logoContainer = $(selectors.logoContainer);
      $nav = $(selectors.navigation);
      $wrapper = $(selectors.wrapper);
      $siteHeader = $(selectors.siteHeader);

      config.wrapperOverlayed = theme.settings.overlayHeader = $wrapper.hasClass(config.overlayedClass);
      config.stickyEnabled = $siteHeader.data('sticky');

      if (config.stickyEnabled) {
        theme.config.stickyHeader = true;
        stickyHeader();
      }

      if (config.wrapperOverlayed) {
        $('body').addClass(classes.overlaidBodyClass);
      }

      accessibleDropdowns();
      searchDrawer();
    }

    function unload() {
      $(window).off(config.namespace);
      $(selectors.searchBtn).off(config.namespace);
      $(selectors.closeSearch).off(config.namespace);
      $parent.off(config.namespace);
      $(selectors.navLinks).off(config.namespace);
      $(selectors.navDropdownLinks).off(config.namespace);
    }

    function searchDrawer() {
      $(selectors.searchBtn).on('click' + config.namespace,function(evt) {
        evt.preventDefault();
        openSearchDrawer();
      });

      $(selectors.closeSearch,).on('click' + config.namespace,function() {
        closeSearchDrawer();
      });
      $(".gray-overlay").click(function() {
        closeSearchDrawer();
      });
    }

    function openSearchDrawer() {
      $(selectors.searchContainer).addClass('is-active');
      //       $parent.addClass('js-drawer-open js-drawer-open--search');

      slate.a11y.trapFocus({
        $container: $(selectors.searchContainer),
        namespace: 'header_search',
        $elementToFocus: $(selectors.searchContainer).find('input')
      });
      recentSearchesLoad();
      $("#searchPopParent").show();
      //         $("#searchSuggestions").show();
      //         $("#searchinput").focus();
      // If sticky is enabled, scroll to top on mobile when close to it
      // so you don't get an invisible search box
      if (theme.config.bpSmall && config.stickyEnabled && config.lastScroll < 300) {
        window.scrollTo(0,0);
      }

      // Bind events
      slate.a11y.lockMobileScrolling(config.namespace);

      // Clicking out of container closes it
      $page.on('click' + config.namespace,function() {
        closeSearchDrawer();
        return false;
      });

      $parent.on('keyup' + config.namespace,function(evt) {
        if (evt.keyCode === 27) {
          closeSearchDrawer();
        }
      });
    }

    function closeSearchDrawer() {
      // deselect any focused form elements
      $(document.activeElement).trigger('blur');
      $("#searchSuggestionsUL").html("");
      $("#searchSuggestions").hide();
      $("#searchPopParent").hide();

      $(".gray-overlay").hide();
      $(".close-search").hide();
      $(".search-mag-icon").show();
      $parent.removeClass('js-drawer-open js-drawer-open--search').off(config.namespace);
      $(selectors.searchContainer).removeClass('is-active');
      $(".button-search").val("");
      $(".button-search").attr("placeholder","Search");


      slate.a11y.removeTrapFocus({
        $container: $(selectors.searchContainer),
        namespace: 'header_search'
      });

      slate.a11y.unlockMobileScrolling(config.namespace);
      $page.off('click' + config.namespace);
      $parent.off('keyup' + config.namespace);
    }

    function accessibleDropdowns() {
      var hasActiveDropdown = false;
      var hasActiveSubDropdown = false;
      var closeOnClickActive = false;


      $(selectors.navLinks).on('focusin mouseover' + config.namespace,function() {
        if (hasActiveDropdown) {
          closeSecondLevelDropdown();
        }

        if (hasActiveSubDropdown) {
          closeThirdLevelDropdown();
        }

        openFirstLevelDropdown($(this));
      });

      // Force remove focus on sitenav links because focus sometimes gets stuck
      $(selectors.navLinks).on('mouseleave' + config.namespace,function() {
        closeSecondLevelDropdown();
        closeThirdLevelDropdown();
      });

      // Open/hide sub level dropdowns
      $(selectors.navDropdownLinks).on('focusin' + config.namespace,function() {
        if (hasActiveSubDropdown) {
          closeThirdLevelDropdown();
        }

        openSecondLevelDropdown($(this),true);
      });

      // Private dropdown methods
      function openFirstLevelDropdown($el) {
        var $parentItem = $el.parent();
        if ($parentItem.hasClass(classes.hasDropdownClass)) {
          $parentItem.addClass(classes.dropdownActive);
          hasActiveDropdown = true;
        }

        if (!theme.config.isTouch) {
          if (!closeOnClickActive) {
            var eventType = theme.config.isTouch ? 'touchend' : 'click';
            closeOnClickActive = true;
            $('body').on(eventType + config.namespace,function() {
              closeDropdowns();
              $('body').off(config.namespace);
              closeOnClickActive = false;
            });
          }
        }
      }

      function openSecondLevelDropdown($el,skipCheck) {
        var $parentItem = $el.parent();
        if ($parentItem.hasClass(classes.hasSubDropdownClass) || skipCheck) {
          $parentItem.addClass(classes.dropdownActive);
          hasActiveSubDropdown = true;
        }
      }

      function closeDropdowns() {
        closeSecondLevelDropdown();
        closeThirdLevelDropdown();
      }

      function closeSecondLevelDropdown() {
        $(selectors.navItems).removeClass(classes.dropdownActive);
      }

      function closeThirdLevelDropdown() {
        $(selectors.navDropdownLinks).parent().removeClass(classes.dropdownActive);
      }
    }

    function stickyHeader() {
      config.lastScroll = 0;
      $parent.addClass(classes.stickyBodyClass);
      $siteHeader.wrap('<div class="site-header-sticky"></div>');

      stickyHeaderHeight();
      setTimeout(function() {
        stickyHeaderHeight();
      },200);
      $window.on('resize' + config.namespace,$.debounce(50,stickyHeaderHeight));
      $window.on('scroll' + config.namespace,$.throttle(15,stickyHeaderScroll));
    }

    function stickyHeaderHeight() {
      var height = $siteHeader.outerHeight(true);

      // Also update top position of sticky sidebar
      if ($('.grid__item--sidebar').length) {
        $('.grid__item--sidebar').css('top',height + 10);
      }
    }

    function stickyHeaderScroll() {
      var scroll = window.pageYOffset;
      var threshold = 150;
      if (config.lastScroll < scroll + 15) {
        config.lastScroll = scroll;
        return;
      }
      if (scroll > threshold) {
        if (config.stickyActive) {
          return;
        }

        config.stickyActive = true;

        $siteHeader.addClass(config.stickyClass);
        $(".filters-sidebar").addClass("searchStickyNav");
        if ($(".noResults").length == 0){
          $(".featuredCollection").addClass("searchStickyContent");
        }
        //         $(".titlecrumbwrap").addClass("mobileSearchFilterSticky");

        if (config.wrapperOverlayed) {
          $wrapper.removeClass(config.overlayedClass);
        }

        // Add open transition class after element is set to fixed
        // so CSS animation is applied correctly
        setTimeout(function() {
          $siteHeader.addClass(config.openTransitionClass);
        },100);
      } else {
        if (!config.stickyActive) {
          return;
        }

        config.stickyActive = false;

        $siteHeader.removeClass(config.openTransitionClass).removeClass(config.stickyClass);
        $(".filters-sidebar").removeClass("searchStickyNav");
        $(".featuredCollection").removeClass("searchStickyContent");
        //         $(".titlecrumbwrap").removeClass("mobileSearchFilterSticky");
        if (config.wrapperOverlayed) {
          $wrapper.addClass(config.overlayedClass);
        }
      }

      config.lastScroll = scroll;
    }

    // If the header setting to overlay the menu on the collection image
    // is enabled but the collection setting is disabled, we need to undo
    // the init of the sticky nav
    function disableOverlayHeader() {
      $(selectors.wrapper)
        .removeClass(config.stickyEnabledClass)
        .removeClass(config.overlayedClass);

      $('body').removeClass(classes.overlaidBodyClass);
      config.wrapperOverlayed = false;
    }

    return {
      init: init,
      disableOverlayHeader: disableOverlayHeader,
      unload: unload
    };
  })();

  theme.Slideshow = (function() {
    this.$slideshow = null;

    var classes = {
      next: 'is-next',
      init: 'is-init',
      animateOut: 'animate-out',
      wrapper: 'slideshow-wrapper',
      slideshow: 'slideshow',
      allSlides: 'slick-slide',
      currentSlide: 'slick-current',
      pauseButton: 'slideshow__pause',
      isPaused: 'is-paused'
    };

    function slideshow(el,args) {
      this.$slideshow = $(el);
      this.$wrapper = this.$slideshow.closest('.' + classes.wrapper);
      this.$pause = this.$wrapper.find('.' + classes.pauseButton);

      this.settings = {
        accessibility: true,
        arrows: args.arrows ? true : false,
        dots: args.dots ? true : false,
        fade: args.fade ? true : false,
        speed: args.speed ? args.speed : 500,
        draggable: true,
        touchThreshold: 5,
        pauseOnHover: false,
        autoplay: args.autoplay ? true : false,
        autoplaySpeed: this.$slideshow.data('speed')
      };

      this.$slideshow.off('beforeChange');
      this.$slideshow.off('afterSlideChange');
      this.$slideshow.on('init',this.init.bind(this));
      this.$slideshow.on('beforeChange',this.beforeSlideChange.bind(this));
      this.$slideshow.on('afterChange',this.afterSlideChange.bind(this));

      this.$slideshow.slick(this.settings);

      this.$pause.on('click',this._togglePause.bind(this));
    }

    slideshow.prototype = Object.assign({},slideshow.prototype,{
      init: function(event,obj) {
        this.$slideshowList = obj.$list;
        this.$slickDots = obj.$dots;
        this.$allSlides = obj.$slides;
        this.slideCount = obj.slideCount;

        this.$slideshow.addClass(classes.init);
        this._a11y();
        this._clonedLazyloading();
      },
      beforeSlideChange: function(event,slick,currentSlide,nextSlide) {
        var $slider = slick.$slider;
        var $currentSlide = $slider.find('.' + classes.currentSlide).addClass(classes.animateOut);
      },
      afterSlideChange: function(event,slick,currentSlide) {
        var $slider = slick.$slider;
        var $allSlides = $slider.find('.' + classes.allSlides).removeClass(classes.animateOut);
      },
      destroy: function() {
        this.$slideshow.slick('unslick');
      },

      // Playback
      _play: function() {
        this.$slideshow.slick('slickPause');
        $(classes.pauseButton).addClass('is-paused');
      },
      _pause: function() {
        this.$slideshow.slick('slickPlay');
        $(classes.pauseButton).removeClass('is-paused');
      },
      _togglePause: function() {
        var slideshowSelector = this._getSlideshowId(this.$pause);
        if (this.$pause.hasClass(classes.isPaused)) {
          this.$pause.removeClass(classes.isPaused);
          $(slideshowSelector).slick('slickPlay');
        } else {
          this.$pause.addClass(classes.isPaused);
          $(slideshowSelector).slick('slickPause');
        }
      },

      // Helpers
      _getSlideshowId: function($el) {
        return '#Slideshow-' + $el.data('id');
      },
      _activeSlide: function() {
        return this.$slideshow.find('.slick-active');
      },
      _currentSlide: function() {
        return this.$slideshow.find('.slick-current');
      },
      _nextSlide: function(index) {
        return this.$slideshow.find('.slideshow__slide[data-slick-index="' + index + '"]');
      },

      // a11y fixes
      _a11y: function() {
        var $list = this.$slideshowList;
        var autoplay = this.settings.autoplay;

        if (!$list) {
          return;
        }

        // Remove default Slick aria-live attr until slider is focused
        $list.removeAttr('aria-live');

        // When an element in the slider is focused
        // pause slideshow and set aria-live
        $(classes.wrapper).on('focusin',function(evt) {
          if (!$(classes.wrapper).has(evt.target).length) {
            return;
          }

          $list.attr('aria-live','polite');
          if (autoplay) {
            this._pause();
          }
        }.bind(this));

        // Resume autoplay
        $(classes.wrapper).on('focusout',function(evt) {
          if (!$(classes.wrapper).has(evt.target).length) {
            return;
          }

          $list.removeAttr('aria-live');
          if (autoplay) {
            this._play();
          }
        }.bind(this));
      },

      // Make sure lazyloading works on cloned slides
      _clonedLazyloading: function() {
        var $slideshow = this.$slideshow;

        $slideshow.find('.slick-slide').each(function(index,el) {
          var $slide = $(el);
          if ($slide.hasClass('slick-cloned')) {
            var slideId = $slide.data('id');
            var $slideImg = $slide.find('.hero__image').removeClass('lazyloading').addClass('lazyloaded');

            // Get inline style attribute from non-cloned slide with arbitrary timeout
            // so the image is loaded
            setTimeout(function() {
              var loadedImageStyle = $slideshow.find('.slideshow__slide--' + slideId + ':not(.slick-cloned) .hero__image').attr('style');

              if (loadedImageStyle) {
                $slideImg.attr('style',loadedImageStyle);
              }

            },this.settings.autoplaySpeed / 1.5);

          }
        }.bind(this));
      }
    });

    return slideshow;
  })();
  if (!theme.announcementBar) {
    theme.announcementBar = (function() {
      var slideCount = 0;
      var compact = false;
      var defaults = {
        accessibility: true,
        arrows: false,
        dots: false,
        autoplay: true,
        autoplaySpeed: 5000,
        touchThreshold: 20,
        slidesToShow: 1
      };
      var $slider;

      function init() {
        $slider = $('#AnnouncementSlider');
        if (!$slider.length) {
          return;
        }

        slideCount = $slider.data('block-count');
        compact = $slider.data('compact-style');

        var desktopOptions = Object.assign({},defaults,{
          slidesToShow: compact ? 1 : slideCount,
          slidesToScroll: 1
        });

        var mobileOptions = Object.assign({},defaults,{
          slidesToShow: 1
        });

        if (theme.config.bpSmall) {
          initSlider($slider,mobileOptions);
        } else {
          initSlider($slider,desktopOptions);
        }

        $('body').on('matchSmall',function() {
          initSlider($slider,mobileOptions);
        }.bind(this));

        $('body').on('matchLarge',function() {
          initSlider($slider,desktopOptions);
        }.bind(this));
      }

      function initSlider($slider,args) {
        if (isInitialized($slider)) {
          $slider.slick('unslick');
        }
        $slider.slick(args);
      }

      function isInitialized($slider) {
        return $slider.length && $slider.hasClass('slick-initialized');
      }

      // Go to slide if selected in the editor
      function onBlockSelect(id) {
        var $slide = $('#AnnouncementSlide-' + id);
        if ($slider.length) {
          $slider.slick('slickPause');
        }
        if ($slide.length) {
          $slider.slick('slickGoTo',$slide.data('index'));
        }
      }

      function onBlockDeselect(id) {
        if ($slider.length && isInitialized($slider)) {
          $slider.slick('slickPlay');
        }
      }

      function unload() {
        if (isInitialized($slider)) {
          $slider.slick('unslick');
        }
      }

      return {
        init: init,
        onBlockSelect: onBlockSelect,
        onBlockDeselect: onBlockDeselect,
        unload: unload
      };
    })();
  }

  theme.currencySwitcher = (function() {

    var selectors = {
      dataDiv: '#CurrencyData',
      currencyOptions: '.currency-options__btn',
      pickerFlag: '.currency-picker .currency-flag',
      pickerLabel: '.currency-picker .currency-picker__label'
    };

    var data = {};
    var modal;

    function init() {
      var $dataDiv = $(selectors.dataDiv);

      if (!$dataDiv.length) {
        return;
      }

      modal = new theme.Modals('CurrencyModal','currency-modal',{
        closeOffContentClick: false
      });

      $(selectors.currencyOptions).on('click',setNewCurrency);

      data = {
        currency: $dataDiv.data('shop-currency'),
        format: $dataDiv.data('format'),
        moneyFormat: $dataDiv.data('money-format'),
        moneyCurrencyFormat: $dataDiv.data('money-currency-format')
      };

      if (!theme.settings.nativeMultiCurrency) {
        Currency.format = data.format;

        // Rely on the shop's currency format, not Shopify defaults (in case merchant changes it)
        Currency.money_format[data.currency] = data.moneyFormat;
        Currency.money_with_currency_format[data.currency] = data.moneyCurrencyFormat;

        // Fix for customer account page
        $('span.money span.money').each(function() {
          $(this).parents('span.money').removeClass('money');
        });

        // Save current price
        $('span.money').each(function() {
          $(this).attr('data-currency-' + data.currency,$(this).html());
        });

        checkCookie();
      }
    }

    function setNewCurrency() {
      var newCurrency = $(this).data('value');

      if (theme.settings.nativeMultiCurrency) {
        $(this).addClass('is-active');
        theme.cart.updateCurrency(newCurrency);
        return;
      }

      if (newCurrency !== data.currency) {
        data.currency = newCurrency;
        $(selectors.dataDiv).data('current-currency',newCurrency);
        updatePicker(newCurrency);

        refresh();
      }

      modal.close();
    }

    function updatePicker(currency) {
      $(selectors.pickerFlag).attr('data-flag',currency);
      $(selectors.pickerLabel).text(currency);

      // Update modal options active states
      $(selectors.currencyOptions).removeClass('is-active');
      $(selectors.currencyOptions + '[data-value=' + currency + ']').addClass('is-active');
    }

    // Refresh functions only needed when not using native multi-currency
    function refresh() {
      if (theme.settings.nativeMultiCurrency) {
        return;
      }

      var newCurrency = $(selectors.dataDiv).data('current-currency');
      Currency.convertAll(Currency.currentCurrency,newCurrency);
    }

    function ajaxrefresh() {
      if (theme.settings.nativeMultiCurrency) {
        return;
      }

      var shopCurrency = $(selectors.dataDiv).data('shop-currency');
      var newCurrency = $(selectors.dataDiv).data('current-currency');

      // Ajax cart always returns shop's currency, not what theme settings defines
      Currency.convertAll(shopCurrency,newCurrency);
    }

    function checkCookie() {
      var cookieCurrency = Currency.cookie.read();

      if (cookieCurrency == null) {
        Currency.currentCurrency = cookieCurrency = data.currency;
      } else if ($(selectors.currencyOptions).length && $(selectors.currencyOptions + '[data-value=' + cookieCurrency + ']').length === 0) {
        // If the cookie value does not correspond to any value in the currency dropdown
        Currency.currentCurrency = data.currency;
        Currency.cookie.write(data.currency);
      } else if (cookieCurrency === data.currency) {
        Currency.currentCurrency = data.currency;
      } else {
        Currency.convertAll(data.currency,cookieCurrency);
      }

      // Update current currency with cookie value
      $(selectors.dataDiv).data('current-currency',cookieCurrency);
      data.currency = cookieCurrency;
      updatePicker(cookieCurrency);
    }

    return {
      init: init,
      refresh: refresh,
      ajaxrefresh: ajaxrefresh
    };
  })();

  theme.initQuickShop = function(reinit) {
    var ids = [];
    var $buttons = $('.quick-product__btn');

    $buttons.each(function() {
      var id = $(this).data('product-id');
      var modalId = 'QuickShopModal-' + id;
      var name = 'quick-modal-' + id;

      // If another identical modal exists, remove duplicates
      if (ids.indexOf(id) > -1) {
        $('.modal--quick-shop[data-product-id="' + id + '"]').each(function(i) {
          if (i > 0) {
            $(this).remove();
          }
        });
        return;
      }

      new theme.Modals(modalId,name);
      ids.push(id);
    });
  };

  theme.videoModal = function() {
    var videoModalPlayer = null;
    var videoOptions = {
      width: 1280,
      height: 720,
      playerVars: {
        autohide: 0,
        autoplay: 1,
        branding: 0,
        cc_load_policy: 0,
        fs: 0,
        iv_load_policy: 3,
        modestbranding: 1,
        playsinline: 1,
        quality: 'hd720',
        rel: 0,
        showinfo: 0,
        wmode: 'opaque'
      }
    };

    var selectors = {
      triggers: 'a[href*="youtube.com/watch"], a[href*="youtu.be/"]'
    };

    if (!$(selectors.triggers).length) {
      return;
    }

    var modal = new theme.Modals('VideoModal','video-modal',{
      closeOffContentClick: true,
      solid: true
    });

    $(selectors.triggers).on('click',triggerYouTubeModal);

    function triggerYouTubeModal(evt) {
      evt.preventDefault();
      window.loadYouTube();

      if (theme.config.youTubeReady) {
        startVideoOnClick(evt);
      } else {
        $('body').on('youTubeReady',function() {
          startVideoOnClick(evt);
        });
      }
    }

    function startVideoOnClick(evt) {
      var $el = $(evt.currentTarget);
      var videoId = getYoutubeVideoId($el.attr('href'));

      var args = Object.assign({},videoOptions,{
        videoId: videoId
      });

      // Disable plays inline on mobile
      args.playerVars.playsinline = theme.config.bpSmall ? 0 : 1;

      var videoModalPlayer = new YT.Player('VideoHolder',args);
      modal.open();

      $('body').on('modalClose.VideoModal',function() {
        // Slight timeout so it is destroyed after the modal closes
        setTimeout(function() {
          videoModalPlayer.destroy();
        },500); // modal close css transition
      });
    }

    function getYoutubeVideoId(url) {
      var regExp = /^.*((youtu.be\/)|(v\/)|(\/u\/\w\/)|(embed\/)|(watch\?))\??v?=?([^#\&\?]*).*/;
      var match = url.match(regExp);
      return (match && match[7].length == 11) ? match[7] : false;
    }
  };


  theme.RecentlyViewed = (function() {
    var selectors = {
      template: '#RecentlyViewedProduct',
      outputContainer: '#RecentlyViewed-'
    };

    var init = false;

    function RecentlyViewed(container) {
      var $container = this.$container = $(container);
      var sectionId = this.sectionId = $container.attr('data-section-id');
      this.namespace = '.recently-viewed' + sectionId;

      if (!$(selectors.template).length) {
        return;
      }

      // Lazyload API
      this.checkVisibility();
      $(window).on('scroll' + this.namespace,$.throttle(200,this.checkVisibility.bind(this)));
    };
    //keelo
    RecentlyViewed.prototype = Object.assign({},RecentlyViewed.prototype,{
      init: function() {
        if (init) {
          return;
        }

        init = true;

        if ($.isEmptyObject(theme.recentlyViewed.recent)) {
          // No previous history on page load, so bail
          return;
        }

        this.outputContainer = $(selectors.outputContainer + this.sectionId);
        this.handle = this.$container.attr('data-product-handle');

        // Request new product info via JS API
        var promises = [];
        for (handle in theme.recentlyViewed.recent) {
          let p = this.getProductInfo(handle);
          if (p == undefined)
            continue;
          //console.log(p);
          promises.push(p);
        }

        Promise.all(promises).then(function(result) {
          this.setupOutput(result);
          this.captureProductDetails(result);
        }.bind(this),function(error) {
          console.log('Theme | recently viewed products failed to load');
          console.log(error);
        });
      },

      checkVisibility: function() {
        if (theme.isElementVisible(this.$container,200)) {
          this.init();
          $(window).off('scroll' + this.namespace);
        }
      },

      getProductInfo: function(handle) {
        return new Promise(function(resolve,reject) {
          if (theme.recentlyViewed.productInfo.hasOwnProperty(handle)) {
            try {
              resolve(theme.recentlyViewed.productInfo[handle]);
            } catch (error) { }
          } else {
            try {
              jQuery.getJSON('/products/' + handle + '.js',function(product) {
                resolve(product);
              });
            } catch (error) { }
          }
        });
      },

      setupOutput: function(products) {
        var allProducts = [];
        var data = {};
        var limit = this.$container.attr('data-recent-count');

        var i = 0;
        for (key in products) {

          var product = products[key];
          if (product == undefined || !product.available) {
            continue;
          }
          //console.log(product.handle);
          // Ignore current product
          if (product.handle === this.handle) {
            continue;
          }
          //console.log(product.handle);
          i++;

          var pType = product.type.replace(/\//g,"-");
          // New or formatted properties
          //product.url_formatted = theme.recentlyViewed.recent[product.handle] ? theme.recentlyViewed.recent[product.handle].url : product.url;
          product.url_formatted = "/collections/" + pType + "/products/" + product.handle + "?id=" + product.id;;
          product.image_responsive_url = theme.recentlyViewed.recent[product.handle].featuredImage;
          product.image_aspect_ratio = theme.recentlyViewed.recent[product.handle].aspectRatio;
          product.on_sale = product.compare_at_price > product.price;
          product.sold_out = !product.available;
          product.price_formatted = theme.Currency.formatMoney(product.price,theme.settings.moneyFormat);
          product.compare_at_price_formatted = theme.Currency.formatMoney(product.compare_at_price,theme.settings.moneyFormat);
          product.price_min_formatted = theme.Currency.formatMoney(product.price_min,theme.settings.moneyFormat);
          product.money_saved = theme.Currency.formatMoney((product.compare_at_price - product.price),theme.settings.moneyFormat);
          product.percentageSaved = Math.round(((product.compare_at_price - product.price) * 100) / product.compare_at_price);
          allProducts.unshift(product);
        }

        data = {
          items: allProducts.slice(0,limit),
          grid_item_width: this.$container.attr('data-grid-item-class')
        };

        if (allProducts.length === 0) {
          return;
        }

        // Prep handlebars template
        var source = $(selectors.template).html();
        var template = Handlebars.compile(source);
        this.outputContainer.append(template(data));

        if (AOS) {
          AOS.refreshHard();
        }
      },

      captureProductDetails: function(products) {
        for (var i = 0; i < products.length; i++) {
          var product = products[i];
          if (product == undefined) {
            continue;
          }
          theme.recentlyViewed.productInfo[product.handle] = product;
        }

        // Add data to session storage to reduce API requests later
        if (theme.config.hasSessionStorage) {
          sessionStorage.setItem('recent-products',JSON.stringify(theme.recentlyViewed.productInfo));
        }
      },

      onUnload: function() {
        init = false;
        $('window').off(this.namespace);
      }
    });

    return RecentlyViewed;
  })();

  theme.parallaxSections = {};

  theme.Parallax = (function() {
    var speed = 7; // higher is slower

    function parallax(el,args) {
      this.$container = $(el);
      this.namespace = args.namespace;

      if (!this.$container.length) {
        return;
      }

      if (args.desktopOnly) {
        this.desktopInit();
      } else {
        this.init(this.$container,args);
      }
    }

    parallax.prototype = Object.assign({},parallax.prototype,{
      init: function(desktopOnly) {
        var $window = this.$window = $(window);
        var elTop = this.$container.offset().top;

        $window.on('scroll' + this.namespace,function(evt) {
          var scrolled = $window.scrollTop();
          var shiftDistance = (elTop - scrolled) / speed;
          this.$container.css({
            'transform': 'translate3d(0, ' + shiftDistance + 'px, 0)'
          });
        }.bind(this));

        // Reinit on resize
        $window.on('resize' + this.namespace,$.debounce(350,function() {
          $window.off(this.namespace);

          if (desktopOnly) {
            if (!theme.config.bpSmall) {
              this.init(true);
              return;
            }
          }

          this.init();
        }.bind(this)));
      },

      desktopInit: function() {
        if (!theme.config.bpSmall) {
          this.init(true);
        }

        $('body').on('matchSmall',function() {
          this.destroy();
        }.bind(this));

        $('body').on('matchLarge',function() {
          this.init(true);
        }.bind(this));
      },

      destroy: function() {
        this.$container.removeAttr('style');
        this.$window.off(this.namespace);
      }
    });

    return parallax;
  })();


  theme.collectionTemplate = (function() {
    var isAnimating = false;

    var selectors = {
      collectionGrid: '.collection-grid__wrapper',
      sidebar: '#CollectionSidebar',
      activeTagList: '.tag-list--active-tags',
      tags: '.tag-list a',
      filters: '.collection-filter'
    };

    var settings = {
      combineTags: $(selectors.sidebar).data('combine-tags')
    };

    var classes = {
      activeTag: 'tag--active',
      removeTagParent: 'tag--remove'
    };

    function init() {
      // Ajax pagination
      $(window).on('popstate',function(state) {
        if (state) {
          getNewCollectionContent(location.href);
        }
      });

      // Set mobile top value for filters if sticky header enabled
      if (theme.config.stickyHeader) {
        setFilterStickyPosition();
        $(window).on('resize',$.debounce(150,setFilterStickyPosition));
      }

      initTagClicks();
    }

    function initTagClicks() {
      $('body').on('click',selectors.tags,function(evt) {
        var $el = $(this);
        if (theme.FilterDrawer) {
          theme.FilterDrawer.close();
        }

        if ($el.hasClass('no-ajax')) {
          return;
        }

        evt.preventDefault();
        if (isAnimating) {
          return;
        }

        isAnimating = true;

        var $el = $(evt.currentTarget);
        var $parent = $el.parent();
        var newUrl = $el.attr('href');

        if (settings.combineTags) {
          if ($parent.hasClass(classes.activeTag)) {
            $parent.removeClass(classes.activeTag);
          } else {
            $parent.addClass(classes.activeTag);

            // If adding a tag, show new tag right away.
            // Otherwise, remove it before ajax finishes
            if ($el.parent('li').hasClass(classes.removeTagParent)) {
              $(this).parent().remove();
            } else {
              $(selectors.activeTagList).append('<li class="tag tag--remove"><a class="btn btn--small js-no-transition">' + $el.text() + '</a></li>');
            }
          }
        } else {
          $(selectors.tags).parent().removeClass(classes.activeTag);
          $parent.addClass(classes.activeTag);
        }

        updateScroll(true);

        history.pushState({},'',newUrl);
        $(selectors.collectionGrid).addClass('unload');
        getNewCollectionContent(newUrl);
      });
    }

    function updateScroll(animate) {
      var scrollTo;
      if (theme.config.bpSmall) {
        // 60 is ~ height of sticky filters
        scrollTo = $('[data-scroll-to]').offset().top - 60;
      } else {
        scrollTo = $('#CollectionAjaxResult').offset().top + 1;
      }

      if (theme.config.stickyHeader) {
        var heightOfStickyNav = $('.site-header').outerHeight(true);
        scrollTo = scrollTo - heightOfStickyNav;
      }

      if (animate) {
        $('html, body').animate({ scrollTop: scrollTo },300);
      } else {
        $('html, body').scrollTop(scrollTo);
      }
    }

    function setFilterStickyPosition() {
      var headerHeight = $('.site-header').outerHeight(true);
      $(selectors.filters).css('top',headerHeight + 10);
    }

    function getNewCollectionContent(url) {
      //url = url + '?view=ajax';
      $('#CollectionAjaxResult').load(url + ' #CollectionAjaxContent',function() {
        isAnimating = false;
        theme.reinitSection('collection-template');
        theme.collectionTemplate.reinit();
      }.bind(this));

    }

    function reinit() {
      settings.combineTags = $(selectors.sidebar).data('combine-tags');

      updateScroll(false);

      // Setup page transition classes
      theme.pageTransitions();

      theme.reinitProductGridItem();

      // Trigger resize for sticky sidebar styles to update
      $('body').trigger('resize');
    }

    return {
      init: init,
      reinit: reinit
    };
  })();

  theme.customerTemplates = (function() {

    function initEventListeners() {
      // Show reset password form
      $('#RecoverPassword').on('click',function(evt) {
        evt.preventDefault();
        toggleRecoverPasswordForm();
      });

      // Hide reset password form
      $('#HideRecoverPasswordLink').on('click',function(evt) {
        evt.preventDefault();
        toggleRecoverPasswordForm();
      });
    }

    /**
     *
     *  Show/Hide recover password form
     *
     */
    function toggleRecoverPasswordForm() {
      $('#RecoverPasswordForm').toggleClass('hide');
      $('#CustomerLoginForm').toggleClass('hide');
    }

    /**
     *
     *  Show reset password success message
     *
     */
    function resetPasswordSuccess() {
      var $formState = $('.reset-password-success');

      // check if reset password form was successfully submitted
      if (!$formState.length) {
        return;
      }

      // show success message
      $('#ResetSuccess').removeClass('hide');
    }

    /**
     *
     *  Show/hide customer address forms
     *
     */
    function customerAddressForm() {
      var $newAddressForm = $('#AddressNewForm');
      var $addressForms = $('.js-address-form');
      var $addressList = $('.single-address-line');
      var $addressBtn = $('.add-address-button');
      var $addressTitle = $('.address-title');
      var $noAdd = $('.no-address');

      if (!$newAddressForm.length || !$addressForms.length) {
        return;
      }

      if (Shopify) {
        $('.js-address-country').each(function() {
          var $container = $(this);
          var countryId = $container.data('country-id');
          var provinceId = $container.data('province-id');
          var provinceContainerId = $container.data('province-container-id');

          new Shopify.CountryProvinceSelector(
            countryId,
            provinceId,
            {
              hideElement: provinceContainerId
            }
          );
        });
      }

      // Toggle new/edit address forms
      $('.address-new-toggle').on('click',function() {
        $newAddressForm.toggleClass('hide');
        $addressList.toggleClass('hide');
        $addressBtn.toggleClass('hide');
        $addressTitle.toggleClass('hide');
        $noAdd.toggleClass('hide');

      });

      $('.address-edit-toggle').on('click',function() {
        var formId = $(this).data('form-id');
        $('#EditAddress_' + formId).toggleClass('hide');
        $addressList.toggleClass('hide');
        $addressBtn.toggleClass('hide');
        $addressTitle.toggleClass('hide');
      });

      $('.address-delete').on('click',function() {
        var $el = $(this);
        var formId = $el.data('form-id');
        swal({
          title: "Are you sure you want to delete this address?",
          buttons: ["Cancel","YES, I'M SURE"],
          dangerMode: false,
        })
          .then((willDelete) => {
            if (willDelete) {
              Shopify.postLink('/account/addresses/' + formId,{ parameters: { _method: 'delete' } });
              swal("Address has been deleted.",{
                icon: "success",
              });
            }
          });
      });
    }



    /**
 *
 *  Show/hide REWARDS my history
 *
 */
    //     function rewardsHistory() {
    //       var $rewardsWrap = $('.rewards-page-wrap"');
    //       var $historyWrap = $('.history-wrap');
    //       var $historyBtn = $('.hist-btn');





    //       // Toggle new/edit address forms
    //       $('.hist-btn').on('click', function() {
    //         $rewardsWrap.toggleClass('hide');
    //         $historyWrap.toggleClass('show');
    //       });


    //     };



    /**
     *
     *  Check URL for reset password hash
     *
     */
    function checkUrlHash() {
      var hash = window.location.hash;

      // Allow deep linking to recover password form
      if (hash === '#recover') {
        toggleRecoverPasswordForm();
      }
    }

    return {
      init: function() {
        checkUrlHash();
        initEventListeners();
        resetPasswordSuccess();
        customerAddressForm();
        //         rewardsHistory();
      }
    };
  })();

  theme.Photoswipe = (function() {
    var selectors = {
      trigger: '.js-photoswipe__zoom',
      images: '.photoswipe__image',
      activeImage: '.slick-active .photoswipe__image'
    };

    function Photoswipe(container,sectionId) {
      this.$container = $(container);
      this.sectionId = sectionId;
      this.namespace = '.photoswipe-' + this.sectionId;
      this.gallery;
      this.$images;
      this.inSlideshow = false;

      if (this.$container.attr('data-zoom') === 'false') {
        return;
      }

      if (this.$container.attr('data-has-slideshow') === 'true') {
        this.inSlideshow = true;
      }

      this.init();
    }

    Photoswipe.prototype = Object.assign({},Photoswipe.prototype,{
      init: function() {
        //var $trigger = this.$container.find(selectors.trigger);
        //this.$images = this.$container.find(selectors.images);
        this.$images=$(".photoswipe__image");
        var items = [];

        // Init gallery on active image
        $(".product__photo-zoom").on('click',function(evt) {
          items = this.getImageData();
          if (this.inSlideshow) {
            var index = this.$container.find(selectors.activeImage).data('index');
          } else {
            var index = $(evt.currentTarget).data('index');
          }
          this.initGallery(items,index);
        }.bind(this));
      },

      getImageData: function() {
        var haveImages = false;
        var items = [];
        var options = {};

        this.$images.each(function() {
          var haveImages = true;
          var smallSrc = $(this).prop('currentSrc') || $(this).prop('src');
          var item = {
            msrc: smallSrc,
            src: $(this).data('photoswipe-src'),
            w: $(this).data('photoswipe-width'),
            h: $(this).data('photoswipe-height'),
            el: $(this)[0],
            initialZoomLevel: 0.5
          };

          items.push(item);
        });

        return items;
      },

      initGallery: function(items,index) {
        var pswpElement = document.querySelectorAll('.pswp')[0];

        var options = {
          allowPanToNext: false,
          captionEl: false,
          closeOnScroll: false,
          counterEl: false,
          history: false,
          index: index - 1,
          pinchToClose: false,
          preloaderEl: false,
          scaleMode: 'zoom',
          shareEl: false,
          tapToToggleControls: false,
          getThumbBoundsFn: function(index) {
            var pageYScroll = window.pageYOffset || document.documentElement.scrollTop;
            var thumbnail = items[index].el;
            var rect = thumbnail.getBoundingClientRect();
            return { x: rect.left,y: rect.top + pageYScroll,w: rect.width };
          }
        };

        this.gallery = new PhotoSwipe(pswpElement,PhotoSwipeUI_Default,items,options);

        this.gallery.init();
        this.gallery.listen('afterChange',this.afterChange.bind(this));
      },

      afterChange: function() {
        if (this.inSlideshow) {
          var $slideshow = $('#ProductPhotos-' + this.sectionId);
          if ($slideshow.hasClass('slick-initialized')) {
            var newIndex = this.gallery.getCurrentIndex();
            $slideshow.slick('slickGoTo',newIndex);
          }
        }
      }
    });

    return Photoswipe;
  })();

  theme.Product = (function() {

    var classes = {
      onSale: 'on-sale',
      disabled: 'disabled',
      isModal: 'is-modal',
      loading: 'loading',
      loaded: 'loaded',
      interactable: 'video-interactable',
      visuallyHide: 'visually-invisible'
    };

    var selectors = {
      productVideo: '.product__video',
      videoParent: '.product__video-wrapper',
      currentSlide: '.slick-current'
    };

    var youtubeReady;
    var videos = {};
    var youtubePlayers = [];
    var youtubeVideoOptions = {
      height: '480',
      width: '850',
      playerVars: {
        autohide: 0,
        autoplay: 1,
        branding: 0,
        cc_load_policy: 0,
        controls: 0,
        fs: 0,
        iv_load_policy: 3,
        modestbranding: 1,
        playsinline: 1,
        quality: 'hd720',
        rel: 0,
        showinfo: 0,
        wmode: 'opaque'
      },
      events: {
        onReady: onVideoPlayerReady,
        onStateChange: onVideoStateChange
      }
    };

    var vimeoReady;
    var vimeoPlayers = [];
    var vimeoVideoOptions = {
      byline: false,
      title: false,
      portrait: false,
      loop: true
    };

    function onVideoPlayerReady(evt) {
      var $player = $(evt.target.a);
      var playerId = $player.attr('id');
      youtubePlayers[playerId] = evt.target; // update stored player
      var player = youtubePlayers[playerId];

      setParentAsLoading($player);

      if (videos[playerId].style === 'muted') {
        youtubePlayers[playerId].mute().playVideo().pauseVideo();
      } else {
        setParentAsLoaded($player);
      }

      // If first slide or only photo, start video
      if ($player.closest(selectors.currentSlide).length || $player.data('image-count') === 1) {
        if (videos[playerId].style === 'muted') {
          youtubePlayers[playerId].playVideo();
          initCheckVisibility(playerId);
        }
      }
    }

    function initCheckVisibility(playerId) {
      // Add out of view pausing
      videoVisibilityCheck(playerId);
      $(window).on('scroll.' + playerId,{ id: playerId },$.throttle(150,videoVisibilityCheck));
    }

    function videoVisibilityCheck(id) {
      var playerId;

      if (typeof id === 'string') {
        playerId = id;
      } else {
        // Data comes in as part of the scroll event
        playerId = id.data.id;
      }

      if (theme.isElementVisible($('#' + playerId))) {
        if (videos[playerId] && videos[playerId].style === 'unmuted') {
          return;
        }
        playVisibleVideo(playerId);
      } else {
        pauseHiddenVideo(playerId);
      }
    }

    function playVisibleVideo(id) {
      if (youtubePlayers[id] && typeof youtubePlayers[id].playVideo === 'function') {
        youtubePlayers[id].playVideo();
      }
    }

    function pauseHiddenVideo(id) {
      if (youtubePlayers[id] && typeof youtubePlayers[id].pauseVideo === 'function') {
        youtubePlayers[id].pauseVideo();
      }
    }

    function onVideoStateChange(evt) {
      var $player = $(evt.target.a);
      var playerId = $player.attr('id');
      var player = youtubePlayers[playerId];

      switch (evt.data) {
        case -1: // unstarted
          // Handle low power state on iOS by checking if
          // video is reset to unplayed after attempting to buffer
          if (videos[playerId].attemptedToPlay) {
            setParentAsLoaded($player);
            setVideoToBeInteractedWith($player);
          }
          break;
        case 0: // ended
          player.playVideo();
          break;
        case 1: // playing
          setParentAsLoaded($player);
          break;
        case 3: // buffering
          videos[playerId].attemptedToPlay = true;
          break;
      }
    }

    function setParentAsLoading($el) {
      $el
        .closest(selectors.videoParent)
        .addClass(classes.loading);
    }

    function setParentAsLoaded($el) {
      $el
        .closest(selectors.videoParent)
        .removeClass(classes.loading)
        .addClass(classes.loaded);
    }

    function setVideoToBeInteractedWith($el) {
      $el
        .closest(selectors.videoParent)
        .addClass(classes.interactable);
    }

    function Product(container) {
      var $container = this.$container = $(container);
      var sectionId = this.sectionId = $container.attr('data-section-id');

      this.inModal = $container.closest('.modal').length;
      this.$modal;

      this.settings = {
        enableHistoryState: $container.data('enable-history-state') || false,
        namespace: '.product-' + sectionId,
        inventory: $container.data('inventory') || false,
        modalInit: false,
        lazyLoadModalContent: $container.data('lazyload-content') || false,
        slickMainInitialized: false,
        slickThumbInitialized: false,
        hasImages: true,
        hasMultipleImages: false,
        imageSize: '620x'
      };

      // Overwrite some settings when loaded in modal
      if (this.inModal) {
        this.settings.enableHistoryState = false;
        this.settings.namespace = '.product-' + sectionId + '-modal';
        this.$modal = $('#QuickShopModal-' + sectionId);
      }

      this.selectors = {
        variantsJson: 'VariantsJson-' + sectionId,
        currentVariantJson: 'CurrentVariantJson-' + sectionId,

        video: 'ProductVideo-' + sectionId,
        photoThumbs: '.product__thumb-' + sectionId,
        thumbSlider: '#ProductThumbs-' + sectionId,
        mainSlider: '#ProductPhotos-' + sectionId,
        imageContainer: '[data-product-images]',
        productImageMain: '.product-image-main--' + sectionId,

        priceWrapper: '.product__price-wrap-' + sectionId,
        price: '#ProductPrice-' + sectionId,
        comparePrice: '#ComparePrice-' + sectionId,
        savePrice: '#SavePrice-' + sectionId,
        priceA11y: '#PriceA11y-' + sectionId,
        comparePriceA11y: '#ComparePriceA11y-' + sectionId,
        unitWrapper: '.product__unit-price-wrapper--' + sectionId,
        unitPrice: '.product__unit-price--' + sectionId,
        unitPriceBaseUnit: '.product__unit-base--' + sectionId,
        sku: '#Sku-' + sectionId,
        inventory: '#ProductInventory-' + sectionId,

        stickyPrice: '#StickyProductPrice-' + sectionId,
        stickyComparePrice: '#StickyComparePrice-' + sectionId,
        stickySavePrice: '#StickySavePrice-' + sectionId,
        stickyPriceA11y: '#StickyPriceA11y-' + sectionId,
        stickyComparePriceA11y: '#StickyComparePriceA11y-' + sectionId,

        addToCart: '#AddToCart-pdp2',
        addToCartText: '#AddToCartText-' + sectionId,

        originalSelectorId: '#ProductSelect-' + sectionId,
        singleOptionSelector: '.variant__input-' + sectionId,
        variantColorSwatch: '.variant__input--color-swatch-' + sectionId,

        modalFormHolder: '#ProductFormHolder-' + sectionId,
        formContainer: '#AddToCartForm-' + sectionId
      };
      this.storeAvailabilityContainer = $("#store-container");
      //window.storePickupvendors is set in product file
      if (window.storePickupvendors && window.meta.product && window.storePickupvendors.includes(window.meta.product.vendor)) {
        this._initStoreAvailability();
      }

      this.$mainSlider = $(this.selectors.mainSlider);
      this.$thumbSlider = $(this.selectors.thumbSlider);
      this.$firstProductImage = this.$mainSlider.find('img').first();

      if (!this.$firstProductImage.length) {
        this.settings.hasImages = false;
      }

      this.init();
    }

    Product.prototype = Object.assign({},Product.prototype,{
      init: function() {
        if (this.inModal) {
          this.$container.addClass(classes.isModal);
          $('body')
            .off('modalOpen.QuickShopModal-' + this.sectionId)
            .off('modalClose.QuickShopModal-' + this.sectionId);
          $('body').on('modalOpen.QuickShopModal-' + this.sectionId,this.openModalProduct.bind(this));
          $('body').on('modalClose.QuickShopModal-' + this.sectionId,this.closeModalProduct.bind(this));
        }

        if (!this.inModal) {
          if (!window.allowTracking())
            return;
          this.stringOverrides();
          this.formSetup();
          this.productSetup();

          if (window.ShopSimonJustViewed && window.meta && window.meta.product && window.meta.product.id) {
            window.ShopSimonJustViewed.rememberProductId(window.meta.product.id);
          }

          this.checkIfVideos();
          this.createImageCarousels();

          // Add product id to recently viewed array
          //this.addIdToRecentlyViewed();
        }
        let nowLocalTime = new Date();
        //call search to get promo data
        //
        fetch(`https://spo-partner-api.azure-api.net/search?Subscription-Key=662cff71ce7d49088924abf032a0785c&searchFields=ProductID&selectFields=IsPunchOut,ProductID,activePromo,Promos,Fzy_Style,Fzy_Closure,Fzy_Occasion,Fzy_ShoulderType,Fzy_Hem,Fzy_SleeveLength,Fzy_Fit,Fzy_Neckline,Fzy_Heel,Fzy_Toe,Fzy_HeelHeight,Fzy_Activity,Fzy_LegStyle&suppressFacets=false&term=${window.dataLayerData.product.id}`)
        .then(response => response.json())
        .then(data => {
          let hasActivePromo = false;
          //console.log(data.value);
          if (data.value.length > 0 && data.value[0].IsPunchOut == false)
          {
            if (data.value.length > 0 && data.value[0].activePromo && !data.value[0].activePromo.code.toLowerCase().startsWith("app"))
            {
              if (!data.value[0].activePromo.code.toLowerCase().startsWith("private") || (data.value[0].activePromo.code.toLowerCase().startsWith("private") && typeof customerID !== 'undefined'))
              {
                let pStart = new Date(data.value[0].activePromo.startDate);
                let pEnd = new Date(data.value[0].activePromo.endDate);
                if (nowLocalTime >= pStart && nowLocalTime < pEnd)   
                {
                  let value = data.value[0].activePromo.discountType == "percentage" ? `${data.value[0].activePromo.discountValue}%` : `$${data.value[0].activePromo.discountValue}`;
                  $("#promoplaceholder").html(`<div class="pdp-promo" id="pdp-promo" style="padding:10px 0px">Extra ${value} Off with Code: ${data.value[0].activePromo.code}</div>`);
                  hasActivePromo = true;
                }
              }
            }
            if (!hasActivePromo && data.value.length > 0 && data.value[0].activePromo && data.value[0].activePromo.code.toLowerCase().startsWith("app"))
            {
              if (data.value[0].activePromo.code.toUpperCase().startsWith("APP"))
              {
                let pStart = new Date(data.value[0].activePromo.startDate);
                let pEnd = new Date(data.value[0].activePromo.endDate);
                if (nowLocalTime >= pStart && nowLocalTime < pEnd)   
                {
                  $("#promoplaceholder").html(`<div class="pdp-promo" id="pdp-promo" style="padding:10px 0px">APP ONLY: Extra ${data.value[0].activePromo.discountValue}% Off with Code: ${data.value[0].activePromo.code}</div>`);
                  hasActivePromo = true;
                }
              }
            }
            if (!hasActivePromo)
            {
              for(let v=0;v<data.value[0].Promos.length;v++)
              {
                if (true)
                {          
                  let promo = data.value[0].Promos[v];
                  let code = promo.discountCode;
                  let startD = new Date(promo.StartDate);
                  let endD = new Date(promo.EndDate);
                  if (nowLocalTime >= startD && nowLocalTime < endD) 
                  {          
                    if (code && code.toLowerCase().startsWith("private")) 
                    {
                      if (typeof customerID !== 'undefined') {
                          $("#promoplaceholder").html(`<div class="pdp-promo" id="pdp-promo" style="padding:10px 0px">${promo.Text}</div>`);
                      } else {
                          code = '<div style="margin-top: 4px;"><svg style="margin-right: 4px" width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M2.36357 12H9.6363C9.93753 12 10.1818 11.7558 10.1818 11.4545V5.27273C10.1818 4.97149 9.93753 4.72727 9.6363 4.72727H9.09084V3.09091C9.09084 1.38658 7.70426 0 5.99993 0C4.29561 0 2.90902 1.38658 2.90902 3.09091V4.72727H2.36357C2.06233 4.72727 1.81812 4.97149 1.81812 5.27273V11.4545C1.81812 11.7558 2.06233 12 2.36357 12ZM6.54539 8.54494V9.27273C6.54539 9.57396 6.30117 9.81818 5.99993 9.81818C5.6987 9.81818 5.45448 9.57396 5.45448 9.27273V8.54494C5.23382 8.37895 5.09084 8.11498 5.09084 7.81818C5.09084 7.31691 5.49866 6.90909 5.99993 6.90909C6.50121 6.90909 6.90902 7.31691 6.90902 7.81818C6.90902 8.11498 6.76604 8.37895 6.54539 8.54494ZM3.99993 3.09091C3.99993 1.98811 4.89713 1.09091 5.99993 1.09091C7.10273 1.09091 7.99993 1.98811 7.99993 3.09091V4.72727H3.99993V3.09091Z" fill="#9F005B"/></svg>Sign in for extra savings</div>'
                      }
                    } 
                    else
                    {
                      $("#promoplaceholder").html(`<div class="pdp-promo" id="pdp-promo" style="padding:10px 0px">${promo.Text}</div>`);
                    }                  
                    break;
                  }
                }
              }
            }
          }
          
          if (data.value.length > 0)
          {
            let hasfzy = false;
            let h = `<div style="text-transform: capitalize;padding:10px 0px 20px 0px">`;
            let schematext = "";
            for (const key in data.value[0]) 
            {
              if (key.startsWith("Fzy_"))
              {
                let v = data.value[0][key];
                if (v != "")
                {
                  hasfzy = true;
                  let k = key.split("Fzy_")[1];
                  if (k == "HeelHeight")
                  {
                    k = "Heel Height";
                  }
                  else if (k == "SleeveLength")
                  {
                    k = "Sleeve Length";
                  }
                  else if (k == "ShoulderType")
                  {
                    k = "Shoulder Type";
                  }
                  else if (k == "LegStyle")
                  {
                    k = "Leg Style";
                  }
                  schematext+=`The ${k} is ${v}. `;
                  let h2 = `<div>${k}: ${v}</div>`;
                  h+=h2;
                }                
              }
            }
            if (hasfzy)
            {
              h+="</div>";
              $("#sidebar-box .pdp-details-txt").append(h);

              console.log(schematext)
              const productSchema = $('script[type="application/ld+json"]').filter(function() {
                const text = $(this).text();
                return /"@type"\s*:\s*"Product"/.test(text);
              }).first();

              if (productSchema.length && schematext) {
                const schemaObj = JSON.parse(productSchema.text());

                if (schemaObj.description) {
                  schemaObj.description = `${schematext} ${schemaObj.description}`;
                } else {
                  schemaObj.description = schematext;
                }

                productSchema.text(JSON.stringify(schemaObj, null, 2));
              }
            }
          }
        }); 
      },

      formSetup: function() {
        // Determine how to handle variant availability selectors
        if (theme.settings.dynamicVariantsEnable) {
          this.$variantSelectors = $(this.selectors.formContainer).find(this.selectors.singleOptionSelector);
        }

        this.initQtySelector();
        this.initAjaxProductForm();
        this.initVariants();
      },

      productSetup: function() {
        this.setImageSizes();
        this.initImageSwitch();
        this.initImageZoom();
      },

      addIdToRecentlyViewed: function() {
        var handle = this.$container.attr('data-product-handle');
        var url = this.$container.attr('data-product-url');
        var aspectRatio = this.$container.attr('data-aspect-ratio');
        var featuredImage = this.$container.attr('data-img-url');

        // Remove current product if already in set of recent
        if (theme.recentlyViewed.recent.hasOwnProperty(handle)) {
          delete theme.recentlyViewed.recent[handle];
        }

        // Add it back to the end
        theme.recentlyViewed.recent[handle] = {
          url: url,
          aspectRatio: aspectRatio,
          featuredImage: featuredImage
        };

        Cookies.set('theme-recent',JSON.stringify(theme.recentlyViewed.recent),{ path: '/',expires: 14 });
      },

      initImageZoom: function() {
        var $container = $(this.selectors.imageContainer,this.$container);
        var imageZoom = new theme.Photoswipe($container[0],this.sectionId);
      },

      stringOverrides: function() {
        theme.productStrings = theme.productStrings || {};
        Object.assign(theme.strings,theme.productStrings);
      },

      setImageSizes: function() {
        if (!this.settings.hasImages) {
          return;
        }

        // Get srcset image src, works on most modern browsers
        // otherwise defaults to settings.imageSize
        var currentImage = this.$firstProductImage[0].currentSrc;

        if (currentImage) {
          this.settings.imageSize = theme.Images.imageSize(currentImage);
        }
      },
      _initStoreAvailability: function() {
        this.storeAvailability = new theme.StoreAvailability(
          this.storeAvailabilityContainer
        );
      },
      _updateStoreAvailabilityContent: function(evt) {
        if (!this.storeAvailability) {
          return;
        }
        this.storeAvailability.updateContent(evt);
        //if (this.productState.available && !this.productState.soldOut) {

        // } else {
        //this.storeAvailability.clearContent();
        //}
      },
      initVariants: function() {

        if (!document.getElementById(this.selectors.variantsJson)) {
          return;
        }

        this.variantsObject = JSON.parse(document.getElementById(this.selectors.variantsJson).innerHTML);

        let inStock = [];
        for (let x = 0; x < this.variantsObject.length; x++) {
          if (this.variantsObject[x].available)
            inStock.push(this.variantsObject[x]);
        }
        this.variantsObject = inStock;

        var options = {
          $container: this.$container,
          enableHistoryState: this.settings.enableHistoryState,
          singleOptionSelector: this.selectors.singleOptionSelector,
          originalSelectorId: this.selectors.originalSelectorId,
          variants: this.variantsObject
        };

        if ($(this.selectors.variantColorSwatch).length) {
          $(this.selectors.variantColorSwatch).on('change',function(evt) {
            var $el = $(evt.currentTarget);
            var color = $el.data('color-name');
            var index = $el.data('color-index');
            this.updateColorName(color,index);
          }.bind(this));
        }

        this.variants = new slate.Variants(options);

        this.$container
          .on('variantChange' + this.settings.namespace,this.updateCartButton.bind(this))
          .on('variantImageChange' + this.settings.namespace,this.updateVariantImage.bind(this))
          .on('variantPriceChange' + this.settings.namespace,this.updatePrice.bind(this))
          .on('variantUnitPriceChange' + this.settings.namespace,this.updateUnitPrice.bind(this));

        if ($(this.selectors.sku).length) {
          this.$container.on('variantSKUChange' + this.settings.namespace,this.updateSku.bind(this));
        }
        if (this.settings.inventory) {
          this.$container.on('variantChange' + this.settings.namespace,this.updateInventory.bind(this));
        }


        // Update individual variant availability on each selection
        if (theme.settings.dynamicVariantsEnable && document.getElementById(this.selectors.currentVariantJson)) {
          this.currentVariantObject = JSON.parse(document.getElementById(this.selectors.currentVariantJson).innerHTML);

          this.$variantSelectors.on('change' + this.settings.namespace,this.updateVariantAvailability.bind(this));

          // Set default state based on current selected variant
          this.setCurrentVariantAvailability(this.currentVariantObject,true);
          this._updateStoreAvailabilityContent(this.currentVariantObject);
          window.dataLayerData.product.price = this.currentVariantObject.price / 100;
        }
        else {
          //keelo
          this._updateStoreAvailabilityContent(this.variants.variants[0]);
          if (this.variants && this.variants.variants && this.variants.variants[0])
          	window.dataLayerData.product.price = this.variants.variants[0].price / 100;
        }


        //pdp load
        if (typeof window.userLoyaltyUpdatePrice === 'function') {
          window.userLoyaltyUpdatePrice();
        }
        if (typeof window.trackVariantView === 'function') {
          // this will have the initially selected variant
          const $initialVariantJson = document.querySelector('[id*=CurrentVariantJson-]');
          if ($initialVariantJson && $initialVariantJson.innerHTML) {
            const initialVariant = JSON.parse($initialVariantJson.innerHTML);
            window.trackVariantView(initialVariant);
          }
        }
        //$("#optionWrapSize").insertAfter($("#optionWrapColor"));

        $(".variant-input-wrap").each(function(index) {
          var $children = $(this).children('div');
          $children.sort(function(a,b) {
            var a2 = a.dataset.value;
            var b2 = b.dataset.value;
            if (a2 == "1" || a2 == "1.5" || a2 == "2" || a2 == "2.5" || a2 == "3" || a2 == "3.5" || a2 == "4" || a2 == "4.5" || a2 == "5" || a2 == "5.5" || a2 == "6" || a2 == "6.5" || a2 == "7" || a2 == "7.5" || a2 == "8" || a2 == "8.5" || a2 == "9" || a2 == "9.5") {
              a2 = "0" + a2;
            }
            else if (a2 == "US 1T") {
              a2 = "001";
            }
            else if (a2 == "US 2T") {
              a2 = "002";
            }
            else if (a2 == "US 3T") {
              a2 = "003";
            }
            else if (a2 == "US 4T") {
              a2 = "004";
            }
            else if (a2 == "US 5T") {
              a2 = "005";
            }
            else if (a2 == "US 6T") {
              a2 = "006";
            }
            else if (a2.startsWith("US 00 ")) {
              a2 = "US 0";
            }
            else if (a2.startsWith("US 0 ")) {
              a2 = "US 00";
            }
            else if (a2.startsWith("US 1 ") || a2 == "US 1") {
              a2 = "US 01";
            }
            else if (a2.startsWith("US 1.5 ") || a2 == "US 1.5") {
              a2 = "US 01.5";
            }
            else if (a2.startsWith("US 2 ") || a2 == "US 2") {
              a2 = "US 02";
            }
            else if (a2.startsWith("US 2.5 ") || a2 == "US 2.5") {
              a2 = "US 02.5";
            }
            else if (a2.startsWith("US 3 ") || a2 == "US 3") {
              a2 = "US 03";
            }
            else if (a2.startsWith("US 3.5 ") || a2 == "US 3.5") {
              a2 = "US 03.5";
            }
            else if (a2.startsWith("US 4 ") || a2 == "US 4") {
              a2 = "US 04";
            }
            else if (a2.startsWith("US 4.5 ") || a2 == "US 4.5") {
              a2 = "US 04.5";
            }
            else if (a2.startsWith("US 5 ") || a2 == "US 5") {
              a2 = "US 05";
            }
            else if (a2.startsWith("US 5.5 ") || a2 == "US 5.5") {
              a2 = "US 05.5";
            }
            else if (a2.startsWith("US 6 ") || a2 == "US 6") {
              a2 = "US 06";
            }
            else if (a2.startsWith("US 6.5 ") || a2 == "US 6.5") {
              a2 = "US 06.5";
            }
            else if (a2.startsWith("US 7 ") || a2 == "US 7") {
              a2 = "US 07";
            }
            else if (a2.startsWith("US 7.5 ") || a2 == "US 7.5") {
              a2 = "US 07.5";
            }
            else if (a2.startsWith("US 8 ") || a2 == "US 8") {
              a2 = "US 08";
            }
            else if (a2.startsWith("US 8.5 ") || a2 == "US 8.5") {
              a2 = "US 08.5";
            }
            else if (a2.startsWith("US 9 ") || a2 == "US 9") {
              a2 = "US 09";
            }
            else if (a2.startsWith("US 9.5 ") || a2 == "US 9.5") {
              a2 = "US 09.5";
            }
            else if (a2.startsWith("UK 00 ")) {
              a2 = "UK 0";
            }
            else if (a2.startsWith("UK 0 ")) {
              a2 = "UK 00";
            }
            else if (a2.startsWith("UK 1 ") || a2 == "UK 1") {
              a2 = "UK 01";
            }
            else if (a2.startsWith("UK 1.5 ") || a2 == "UK 1.5") {
              a2 = "UK 01.5";
            }
            else if (a2.startsWith("UK 2 ") || a2 == "UK 2") {
              a2 = "UK 02";
            }
            else if (a2.startsWith("UK 2.5 ") || a2 == "UK 2.5") {
              a2 = "UK 02.5";
            }
            else if (a2.startsWith("UK 3 ") || a2 == "UK 3") {
              a2 = "UK 03";
            }
            else if (a2.startsWith("UK 3.5 ") || a2 == "UK 3.5") {
              a2 = "UK 03.5";
            }
            else if (a2.startsWith("UK 4 ") || a2 == "UK 4") {
              a2 = "UK 04";
            }
            else if (a2.startsWith("UK 4.5 ") || a2 == "UK 4.5") {
              a2 = "UK 04.5";
            }
            else if (a2.startsWith("UK 5 ") || a2 == "UK 5") {
              a2 = "UK 05";
            }
            else if (a2.startsWith("UK 5.5 ") || a2 == "UK 5.5") {
              a2 = "UK 05.5";
            }
            else if (a2.startsWith("UK 6 ") || a2 == "UK 6") {
              a2 = "UK 06";
            }
            else if (a2.startsWith("UK 6.5 ") || a2 == "UK 6.5") {
              a2 = "UK 06.5";
            }
            else if (a2.startsWith("UK 7 ") || a2 == "UK 7") {
              a2 = "UK 07";
            }
            else if (a2.startsWith("UK 7.5 ") || a2 == "UK 7.5") {
              a2 = "UK 07.5";
            }
            else if (a2.startsWith("UK 8 ") || a2 == "UK 8") {
              a2 = "UK 08";
            }
            else if (a2.startsWith("UK 8.5 ") || a2 == "UK 8.5") {
              a2 = "UK 08.5";
            }
            else if (a2.startsWith("UK 9 ") || a2 == "UK 9") {
              a2 = "UK 09";
            }
            else if (a2.startsWith("UK 9.5 ") || a2 == "UK 9.5") {
              a2 = "UK 09.5";
            }
            else if (a2.startsWith("EU 33") || a2 == "EU 33") {
              a2 = "EU 33";
            }
            else if (a2.startsWith("EU 33.5") || a2 == "EU 33.5") {
              a2 = "EU 33.5";
            }
            else if (a2.startsWith("EU 34") || a2 == "EU 34") {
              a2 = "EU 34";
            }
            else if (a2.startsWith("EU 34.5") || a2 == "EU 34.5") {
              a2 = "EU 34.5";
            }
            else if (a2.startsWith("EU 35") || a2 == "EU 35") {
              a2 = "EU 35";
            }
            else if (a2.startsWith("EU 35.5") || a2 == "EU 35.5") {
              a2 = "EU 35.5";
            }
            else if (a2.startsWith("EU 36") || a2 == "EU 36") {
              a2 = "EU 36";
            }
            else if (a2.startsWith("EU 36.5") || a2 == "EU 36.5") {
              a2 = "EU 36.5";
            }
            else if (a2.startsWith("EU 37") || a2 == "EU 37") {
              a2 = "EU 37";
            }
            else if (a2.startsWith("EU 37.5") || a2 == "EU 37.5") {
              a2 = "EU 37.5";
            }
            else if (a2.startsWith("EU 38") || a2 == "EU 38") {
              a2 = "EU 38";
            }
            else if (a2.startsWith("EU 38.5") || a2 == "EU 38.5") {
              a2 = "EU 38.5";
            }
            else if (a2.startsWith("EU 39") || a2 == "EU 39") {
              a2 = "EU 39";
            }
            else if (a2.startsWith("EU 39.5") || a2 == "EU 39.5") {
              a2 = "EU 39.5";
            }
            else if (a2.startsWith("EU 40") || a2 == "EU 40") {
              a2 = "EU 40";
            }
            else if (a2.startsWith("EU 40.5") || a2 == "EU 40.5") {
              a2 = "EU 40.5";
            }
            else if (a2.startsWith("EU 41") || a2 == "EU 41") {
              a2 = "EU 41";
            }
            else if (a2.startsWith("EU 41.5") || a2 == "EU 41.5") {
              a2 = "EU 41.5";
            }
            else if (a2.startsWith("EU 42") || a2 == "EU 42") {
              a2 = "EU 42";
            }
            else if (a2.startsWith("EU 42.5") || a2 == "EU 42.5") {
              a2 = "EU 42.5";
            }
            else if (a2.startsWith("EU 43") || a2 == "EU 43") {
              a2 = "EU 43";
            }
            else if (a2.startsWith("EU 43.5") || a2 == "EU 43.5") {
              a2 = "EU 43.5";
            }
            else if (a2.startsWith("EU 44") || a2 == "EU 44") {
              a2 = "EU 44";
            }
            else if (a2.startsWith("EU 44.5") || a2 == "EU 44.5") {
              a2 = "EU 44.5";
            }
            else if (a2.startsWith("EU 45") || a2 == "EU 45") {
              a2 = "EU 45";
            }
            else if (a2.startsWith("EU 45.5") || a2 == "EU 45.5") {
              a2 = "EU 45.5";
            }
            else if (a2.startsWith("EU 46") || a2 == "EU 46") {
              a2 = "EU 46";
            }
            else if (a2.startsWith("EU 47") || a2 == "EU 47") {
              a2 = "EU 47";
            }
            else if (a2.startsWith("EU 48") || a2 == "EU 48") {
              a2 = "EU 48";
            }
            else if (a2.startsWith("EU 49") || a2 == "EU 49") {
              a2 = "EU 49";
            }
            else if (a2.startsWith("EU 50") || a2 == "EU 50") {
              a2 = "EU 50";
            }
            else if (a2 == "Petite XXSmall") {
              a2 = "Regular 00";
            }
            else if (a2 == "Petite XSmall") {
              a2 = "Regular 0";
            }
            else if (a2 == "Petite Small") {
              a2 = "Regular 1";
            }
            else if (a2 == "Petite Medium") {
              a2 = "Regular 2";
            }
            else if (a2 == "Petite Regular") {
              a2 = "Regular 21";
            }
            else if (a2 == "Petite Large") {
              a2 = "Regular 3";
            }
            else if (a2 == "Petite XLarge") {
              a2 = "Regular 4";
            }
            else if (a2 == "Petite XXLarge") {
              a2 = "Regular 5";
            }
            else if (a2 == "XXS") {
              a2 = "Regular A";
            }
            else if (a2 == "XS") {
              a2 = "Regular B";
            }
            else if (a2 == "S") {
              a2 = "Regular C";
            }
            else if (a2 == "M") {
              a2 = "Regular D";
            }
            else if (a2 == "L") {
              a2 = "Regular E";
            }
            else if (a2 == "XL") {
              a2 = "Regular F";
            }
            else if (a2 == "XXL") {
              a2 = "Regular G";
            }
            else if (a2 == "XXXL") {
              a2 = "Regular H";
            }
            else if (a2 == "XXXSmall") {
              a2 = "Regular I";
            }
            else if (a2 == "XXSmall") {
              a2 = "Regular J";
            }
            else if (a2 == "XSmall") {
              a2 = "Regular K";
            }
            else if (a2 == "XSmall Short") {
              a2 = "Regular K1";
            }
            else if (a2 == "XSmall Medium") {
              a2 = "Regular K2";
            }
            else if (a2 == "XSmall Regular") {
              a2 = "Regular K22";
            }
            else if (a2 == "XSmall Long") {
              a2 = "Regular K3";
            }
            else if (a2 == "Small") {
              a2 = "Regular L";
            }
            else if (a2 == "Small Short") {
              a2 = "Regular L1";
            }
            else if (a2 == "Small Medium") {
              a2 = "Regular L2";
            }
            else if (a2 == "Small Regular") {
              a2 = "Regular L22";
            }
            else if (a2 == "Small Long") {
              a2 = "Regular L3";
            }
            else if (a2 == "Small/Medium") {
              a2 = "Regular M";
            }
            else if (a2 == "Medium") {
              a2 = "Regular N";
            }
            else if (a2 == "Medium Short") {
              a2 = "Regular N1";
            }
            else if (a2 == "Medium Medium") {
              a2 = "Regular N2";
            }
            else if (a2 == "Medium Regular") {
              a2 = "Regular N22";
            }
            else if (a2 == "Medium Long") {
              a2 = "Regular N3";
            }
            else if (a2 == "Medium/Large") {
              a2 = "Regular O";
            }
            else if (a2 == "Large") {
              a2 = "Regular P";
            }
            else if (a2 == "Large Short") {
              a2 = "Regular P1";
            }
            else if (a2 == "Large Medium") {
              a2 = "Regular P20";
            }
            else if (a2 == "Large Regular") {
              a2 = "Regular P21";
            }
            else if (a2 == "Large Long") {
              a2 = "Regular P3";
            }
            else if (a2 == "Large/XLarge") {
              a2 = "Regular Q";
            }
            else if (a2 == "Extra Large") {
              a2 = "Regular R";
            }
            else if (a2 == "XLarge") {
              a2 = "Regular R1";
            }
            else if (a2 == "XLarge Short") {
              a2 = "Regular R10";
            }
            else if (a2 == "XLarge Medium") {
              a2 = "Regular R11";
            }
            else if (a2 == "XLarge Regular") {
              a2 = "Regular R12";
            }
            else if (a2 == "XLarge Long") {
              a2 = "Regular R13";
            }
            else if (a2 == "XXLarge") {
              a2 = "Regular R2";
            }
            else if (a2 == "XXLarge Short") {
              a2 = "Regular R20";
            }
            else if (a2 == "XXLarge Medium") {
              a2 = "Regular R21";
            }
            else if (a2 == "XXLarge Regular") {
              a2 = "Regular R22";
            }
            else if (a2 == "XXLarge Long") {
              a2 = "Regular R23";
            }
            else if (a2 == "XXXLarge") {
              a2 = "Regular R3";
            }
            else if (a2 == "Plus Size 1X") {
              a2 = "Regular S";
            }
            else if (a2 == "Plus Size 2X") {
              a2 = "Regular T";
            }
            else if (a2 == "Plus Size 3X") {
              a2 = "Regular U";
            }
            else if (a2 == "$50.00" || a2 == "$75.00" || a2 == "$100.00" || a2 == "$125.00" || a2 == "$150.00" || a2 == "$175.00" || a2 == "$200.00" || a2 == "$250.00" || a2 == "$300.00" || a2 == "$500.00" || a2 == "$1000.00") {
              a2 = parseInt(a2.split('$')[1]);
            }
            if (b2 == "1" || b2 == "1.5" || b2 == "2" || b2 == "2.5" || b2 == "3" || b2 == "3.5" || b2 == "4" || b2 == "4.5" || b2 == "5" || b2 == "5.5" || b2 == "6" || b2 == "6.5" || b2 == "7" || b2 == "7.5" || b2 == "8" || b2 == "8.5" || b2 == "9" || b2 == "9.5") {
              b2 = "0" + b2;
            }
            else if (b2 == "US 1T") {
              b2 = "001";
            }
            else if (b2 == "US 2T") {
              b2 = "002";
            }
            else if (b2 == "US 3T") {
              b2 = "003";
            }
            else if (b2 == "US 4T") {
              b2 = "004";
            }
            else if (b2 == "US 5T") {
              b2 = "005";
            }
            else if (b2 == "US 6T") {
              b2 = "006";
            }
            else if (b2.startsWith("US 00 ")) {
              b2 = "US 0";
            }
            else if (b2.startsWith("US 0 ")) {
              b2 = "US 00";
            }
            else if (b2.startsWith("US 1 ") || b2 == "US 1") {
              b2 = "US 01";
            }
            else if (b2.startsWith("US 1.5 ") || b2 == "US 1.5") {
              b2 = "US 01.5";
            }
            else if (b2.startsWith("US 2 ") || b2 == "US 2") {
              b2 = "US 02";
            }
            else if (b2.startsWith("US 2.5 ") || b2 == "US 2.5") {
              b2 = "US 02.5";
            }
            else if (b2.startsWith("US 3 ") || b2 == "US 3") {
              b2 = "US 03";
            }
            else if (b2.startsWith("US 3.5 ") || b2 == "US 3.5") {
              b2 = "US 03.5";
            }
            else if (b2.startsWith("US 4 ") || b2 == "US 4") {
              b2 = "US 04";
            }
            else if (b2.startsWith("US 4.5 ") || b2 == "US 4.5") {
              b2 = "US 04.5";
            }
            else if (b2.startsWith("US 5 ") || b2 == "US 5") {
              b2 = "US 05";
            }
            else if (b2.startsWith("US 5.5 ") || b2 == "US 5.5") {
              b2 = "US 05.5";
            }
            else if (b2.startsWith("US 6 ") || b2 == "US 6") {
              b2 = "US 06";
            }
            else if (b2.startsWith("US 6.5 ") || b2 == "US 6.5") {
              b2 = "US 06.5";
            }
            else if (b2.startsWith("US 7 ") || b2 == "US 7") {
              b2 = "US 07";
            }
            else if (b2.startsWith("US 7.5 ") || b2 == "US 7.5") {
              b2 = "US 07.5";
            }
            else if (b2.startsWith("US 8 ") || b2 == "US 8") {
              b2 = "US 08";
            }
            else if (b2.startsWith("US 8.5 ") || b2 == "US 8.5") {
              b2 = "US 08.5";
            }
            else if (b2.startsWith("US 9 ") || b2 == "US 9") {
              b2 = "US 09";
            }
            else if (b2.startsWith("US 9.5 ") || b2 == "US 9.5") {
              b2 = "US 09.5";
            }
            else if (b2.startsWith("UK 00 ")) {
              b2 = "UK 0";
            }
            else if (b2.startsWith("UK 0 ")) {
              b2 = "UK 00";
            }
            else if (b2.startsWith("UK 1 ") || b2 == "UK 1") {
              b2 = "UK 01";
            }
            else if (b2.startsWith("UK 1.5 ") || b2 == "UK 1.5") {
              b2 = "UK 01.5";
            }
            else if (b2.startsWith("UK 2 ") || b2 == "UK 2") {
              b2 = "UK 02";
            }
            else if (b2.startsWith("UK 2.5 ") || b2 == "UK 2.5") {
              b2 = "UK 02.5";
            }
            else if (b2.startsWith("UK 3 ") || b2 == "UK 3") {
              b2 = "UK 03";
            }
            else if (b2.startsWith("UK 3.5 ") || b2 == "UK 3.5") {
              b2 = "UK 03.5";
            }
            else if (b2.startsWith("UK 4 ") || b2 == "UK 4") {
              b2 = "UK 04";
            }
            else if (b2.startsWith("UK 4.5 ") || b2 == "UK 4.5") {
              b2 = "UK 04.5";
            }
            else if (b2.startsWith("UK 5 ") || b2 == "UK 5") {
              b2 = "UK 05";
            }
            else if (b2.startsWith("UK 5.5 ") || b2 == "UK 5.5") {
              b2 = "UK 05.5";
            }
            else if (b2.startsWith("UK 6 ") || b2 == "UK 6") {
              b2 = "UK 06";
            }
            else if (b2.startsWith("UK 6.5 ") || b2 == "UK 6.5") {
              b2 = "UK 06.5";
            }
            else if (b2.startsWith("UK 7 ") || b2 == "UK 7") {
              b2 = "UK 07";
            }
            else if (b2.startsWith("UK 7.5 ") || b2 == "UK 7.5") {
              b2 = "UK 07.5";
            }
            else if (b2.startsWith("UK 8 ") || b2 == "UK 8") {
              b2 = "UK 08";
            }
            else if (b2.startsWith("UK 8.5 ") || b2 == "UK 8.5") {
              b2 = "UK 08.5";
            }
            else if (b2.startsWith("UK 9 ") || b2 == "UK 9") {
              b2 = "UK 09";
            }
            else if (b2.startsWith("UK 9.5 ") || b2 == "UK 9.5") {
              b2 = "UK 09.5";
            }
            else if (b2.startsWith("EU 33") || b2 == "EU 33") {
              b2 = "EU 33";
            }
            else if (b2.startsWith("EU 33.5") || b2 == "EU 33.5") {
              b2 = "EU 33.5";
            }
            else if (b2.startsWith("EU 34") || b2 == "EU 34") {
              b2 = "EU 34";
            }
            else if (b2.startsWith("EU 34.5") || b2 == "EU 34.5") {
              b2 = "EU 34.5";
            }
            else if (b2.startsWith("EU 35") || b2 == "EU 35") {
              b2 = "EU 35";
            }
            else if (b2.startsWith("EU 35.5") || b2 == "EU 35.5") {
              b2 = "EU 35.5";
            }
            else if (b2.startsWith("EU 36") || b2 == "EU 36") {
              b2 = "EU 36";
            }
            else if (b2.startsWith("EU 36.5") || b2 == "EU 36.5") {
              b2 = "EU 36.5";
            }
            else if (b2.startsWith("EU 37") || b2 == "EU 37") {
              b2 = "EU 37";
            }
            else if (b2.startsWith("EU 37.5") || b2 == "EU 37.5") {
              b2 = "EU 37.5";
            }
            else if (b2.startsWith("EU 38") || b2 == "EU 38") {
              b2 = "EU 38";
            }
            else if (b2.startsWith("EU 38.5") || b2 == "EU 38.5") {
              b2 = "EU 38.5";
            }
            else if (b2.startsWith("EU 39") || b2 == "EU 39") {
              b2 = "EU 39";
            }
            else if (b2.startsWith("EU 39.5") || b2 == "EU 39.5") {
              b2 = "EU 39.5";
            }
            else if (b2.startsWith("EU 40") || b2 == "EU 40") {
              b2 = "EU 40";
            }
            else if (b2.startsWith("EU 40.5") || b2 == "EU 40.5") {
              b2 = "EU 40.5";
            }
            else if (b2.startsWith("EU 41") || b2 == "EU 41") {
              b2 = "EU 41";
            }
            else if (b2.startsWith("EU 41.5") || b2 == "EU 41.5") {
              b2 = "EU 41.5";
            }
            else if (b2.startsWith("EU 42") || b2 == "EU 42") {
              b2 = "EU 42";
            }
            else if (b2.startsWith("EU 42.5") || b2 == "EU 42.5") {
              b2 = "EU 42.5";
            }
            else if (b2.startsWith("EU 43") || b2 == "EU 43") {
              b2 = "EU 43";
            }
            else if (b2.startsWith("EU 43.5") || b2 == "EU 43.5") {
              b2 = "EU 43.5";
            }
            else if (b2.startsWith("EU 44") || b2 == "EU 44") {
              b2 = "EU 44";
            }
            else if (b2.startsWith("EU 44.5") || b2 == "EU 44.5") {
              b2 = "EU 44.5";
            }
            else if (b2.startsWith("EU 45") || b2 == "EU 45") {
              b2 = "EU 45";
            }
            else if (b2.startsWith("EU 45.5") || b2 == "EU 45.5") {
              b2 = "EU 45.5";
            }
            else if (b2.startsWith("EU 46") || b2 == "EU 46") {
              b2 = "EU 46";
            }
            else if (b2.startsWith("EU 47") || b2 == "EU 47") {
              b2 = "EU 47";
            }
            else if (b2.startsWith("EU 48") || b2 == "EU 48") {
              b2 = "EU 48";
            }
            else if (b2.startsWith("EU 49") || b2 == "EU 49") {
              b2 = "EU 49";
            }
            else if (b2.startsWith("EU 50") || b2 == "EU 50") {
              b2 = "EU 50";
            }
            else if (b2 == "Petite XXSmall") {
              b2 = "Regular 00";
            }
            else if (b2 == "Petite XSmall") {
              b2 = "Regular 0";
            }
            else if (b2 == "Petite Small") {
              b2 = "Regular 1";
            }
            else if (b2 == "Petite Medium") {
              b2 = "Regular 2";
            }
            else if (b2 == "Petite Regular") {
              b2 = "Regular 21";
            }
            else if (b2 == "Petite Large") {
              b2 = "Regular 3";
            }
            else if (b2 == "Petite XLarge") {
              b2 = "Regular 4";
            }
            else if (b2 == "Petite XXLarge") {
              b2 = "Regular 5";
            }
            else if (b2 == "XXS") {
              b2 = "Regular A";
            }
            else if (b2 == "XS") {
              b2 = "Regular B";
            }
            else if (b2 == "S") {
              b2 = "Regular C";
            }
            else if (b2 == "M") {
              b2 = "Regular D";
            }
            else if (b2 == "L") {
              b2 = "Regular E";
            }
            else if (b2 == "XL") {
              b2 = "Regular F";
            }
            else if (b2 == "XXL") {
              b2 = "Regular G";
            }
            else if (b2 == "XXXL") {
              b2 = "Regular H";
            }
            else if (b2 == "XXXSmall") {
              b2 = "Regular I";
            }
            else if (b2 == "XXSmall") {
              b2 = "Regular J";
            }
            else if (b2 == "XSmall") {
              b2 = "Regular K";
            }
            else if (b2 == "XSmall Short") {
              b2 = "Regular K1";
            }
            else if (b2 == "XSmall Medium") {
              b2 = "Regular K2";
            }
            else if (b2 == "XSmall Regular") {
              b2 = "Regular K22";
            }
            else if (b2 == "XSmall Long") {
              b2 = "Regular K3";
            }
            else if (b2 == "Small") {
              b2 = "Regular L";
            }
            else if (b2 == "Small Short") {
              b2 = "Regular L1";
            }
            else if (b2 == "Small Medium") {
              b2 = "Regular L2";
            }
            else if (b2 == "Small Regular") {
              b2 = "Regular L22";
            }
            else if (b2 == "Small Long") {
              b2 = "Regular L3";
            }
            else if (b2 == "Small/Medium") {
              b2 = "Regular M";
            }
            else if (b2 == "Medium") {
              b2 = "Regular N";
            }
            else if (b2 == "Medium Short") {
              b2 = "Regular N1";
            }
            else if (b2 == "Medium Medium") {
              b2 = "Regular N2";
            }
            else if (b2 == "Medium Regular") {
              b2 = "Regular N22";
            }
            else if (b2 == "Medium Long") {
              b2 = "Regular N3";
            }
            else if (b2 == "Medium/Large") {
              b2 = "Regular O";
            }
            else if (b2 == "Large") {
              b2 = "Regular P";
            }
            else if (b2 == "Large Short") {
              b2 = "Regular P1";
            }
            else if (b2 == "Large Medium") {
              b2 = "Regular P20";
            }
            else if (b2 == "Large Regular") {
              b2 = "Regular P21";
            }
            else if (b2 == "Large Long") {
              b2 = "Regular P3";
            }
            else if (b2 == "Large/XLarge") {
              b2 = "Regular Q";
            }
            else if (b2 == "Extra Large") {
              b2 = "Regular R";
            }
            else if (b2 == "XLarge") {
              b2 = "Regular R1";
            }
            else if (b2 == "XLarge Short") {
              b2 = "Regular R10";
            }
            else if (b2 == "XLarge Medium") {
              b2 = "Regular R11";
            }
            else if (b2 == "XLarge Regular") {
              b2 = "Regular R12";
            }
            else if (b2 == "XLarge Long") {
              b2 = "Regular R13";
            }
            else if (b2 == "XXLarge") {
              b2 = "Regular R2";
            }
            else if (b2 == "XXLarge Short") {
              b2 = "Regular R20";
            }
            else if (b2 == "XXLarge Medium") {
              b2 = "Regular R21";
            }
            else if (b2 == "XXLarge Regular") {
              b2 = "Regular R22";
            }
            else if (b2 == "XXLarge Long") {
              b2 = "Regular R23";
            }
            else if (b2 == "XXXLarge") {
              b2 = "Regular R3";
            }
            else if (b2 == "Plus Size 1X") {
              b2 = "Regular S";
            }
            else if (b2 == "Plus Size 2X") {
              b2 = "Regular T";
            }
            else if (b2 == "Plus Size 3X") {
              b2 = "Regular U";
            }
            else if (b2 == "$50.00" || b2 == "$75.00" || b2 == "$100.00" || b2 == "$125.00" || b2 == "$150.00" || b2 == "$175.00" || b2 == "$200.00" || b2 == "$250.00" || b2 == "$300.00" || b2 == "$500.00" || b2 == "$1000.00") {
              b2 = parseInt(b2.split('$')[1]);
            }
            if (a2 < b2) { return -1; }
            if (a2 > b2) { return 1; }
            return 0;
          }).appendTo(this);
        });
      },

      setCurrentVariantAvailability: function(variant) {
        var valuesToEnable = {
          option1: [],
          option2: [],
          option3: []
        };
        // Disable all options to start
        this.disableVariantGroup($(this.selectors.formContainer).find('.variant-input-wrap'));

        // Combine all available variants
        var availableVariants = this.variantsObject.filter(function(el) {
          if (variant.id === el.id) {
            return false;
          }

          // Option 1
          if (variant.option2 === el.option2 && variant.option3 === el.option3) {
            return true;
          }

          // Option 2
          if (variant.option1 === el.option1 && variant.option3 === el.option3) {
            return true;
          }

          // Option 3
          if (variant.option1 === el.option1 && variant.option2 === el.option2) {
            return true;
          }
        });

        //keelo
        // IE11 can't handle shortform of {variant} so extra step is needed
        var variantObject = {
          variant: variant
        };

        availableVariants = Object.assign({},variantObject,availableVariants);

        // Loop through each available variant to gather variant values
        for (var property in availableVariants) {
          if (availableVariants.hasOwnProperty(property)) {
            var item = availableVariants[property];
            var option1 = item.option1;
            var option2 = item.option2;
            var option3 = item.option3;

            if (option1) {
              if (valuesToEnable.option1.indexOf(option1) === -1) {
                valuesToEnable.option1.push(option1);
              }
            }
            if (option2) {
              if (valuesToEnable.option2.indexOf(option2) === -1) {
                valuesToEnable.option2.push(option2);
              }
            }
            if (option3) {
              if (valuesToEnable.option3.indexOf(option3) === -1) {
                valuesToEnable.option3.push(option3);
              }
            }
          }
        }

        // Have values to enable, separated by option index
        if (valuesToEnable.option1.length) {
          this.enableVariantOptionByValue(valuesToEnable.option1,'option1');
        }
        if (valuesToEnable.option2.length) {
          this.enableVariantOptionByValue(valuesToEnable.option2,'option2');
        }
        if (valuesToEnable.option3.length) {
          this.enableVariantOptionByValue(valuesToEnable.option3,'option3');
        }
        //trigger the in store pickup
        //this._updateStoreAvailabilityContent(variant);
      },

      updateVariantAvailability: function(evt,value,index) {
        if (value && index) {
          var newVal = value;
          var optionIndex = index;
        } else {
          var $el = $(evt.currentTarget);
          var newVal = $el.val() ? $el.val() : evt.currentTarget.value;
          var optionIndex = $el.data('index');
        }

        var variants = this.variantsObject.filter(function(el) {
          return el[optionIndex] === newVal;
        });

        // Disable all buttons/dropdown options that aren't the current index
        $(this.selectors.formContainer).find('.variant-input-wrap').each(function(index,el) {
          var $group = $(el);
          var currentOptionIndex = $group.data('index');

          if (currentOptionIndex !== optionIndex) {
            // Disable all options as a starting point
            this.disableVariantGroup($group);

            // Loop through legit available options and enable
            for (var i = 0; i < variants.length; i++) {
              if (variants[i].available) {
                this.enableVariantOption($group,variants[i][currentOptionIndex]);
              }
            }
          }
        }.bind(this));

      },

      disableVariantGroup: function($group) {
        if (theme.settings.dynamicVariantType === 'dropdown') {
          $group.find('option').prop('disabled',true);
        } else {
          //$group.find('input').prop('disabled', true);
          $group.find('label').addClass('disabled');
        }
      },

      enableVariantOptionByValue: function(array,index) {
        var $group = $(this.selectors.formContainer).find('.variant-input-wrap[data-index="' + index + '"]');
        for (var i = 0; i < array.length; i++) {
          if (!this.currentVariantObject.available && !this.currentVariantObject.options.includes(array[i])) {
            this.enableVariantOption($group,array[i]);
          }
          else {
            var foundOne = false;
            for (var k = 0; k < this.variantsObject.length; k++) {
              if (!this.variantsObject[k].available) {
                if (index === 'option1' && this.variantsObject[k].option1 === array[i]) {
                  //console.log(this.variantsObject[k].option1 + " - " + array[i]);
                  //this.enableVariantOption($group, array[i]);break;
                  foundOne = true;
                }
                else if (index === 'option2') {
                  //else if(index === 'option2' && this.variantsObject[k].option2 === array[i]){
                  //this.enableVariantOption($group, array[i]);break;
                  //foundOne = true;
                }
              }
            }
            if (!foundOne)
              this.enableVariantOption($group,array[i]);
          }
        }
      },

      enableVariantOption: function($group,value) {
        // Selecting by value so escape it
        value = value.replace(/([ #;&,.+*~\':"!^$[\]()=>|\/@])/g,'\\$1');

        if (theme.settings.dynamicVariantType === 'dropdown') {
          $group.find('option[value="' + value + '"]').prop('disabled',false);
        } else {
          var $buttonGroup = $group.find('.variant-input[data-value="' + value + '"]');
          var inp = $buttonGroup.find('input');
          inp.prop('disabled',false);
          var col = inp.val();
          if (inp.attr('name') == "Color") {//keelo
            //$('#VariantColorLabel-' + this.sectionId + '-1').text(col);
          }
          //$buttonGroup.find('input').attr({'checked': true});
          $buttonGroup.find('label').toggleClass('disabled',false);
        }

      },

      // Variant change functions
      updateColorName: function(color,index) {
        // Updates on radio button change, not variant.js
        $('#VariantColorLabel-' + this.sectionId + '-' + index).text(color);
      },

      updateCartButton: function(evt) {
        var variant = evt.variant;
        if (variant) {
          if (variant.available && variant.price > 0) {
            // Available, enable the submit button and change text
            $(this.selectors.addToCart).removeClass("pdp-disable");
            $(this.selectors.addToCart).removeClass(classes.disabled).prop('disabled',false);
            $(this.selectors.addToCartText).html($(this.selectors.addToCartText).data("btn-text"));

            $('#AddToCart-sticky').removeClass("pdp-disable");
            $('#AddToCart-sticky').removeClass(classes.disabled).prop('disabled',false);
            $('#AddToCartText-sticky').html($(this.selectors.addToCartText).data("btn-text"));
          } else {
            // Sold out, disable the submit button and change text
            $(this.selectors.addToCart).addClass(classes.disabled).prop('disabled',true);

            $('#AddToCart-sticky').addClass(classes.disabled).prop('disabled',true);
            if (variant.option1 && variant.option2) {
              $(this.selectors.addToCartText).html("Select an option");

              $('#AddToCartText-sticky').html("Select an option");
            }
            else {
              $(this.selectors.addToCartText).html("Sold Out");

              $('#AddToCartText-sticky').html("Sold Out");
            }
          }
          if (typeof window.trackVariantView === 'function') {
            window.trackVariantView(variant);
          }
        } else {
          // The variant doesn't exist, disable submit button
          $(this.selectors.addToCart).addClass(classes.disabled).prop('disabled',true);
          $(this.selectors.addToCart).addClass("pdp-disable");
          $(this.selectors.addToCartText).html("SOLD OUT<div class='pdp-disable-extra'>Select a different size/color option</div>");

          $('#AddToCart-sticky').addClass(classes.disabled).prop('disabled',true);
          $('#AddToCart-sticky').addClass("pdp-disable");
          $('#AddToCartText-sticky').html("SOLD OUT<div class='pdp-disable-extra'>Select a different size/color option</div>");
        }
      },

      updatePrice: function(evt) {
        var variant = evt.variant;

        if (variant) {
          // Regular price
          $(this.selectors.price).html(theme.Currency.formatMoney(variant.price,theme.settings.moneyFormat)).show();
          $(this.selectors.stickyPrice).html(theme.Currency.formatMoney(variant.price,theme.settings.moneyFormat)).show();

          // Sale price, if necessary
          if (variant.compare_at_price > variant.price) {
            $(this.selectors.comparePrice).html(theme.Currency.formatMoney(variant.compare_at_price,theme.settings.moneyFormat));
            $(this.selectors.priceWrapper).removeClass('hide');
            $(this.selectors.price).addClass(classes.onSale);
            $(this.selectors.comparePriceA11y).attr('aria-hidden','false');
            $(this.selectors.priceA11y).attr('aria-hidden','false');

            $(this.selectors.stickyComparePrice).html(theme.Currency.formatMoney(variant.compare_at_price,theme.settings.moneyFormat));
            $(this.selectors.stickyPriceWrapper).removeClass('hide');
            $(this.selectors.stickyPrice).addClass(classes.onSale);
            $(this.selectors.stickyComparePriceA11y).attr('aria-hidden','false');
            $(this.selectors.stickyPriceA11y).attr('aria-hidden','false');
            
            var savings = variant.compare_at_price - variant.price;
            
            if (savings > 1499) {
              $('.pdp-savings-calculation').each(function() {
                $(this).text(`You're saving ${theme.Currency.formatMoney(savings,theme.settings.moneyFormat)}`)
              })
            }
            
            if (theme.settings.saveType == 'percent') {
              savings = Math.round(((savings) * 100) / variant.compare_at_price) + '%';
            } else {
              savings = theme.Currency.formatMoney(savings,theme.settings.moneyFormat);
            }

            $(this.selectors.savePrice)
              .removeClass('hide')
              .html(theme.strings.savePrice.replace('[saved_amount]',savings));

            $(this.selectors.stickySavePrice)
              .removeClass('hide')
              .html(theme.strings.savePrice.replace('[saved_amount]',savings));
          } else {
            $(this.selectors.priceWrapper).addClass('hide');
            $(this.selectors.price).removeClass(classes.onSale);
            $(this.selectors.comparePriceA11y).attr('aria-hidden','true');
            $(this.selectors.priceA11y).attr('aria-hidden','true');
            $(this.selectors.savePrice).addClass('hide');

            $(this.selectors.stickyPriceWrapper).addClass('hide');
            $(this.selectors.stickyPrice).removeClass(classes.onSale);
            $(this.selectors.stickyComparePriceA11y).attr('aria-hidden','true');
            $(this.selectors.stickyPriceA11y).attr('aria-hidden','true');
            $(this.selectors.stickySavePrice).addClass('hide');
          }
          if (theme.settings.currenciesEnabled) {
            theme.currencySwitcher.ajaxrefresh();
          }
          window.dataLayerData.product.price = variant.price / 100;
          //price has changed, call loyalty
          if (typeof window.userLoyaltyUpdatePrice === "function")
            window.userLoyaltyUpdatePrice(variant.price / 100);
        }
      },

      updateUnitPrice: function(evt) {
        var variant = evt.variant;

        if (variant && variant.unit_price) {
          $(this.selectors.unitPrice).html(theme.Currency.formatMoney(variant.unit_price,theme.settings.moneyFormat));
          $(this.selectors.unitPriceBaseUnit).text(theme.Currency.getBaseUnit(variant));
          $(this.selectors.unitWrapper).removeClass('hide').removeClass(classes.visuallyHide);
        } else {
          $(this.selectors.unitWrapper).addClass(classes.visuallyHide);
        }
      },

      updateSku: function(evt) {
        var variant = evt.variant;
        var newSku = '';

        if (variant) {
          if (variant.sku) {
            newSku = variant.sku;
          }

          $(this.selectors.sku).html("&bull; SKU: " + newSku);
        }
      },

      updateInventory: function(evt) {
        var variant = evt.variant;
        if (variant && window.lastVariantId && window.lastVariantId == variant.id)
          return;
        //keelo
        if (variant)
          window.lastVariantId = variant.id;
        var showInventory = false;
        var quantity = 0;
        var $inventoryLabel = $(this.selectors.inventory);
        var isPunchoutProduct = $inventoryLabel.data('punchout-product') === true || $inventoryLabel.data('punchout-product') === 'true';

        if (isPunchoutProduct) {
          $inventoryLabel.addClass('hide');
          return;
        }


        if (variant && variant.inventory_management === 'shopify') {
          showInventory = true;
          quantity = window.inventories[this.sectionId][variant.id];

          if (quantity <= 0 || quantity > theme.settings.inventoryThreshold) {
            showInventory = false;
          }

          this._updateStoreAvailabilityContent(variant);
        }

        if (!showInventory) {
          $inventoryLabel.addClass('hide');
        } else {
          $inventoryLabel
            .removeClass('hide')
            .text(theme.strings.stockLabel.replace('[count]',quantity));
        }
      },

      updateVariantImage: function(evt) {
        var variant = evt.variant;
        var sizedImgUrl = theme.Images.getSizedImageUrl(variant.featured_image.src,this.settings.imageSize);

        var $newImage = $('.product__thumb[data-id="' + variant.featured_image.id + '"]');
        var imageIndex = this._slideIndex($newImage.closest('.product__thumb-item'));

        // No image, bail
        if (typeof imageIndex === 'undefined') {
          return;
        }

        this.$mainSlider.slick('slickGoTo',imageIndex);
      },

      // Image/thumbnail toggling
      initImageSwitch: function() {
        if (!$(this.selectors.photoThumbs).length) {
          return;
        }

        var self = this;

        $(this.selectors.photoThumbs).on('click',function(evt) {
          evt.preventDefault();
        });
      },

      checkIfVideos: function() {
        var $productVideos = this.$mainSlider.find(selectors.productVideo);

        // Stop if there are 0 videos
        if (!$productVideos.length) {
          return false;
        }

        var videoTypes = [];

        $productVideos.each(function() {
          var type = $(this).data('video-type');

          if (videoTypes.indexOf(type) < 0) {
            videoTypes.push(type);
          }
        });

        // Load YouTube API if not already loaded
        if (videoTypes.indexOf('youtube') > -1) {
          if (!theme.config.youTubeReady) {
            window.loadYouTube();
            $('body').on('youTubeReady' + this.settings.namespace,function() {
              this.loadYoutubeVideos($productVideos);
            }.bind(this));
          } else {
            this.loadYoutubeVideos($productVideos);
          }
        }

        // Load Vimeo API if not already loaded
        if (videoTypes.indexOf('vimeo') > -1) {
          if (!vimeoReady) {
            window.loadVimeo();
            $('body').on('vimeoReady' + this.settings.namespace,function() {
              this.loadVimeoVideos($productVideos);
            }.bind(this));
          } else {
            this.loadVimeoVideos($productVideos);
          }
        }

        // Add mp4 video players
        if (videoTypes.indexOf('mp4') > -1) {
          this.loadMp4Videos($productVideos);
        }

        return videoTypes;
      },

      loadMp4Videos: function($videos) {
        $videos.each(function() {
          var $el = $(this);
          if ($el.data('video-type') != 'mp4') {
            return;
          }

          var id = $el.attr('id');
          var videoId = $el.data('video-id');

          videos[this.id] = {
            type: 'mp4',
            divId: id,
            style: $el.data('video-style')
          };
        });
      },

      loadVimeoVideos: function($videos) {
        $videos.each(function() {
          var $el = $(this);
          if ($el.data('video-type') != 'vimeo') {
            return;
          }

          var id = $el.attr('id');
          var videoId = $el.data('video-id');

          videos[this.id] = {
            type: 'vimeo',
            divId: id,
            id: videoId,
            style: $el.data('video-style'),
            width: $el.data('video-width'),
            height: $el.data('video-height')
          };
        });

        // Create a new player for each Vimeo video
        for (var key in videos) {
          if (videos[key].type != 'vimeo') {
            continue;
          }

          var args = Object.assign({},vimeoVideoOptions,videos[key]);
          vimeoPlayers[key] = new Vimeo.Player(videos[key].divId,args);
        }

        vimeoReady = true;
      },

      autoplayVimeoVideo: function(id) {
        // Do not autoplay on mobile though
        if (!theme.config.bpSmall) {
          this.requestToPlayVimeoVideo(id);
        } else {
          // Set as loaded on mobile so you can see the image
          var $player = $('#' + id);
          setParentAsLoaded($player);
        }
      },

      requestToPlayVimeoVideo: function(id) {
        // The slider may initialize and attempt to play the video before
        // the API is even ready, because it sucks.

        var $player = $('#' + id);
        setParentAsLoading($player);

        if (!vimeoReady) {
          // Wait for the trigger, then play it
          $('body').on('vimeoReady' + this.settings.namespace,function() {
            this.playVimeoVideo(id);
          }.bind(this));
          return;
        }

        this.playVimeoVideo(id);
      },

      playVimeoVideo: function(id) {
        vimeoPlayers[id].play();

        if (videos[id].style === 'muted') {
          vimeoPlayers[id].setVolume(0);
        }

        var $player = $('#' + id);
        setParentAsLoaded($player);
      },

      stopVimeoVideo: function(id) {
        if (!theme.config.vimeoReady) {
          return;
        }

        if (id) {
          vimeoPlayers[id].pause();
        } else {
          for (key in vimeoPlayers) {
            if (typeof vimeoPlayers[key].pause === 'function') {
              vimeoPlayers[key].pause();
            }
          }
        }
      },

      loadYoutubeVideos: function($videos) {
        $videos.each(function() {
          var $el = $(this);
          if ($el.data('video-type') != 'youtube') {
            return;
          }

          var id = $el.attr('id');
          var videoId = $el.data('youtube-id');

          videos[this.id] = {
            type: 'youtube',
            id: id,
            videoId: videoId,
            style: $el.data('video-style'),
            width: $el.data('video-width'),
            height: $el.data('video-height'),
            attemptedToPlay: false
          };
        });

        // Create a player for each YouTube video
        for (var key in videos) {
          if (videos[key].type === 'youtube') {
            if (videos.hasOwnProperty(key)) {
              var args = Object.assign({},youtubeVideoOptions,videos[key]);

              if (args.style === 'muted') {
                // default youtubeVideoOptions, no need to change anything
              } else {
                args.playerVars.controls = 1;
                args.playerVars.autoplay = 0;
              }

              youtubePlayers[key] = new YT.Player(key,args);
            }
          }
        }

        youtubeReady = true;
      },

      requestToPlayYoutubeVideo: function(id,forcePlay) {
        if (!theme.config.youTubeReady) {
          return;
        }

        var $player = $('#' + id);
        setParentAsLoading($player);

        // If video is requested too soon, player might not be ready.
        // Set arbitrary timeout to request it again in a second
        if (typeof youtubePlayers[id].playVideo != 'function') {
          var o = this;
          setTimeout(function() {
            o.playYoutubeVideo(id,forcePlay);
          },1000);
          return;
        }

        this.playYoutubeVideo(id,forcePlay);
      },

      playYoutubeVideo: function(id,forcePlay) {
        var $player = $('#' + id);
        setParentAsLoaded($player);
        if (typeof youtubePlayers[id].playVideo === 'function') {
          youtubePlayers[id].playVideo();
        }

        // forcePlay is sent as true from beforeSlideChange so the visibility
        // check isn't fooled by the next slide positioning
        if (!forcePlay) {
          initCheckVisibility(id);
        }
      },

      stopYoutubeVideo: function(id) {
        if (!theme.config.youTubeReady) {
          return;
        }

        if (id && youtubePlayers[id]) {
          if (typeof youtubePlayers[id].pauseVideo === 'function') {
            youtubePlayers[id].pauseVideo();
          }
          $(window).off('scroll.' + id);
        } else {
          for (key in youtubePlayers) {
            if (typeof youtubePlayers[key].pauseVideo === 'function') {
              youtubePlayers[key].pauseVideo();
              $(window).off('scroll.' + key);
            }
          }
        }
      },

      playMp4Video: function(id) {
        var $player = $('#' + id);
        setParentAsLoaded($player);

        $player[0].play();
      },

      stopMp4Video: function(id) {
        if (id) {
          $('#' + id)[0].pause();
        } else {
          // loop through all mp4 videos to stop them
          for (var key in videos) {
            if (videos[key].type === 'mp4') {
              var player = $('#' + videos[key].divId)[0];
              if (typeof player.pause === 'function') {
                player.pause();
              }
            }
          }
        }
      },

      createImageCarousels: function() {
        if (!this.$thumbSlider.length || $(this.selectors.photoThumbs).length < 2) {
          // Single product image. Init video if it exists
          var $video = $(this.selectors.productImageMain).find(selectors.productVideo);
          if ($video.length) {
            this.initVideo($video);
          }
          return;
        }

        this.settings.hasMultipleImages = true;

        // Set starting slide (for both sliders)
        var $activeSlide = this.$mainSlider.find('.starting-slide');
        var startIndex = this._slideIndex($activeSlide);

        // Lame way to prevent duplicate event listeners
        this.$mainSlider.off('init');
        this.$mainSlider.off('beforeChange');
        this.$mainSlider.on('init',this.mainSlideInit.bind(this));
        this.$mainSlider.on('beforeChange',this.beforeSlideChange.bind(this));
        this.$thumbSlider.on('init',this.thumbSlideInit.bind(this));

        // Default (mobile) slider settings
        this.mainSliderArgs = {
          infinite: true,
          arrows: false,
          dots: true,
          adaptiveHeight: true,
          initialSlide: startIndex
        };

        this.thumbSliderArgs = {
          initialSlide: startIndex
        };

        // Init sliders normally
        var sliderArgs = this.setSliderArgs();
        this.initSliders(sliderArgs);

        // Re-init slider when a breakpoint is hit
        $('body').on('matchSmall matchLarge',function() {
          var sliderArgs = this.setSliderArgs();
          this.initSliders(sliderArgs);
        }.bind(this));

        // Too many thumbnails can cause the AOS calculations to be off
        // so refresh that when the slider is ready
        if (AOS) {
          AOS.refresh();
        }
      },

      initSliders: function(args) {
        this.destroyImageCarousels();

        this.$mainSlider.slick(args.main);
        if (!theme.config.bpSmall) {
          this.$thumbSlider.slick(args.thumbs);
        }

        this.settings.slickMainInitialized = true;
      },

      setSliderArgs: function() {
        var args = {};
        var thumbnailsVertical = this.$thumbSlider.data('position') === 'beside' ? true : false;

        if (theme.config.bpSmall) {
          args.main = this.mainSliderArgs;
          args.thumbs = this.thumbSliderArgs;
        } else {
          args.main = Object.assign({},this.mainSliderArgs,{
            asNavFor: this.selectors.thumbSlider,
            adaptiveHeight: thumbnailsVertical ? false : true,
            dots: false,
            infinite: false,
            fade: true
          });
          args.thumbs = Object.assign({},this.thumbSliderArgs,{
            asNavFor: this.selectors.mainSlider,
            slidesToShow: thumbnailsVertical ? 3 : 5,
            slidesToScroll: 1,
            arrows: false,
            dots: false,
            vertical: thumbnailsVertical,
            verticalSwiping: thumbnailsVertical,
            focusOnSelect: true,
            infinite: false,
            customHeightMatching: thumbnailsVertical,
            customSlideAdvancement: true
          });
        }

        return args;
      },

      destroyImageCarousels: function() {
        if (this.$mainSlider && this.settings.slickMainInitialized) {
          this.$mainSlider.slick('unslick');
          this.settings.slickMainInitialized = false;
        }

        if (this.$thumbSlider && this.settings.slickThumbInitialized) {
          this.$thumbSlider.slick('unslick');
          this.settings.slickThumbInitialized = false;
        }

        this.settings.slickMainInitialized = false;
        this.settings.slickThumbInitialized = false;
      },

      mainSlideInit: function(event,slick) {
        var $slider = slick.$slider;
        var $currentSlide = $slider.find(selectors.currentSlide);
        var $video = $currentSlide.find(selectors.productVideo);

        if (!$video.length) {
          return;
        }

        this.initVideo($video);
      },

      thumbSlideInit: function(event,slick) {
        this.settings.slickThumbInitialized = true;
      },

      initVideo: function($video) {
        var videoType = $video.data('video-type');
        var divId = $video.attr('id');

        if (videoType === 'mp4' && videos[divId].style === 'muted') {
          this.playMp4Video(divId);
        }

        if (videoType === 'youtube') {
          if (youtubeReady && videos[divId].style === 'muted') {
            this.requestToPlayYoutubeVideo(divId);
          }
        }

        if (videoType === 'vimeo') {
          if (vimeoReady) {
            this.playOrShowVimeo(divId);
          } else {
            $('body').on('vimeoReady' + this.settings.namespace,function() {
              this.playOrShowVimeo(divId);
            }.bind(this));
          }
        }

        // Hacky way to trigger resetting the slider layout in modals
        if (this.inModal) {
          this.resizeSlides();
        }
      },

      stopVideo: function(id,type) {
        if (!id) {
          this.stopYoutubeVideo();
          this.stopVimeoVideo();
          this.stopMp4Video();
        }

        if (type === 'youtube') {
          this.stopYoutubeVideo(id);
        }

        if (type === 'mp4') {
          this.stopMp4Video(id);
        }

        if (type === 'vimeo') {
          this.stopVimeoVideo(id);
        }
      },

      playOrShowVimeo: function(id) {
        if (videos[id] && videos[id].style === 'muted') {
          this.autoplayVimeoVideo(id);
        } else if (videos[id] && videos[id].style === 'unmuted') {
          setParentAsLoaded($('#' + id));
        }
      },

      getVideoType: function($video) {
        return $video.data('video-type');
      },

      getVideoId: function($video) {
        return $video.attr('id');
      },

      beforeSlideChange: function(event,slick,currentSlide,nextSlide) {
        var $slider = slick.$slider;
        var $currentSlide = $slider.find(selectors.currentSlide);
        var $prevVideo = $currentSlide.find('.product__video');
        var $nextSlide = $slider.find('.slick-slide[data-slick-index="' + nextSlide + '"]');
        var $nextVideo = $nextSlide.find('.product__video');

        // Pause any existing slide video
        if (currentSlide !== nextSlide && $prevVideo.length) {
          var prevVideoType = this.getVideoType($prevVideo);
          var prevVideoId = this.getVideoId($prevVideo);

          if (prevVideoId) {
            this.stopVideo(prevVideoId,prevVideoType);
          }
        }

        // Prep next slide video
        if ($nextVideo.length) {
          var nextVideoType = this.getVideoType($nextVideo);
          var nextVideoId = this.getVideoId($nextVideo);

          // Prep Vimeo with a backup in case the API isn't ready
          if (nextVideoId && nextVideoType === 'vimeo') {
            if (vimeoReady) {
              if (videos[nextVideoId] && videos[nextVideoId].style === 'muted') {
                this.autoplayVimeoVideo(nextVideoId);
              }
            } else {
              $('body').on('vimeoReady' + this.settings.namespace,function() {
                if (videos[nextVideoId] && videos[nextVideoId].style === 'muted') {
                  this.autoplayVimeoVideo(nextVideoId);
                }
              }.bind(this));
            }
          }

          // Prep YouTube with a backup in case API isn't ready
          if (nextVideoId && nextVideoType === 'youtube') {
            if (youtubeReady) {
              if (videos[nextVideoId] && videos[nextVideoId].style === 'muted') {
                this.requestToPlayYoutubeVideo(nextVideoId,true);
              }
            } else {
              $('body').on('youTubeReady' + this.settings.namespace,function() {
                if (videos[nextVideoId] && videos[nextVideoId].style === 'muted') {
                  this.requestToPlayYoutubeVideo(nextVideoId,true);
                }
              }.bind(this));
            }
          }

          // Autoplay muted MP4 videos
          if (nextVideoId && videos[nextVideoId] && videos[nextVideoId].style === 'muted') {
            if (nextVideoType === 'mp4') {
              this.playMp4Video(nextVideoId);
            }
          }

          // Set unmuted videos to loaded state
          if (nextVideoId && videos[nextVideoId] && videos[nextVideoId].style != 'muted') {
            setParentAsLoaded($('#' + nextVideoId));
          }
        }
      },

      resizeSlides: function() {
        if (!this.settings.hasMultipleImages) {
          return;
        }

        $(window).trigger('resize.slick');
        setTimeout(function() {
          if (this.$mainSlider && this.settings.slickMainInitialized) {
            this.$mainSlider.slick('setPosition');
          }
          if (this.$thumbSlider && this.settings.slickThumbInitialized) {
            this.$thumbSlider.slick('setPosition');
          }
        }.bind(this),500); // same timing as modal open transition
      },

      _slideIndex: function($el) {
        return $el.data('index');
      },

      initQtySelector: function() {
        this.$container.find('.js-qty__wrapper').each(function() {
          new theme.QtySelector($(this),{
            namespace: '.product'
          });
        });
      },

      initAjaxProductForm: function() {
        if (theme.settings.cartType === 'drawer') {
          new theme.AjaxProduct($(this.selectors.formContainer));
        }
      },

      openModalProduct: function() {alert("dd");
        if (!this.settings.modalInit) {
          var $formHolder = $(this.selectors.modalFormHolder);
          var url = $formHolder.data('url');
          url = url + '?view=ajax';

          $formHolder.load(url + ' #AddToCartForm-' + this.sectionId,function() {
            $formHolder.addClass('is-active');
            this.formSetup();
            if (Shopify.PaymentButton) {
              Shopify.PaymentButton.init();
            }
          }.bind(this));

          this.productSetup();
          this.loadModalContent();
          this.createImageCarousels();
          this.settings.modalInit = true;
        }

        this.resizeSlides();

        // Add product id to recently viewed array
        //this.addIdToRecentlyViewed();
      },

      closeModalProduct: function() {
        this.stopVideo();
        $('body').off(this.settings.namespace);
        $(window).off(this.settings.namespace);
      },

      loadModalContent: function() {
        // Load videos if they exist
        var videoTypes = this.checkIfVideos();

        // Lazyload mp4 videos similar to images
        if (videoTypes && videoTypes.indexOf('mp4') > -1) {
          this.$modal.find('.product__video[data-video-type="mp4"]').each(function(i,video) {
            var $el = $(video);
            var src = $el.data('video-src');
            var source = document.createElement('source');
            source.setAttribute('src',src);
            $el.append(source);
          }.bind(this));
        }
      },

      onUnload: function() {
        this.$container.off(this.settings.namespace);
        $('body').off(this.settings.namespace);
        this.destroyImageCarousels();
      }
    });

    return Product;
  })();

  theme.HeaderSection = (function() {

    var selectors = {
      drawer: '#NavDrawer',
      mobileSubNavToggle: '.mobile-nav__toggle-btn',
      hasSublist: '.mobile-nav__has-sublist'
    };

    var classes = {
      navExpanded: 'mobile-nav--expanded'
    };

    function Header(container) {
      var $container = this.$container = $(container);
      var sectionId = this.sectionId = $container.attr('data-section-id');

      // Reload any slideshow if when the header is reloaded to make sure the
      // sticky header works as expected
      theme.reinitSection('slideshow-section');

      theme.currencySwitcher.init();
      this.initDrawers();
      theme.headerNav.init();
      theme.announcementBar.init();

      // Set a timer to resize the header in case the logo changes size
      if (Shopify.designMode) {
        setTimeout(function() {
          $('body').trigger('resize');
        },500);
      }
    }

    Header.prototype = Object.assign({},Header.prototype,{
      initDrawers: function() {
        theme.NavDrawer = new theme.Drawers('NavDrawer','nav');
        if (theme.settings.cartType === 'drawer') {
          new theme.CartDrawer();
        }

        this.drawerMenuButtons();
      },

      drawerMenuButtons: function() {
        $(selectors.drawer).find('.js-drawer-close').on('click',function(evt) {
          evt.preventDefault();
          theme.NavDrawer.close();
        });

        var $mobileSubNavToggle = $(selectors.mobileSubNavToggle);

        $mobileSubNavToggle.attr('aria-expanded','false');
        $mobileSubNavToggle.each(function(i,el) {
          var $el = $(el);
          $el.attr('aria-controls',$el.attr('data-aria-controls'));
        });

        $mobileSubNavToggle.on('click',function() {
          var $el = $(this);
          var currentlyExpanded = $el.attr('aria-expanded');
          var toggleState = false;

          // Updated aria-expanded value based on state pre-click
          if (currentlyExpanded === 'true') {
            $el.attr('aria-expanded','false');
          } else {
            $el.attr('aria-expanded','true');
            toggleState = true;
          }

          // Toggle class that expands/collapses sublist
          $el.closest(selectors.hasSublist).toggleClass(classes.navExpanded,toggleState);
        });
      },

      onBlockSelect: function(evt) {
        theme.announcementBar.onBlockSelect(evt.detail.blockId);
      },

      onDeselect: function() {
        theme.announcementBar.onBlockDeselect();
      },

      onUnload: function() {
        theme.NavDrawer.close();
        theme.headerNav.unload();
        theme.announcementBar.unload();
      }
    });

    return Header;

  })();

  theme.slideshows = {};

  theme.SlideshowSection = (function() {

    var selectors = {
      parallaxContainer: '.parallax-container'
    };

    function SlideshowSection(container) {
      var $container = this.$container = $(container);
      var $section = $container.parent();
      var sectionId = $container.attr('data-section-id');
      var slideshow = this.slideshow = '#Slideshow-' + sectionId;
      this.namespace = '.' + sectionId;

      var $imageContainer = $(container).find('.hero');
      if ($imageContainer.length) {
        theme.loadImageSection($imageContainer);
      }

      this.init();

      if ($container.data('parallax')) {
        var args = {
          namespace: this.namespace
        };
        theme.parallaxSections[this.namespace] = new theme.Parallax($container.find(selectors.parallaxContainer),args);
      }
    }

    SlideshowSection.prototype = Object.assign({},SlideshowSection.prototype,{
      init: function() {
        // Prevent slideshows from initializing on top of themselves
        this.onUnload();

        var $slideshow = $(this.slideshow);
        var args = {
          autoplay: $slideshow.data('autoplay'),
          arrows: $slideshow.data('arrows'),
          dots: $slideshow.data('dots'),
          fade: true,
          speed: 500 // same as $slideshowImageAnimationSpeed in CSS
        };

        theme.slideshows[this.slideshow] = new theme.Slideshow(this.slideshow,args);
      },

      forceReload: function() {
        this.init();
      },

      onUnload: function() {
        if (theme.parallaxSections[this.namespace]) {
          theme.parallaxSections[this.namespace].destroy();
          delete theme.parallaxSections[this.namespace];
        }
        if (theme.slideshows[this.slideshow]) {
          theme.slideshows[this.slideshow].destroy();
          delete theme.slideshows[this.slideshow];
        }
      },

      onSelect: function() {
        $(this.slideshow).slick('slickPause');
      },

      onDeselect: function() {
        $(this.slideshow).slick('slickPlay');
      },

      onBlockSelect: function(evt) {
        var $slideshow = $(this.slideshow);

        // Ignore the cloned version
        var $slide = $('.slideshow__slide--' + evt.detail.blockId + ':not(.slick-cloned)');
        var slideIndex = $slide.data('slick-index');

        // Go to selected slide, pause autoplay
        $slideshow.slick('slickGoTo',slideIndex).slick('slickPause');
      },

      onBlockDeselect: function() {
        $(this.slideshow).slick('slickPlay');
      }
    });

    return SlideshowSection;
  })();

  theme.VideoSection = (function() {
    var youtubeReady;
    var videos = [];
    var youtubePlayers = [];
    var youtubeVideoOptions = {
      width: 1280,
      height: 720,
      playerVars: {
        autohide: 0,
        branding: 0,
        cc_load_policy: 0,
        controls: 0,
        fs: 0,
        iv_load_policy: 3,
        modestbranding: 1,
        playsinline: 1,
        quality: 'hd720',
        rel: 0,
        showinfo: 0,
        wmode: 'opaque'
      },
      events: {
        onReady: onVideoPlayerReady,
        onStateChange: onVideoStateChange
      }
    };

    var vimeoReady = false;
    var vimeoVideoOptions = {
      byline: false,
      title: false,
      portrait: false,
      loop: true
    };

    var selectors = {
      videoParent: '.video-parent-section'
    };

    var classes = {
      loading: 'loading',
      loaded: 'loaded',
      interactable: 'video-interactable'
    };

    function videoSection(container) {
      var $container = this.$container = $(container);
      var sectionId = this.sectionId = $container.attr('data-section-id');
      var youtubePlayerId = this.youtubePlayerId = 'YouTubeVideo-' + this.sectionId;
      this.namespace = '.' + youtubePlayerId;
      var vimeoPlayerId = this.vimeoPlayerId = 'Vimeo-' + this.sectionId;
      var $vimeoTrigger = this.$vimeoTrigger = $('#VimeoTrigger-' + this.sectionId);
      var mp4Video = 'Mp4Video-' + this.sectionId;

      var $youtubeDiv = $('#' + youtubePlayerId);
      var $vimeoDiv = $('#' + vimeoPlayerId);
      var $mp4Div = $('#' + mp4Video);

      this.vimeoPlayer = [];

      if ($youtubeDiv.length) {
        this.youtubeVideoId = $youtubeDiv.data('video-id');
        this.initYoutubeVideo();
      }

      if ($vimeoDiv.length) {
        this.vimeoVideoId = $vimeoDiv.data('video-id');
        this.initVimeoVideo();
      }

      if ($mp4Div.length) {
        setParentAsLoaded($mp4Div);

        startMp4Playback(mp4Video).then(function() {
          // Video played as expected, don't do anything
        }).catch(function(error) {
          // Video cannot be played with autoplay, so let
          // user interact with video element itself
          setVideoToBeInteractedWith($mp4Div);
        });
      }
    }

    function startMp4Playback(mp4Video) {
      return document.querySelector('#' + mp4Video).play();
    }

    function onVideoPlayerReady(evt) {
      var $player = $(evt.target.a);
      var playerId = $player.attr('id');
      youtubePlayers[playerId] = evt.target; // update stored player
      var player = youtubePlayers[playerId];

      setParentAsLoading($player);

      youtubePlayers[playerId].mute();

      // Remove from tabindex because YouTube iframes are annoying and you can focus
      // on the YouTube logo and it breaks
      $player.attr('tabindex','-1');

      // Add out of view pausing
      videoVisibilityCheck(playerId);
      $(window).on('scroll.' + playerId,{ id: playerId },$.throttle(150,videoVisibilityCheck));
    }

    function videoVisibilityCheck(id) {
      var playerId;

      if (typeof id === 'string') {
        playerId = id;
      } else {
        // Data comes in as part of the scroll event
        playerId = id.data ? id.data.id : false;
      }

      if (playerId) {
        if (theme.isElementVisible($('#' + playerId))) {
          playVisibleVideo(playerId);
        } else {
          pauseHiddenVideo(playerId);
        }
      }
    }

    function playVisibleVideo(id) {
      if (youtubePlayers[id] && typeof youtubePlayers[id].playVideo === 'function') {
        youtubePlayers[id].playVideo();
      }
    }

    function pauseHiddenVideo(id) {
      if (youtubePlayers[id] && typeof youtubePlayers[id].pauseVideo === 'function') {
        youtubePlayers[id].pauseVideo();
      }
    }

    function onVideoStateChange(evt) {
      var $player = $(evt.target.a);
      var playerId = $player.attr('id');
      var player = youtubePlayers[playerId];

      switch (evt.data) {
        case -1: // unstarted
          // Handle low power state on iOS by checking if
          // video is reset to unplayed after attempting to buffer
          if (videos[playerId].attemptedToPlay) {
            setParentAsLoaded($player);
            setVideoToBeInteractedWith($player);
          }
          break;
        case 0: // ended
          player.playVideo();
          break;
        case 1: // playing
          setParentAsLoaded($player);
          break;
        case 3: // buffering
          videos[playerId].attemptedToPlay = true;
          break;
      }
    }

    function setParentAsLoading($el) {
      $el
        .closest(selectors.videoParent)
        .addClass(classes.loading);
    }

    function setParentAsLoaded($el) {
      $el
        .closest(selectors.videoParent)
        .removeClass(classes.loading)
        .addClass(classes.loaded);
    }

    function setVideoToBeInteractedWith($el) {
      $el
        .closest(selectors.videoParent)
        .addClass(classes.interactable);
    }

    videoSection.prototype = Object.assign({},videoSection.prototype,{
      initYoutubeVideo: function() {
        videos[this.youtubePlayerId] = {
          id: this.youtubePlayerId,
          videoId: this.youtubeVideoId,
          type: 'youtube',
          attemptedToPlay: false
        };

        if (!youtubeReady) {
          window.loadYouTube();
          $('body').on('youTubeReady' + this.namespace,this.loadYoutubeVideo.bind(this));
        } else {
          this.loadYoutubeVideo();
        }
      },

      loadYoutubeVideo: function() {
        var args = Object.assign({},youtubeVideoOptions,videos[this.youtubePlayerId]);
        args.playerVars.controls = 0;
        youtubePlayers[this.youtubePlayerId] = new YT.Player(this.youtubePlayerId,args);

        youtubeReady = true;
      },

      initVimeoVideo: function() {
        videos[this.vimeoPlayerId] = {
          divId: this.vimeoPlayerId,
          id: this.vimeoVideoId,
          type: 'vimeo'
        };

        var $player = $('#' + this.vimeoPlayerId);
        setParentAsLoading($player);

        // Button to play video on mobile
        this.$vimeoTrigger.on('click',+ this.namespace,function(evt) {
          // $(evt.currentTarget).addClass('hide');
          this.requestToPlayVimeoVideo(this.vimeoPlayerId);
        }.bind(this));

        if (!vimeoReady) {
          window.loadVimeo();
          $('body').on('vimeoReady' + this.namespace,this.loadVimeoVideo.bind(this));
        } else {
          this.loadVimeoVideo();
        }
      },

      loadVimeoVideo: function() {
        var args = Object.assign({},vimeoVideoOptions,videos[this.vimeoPlayerId]);
        this.vimeoPlayer[this.vimeoPlayerId] = new Vimeo.Player(videos[this.vimeoPlayerId].divId,args);

        vimeoReady = true;

        // Only autoplay on larger screens
        if (!theme.config.bpSmall) {
          this.requestToPlayVimeoVideo(this.vimeoPlayerId);
        } else {
          var $player = $('#' + this.vimeoPlayerId);
          setParentAsLoaded($player);
        }
      },

      requestToPlayVimeoVideo: function(id) {
        // The slider may initialize and attempt to play the video before
        // the API is even ready, because it sucks.

        if (!vimeoReady) {
          // Wait for the trigger, then play it
          $('body').on('vimeoReady' + this.namespace,function() {
            this.playVimeoVideo(id);
          }.bind(this));
          return;
        }

        this.playVimeoVideo(id);
      },

      playVimeoVideo: function(id) {
        this.vimeoPlayer[id].play();
        this.vimeoPlayer[id].setVolume(0);

        var $player = $('#' + id);
        setParentAsLoaded($player);
      },

      onUnload: function(evt) {
        var sectionId = evt.target.id.replace('shopify-section-','');
        var playerId = 'YouTubeVideo-' + sectionId;
        youtubePlayers[playerId].destroy();
        $(window).off('scroll' + this.namespace);
        $('body').off('vimeoReady' + this.namespace);
      }
    });

    return videoSection;
  })();
  theme.StoreAvailability = (function() {

    var selectors = {
      storeAvailabilityModalOpen: '[data-store-availability-modal-open]',
      storeAvailabilityModalProductTitle:
        '[data-store-availability-modal-product-title]',
      storeAvailabilityModalVariantTitle:
        '[data-store-availability-modal-variant-title]'
    };

    var classes = {
      hidden: 'hide'
    };

    function StoreAvailability(container) {
      if (this.container == undefined)
        return;
      this.container = container;
      this.productTitle = this.container[0].dataset.productTitle;
      this.hasOnlyDefaultVariant = this.container[0].dataset.hasOnlyDefaultVariant === 'true';
    }

    StoreAvailability.prototype = Object.assign({},StoreAvailability.prototype,{

      updateContent: function(variant) {     
        $("#store-container").hide();

        fetch(window.Shopify.routes.root + "variants/" + variant.id + "/?section_id=pickup-availability")
        .then(response => response.text())
        .then(text => {
          console.log(text); 
          //const container = document.querySelector('[data-store-availability-container]');
          const pickupAvailabilityHTML = new DOMParser()
            .parseFromString(text, 'text/html')
            .querySelector('.shopify-section');
          if (text.indexOf("<li") > -1)
          {
            $("#store-availabilities-list-wrap").html(pickupAvailabilityHTML);
            let fli = $("#store-availabilities-list h3:first").html();
            let lititle = $("#store-availabilities-list").data("title");
            let storeAvailabilityModalOpen = $("#store-availability-modal-open");          
            $("#store-availability-information__title").text(`Pickup at ${fli} available during checkout.`).show();
            storeAvailabilityModalOpen.click(function() {
              $("#StoreAvailabilityModal").show().toggleClass("store-availabilities-modal--active");
            });
            $(".store-availabilities-modal__close").click(function() {
              $("#StoreAvailabilityModal").toggleClass("store-availabilities-modal--active").hide();
            });
            $("#store-availabilities-modal__variant-title").text(lititle);
            storeAvailabilityModalOpen.show();
            $("#store-container").show();
          }
        })
        .catch(e => {
          console.error(e);
        });
      },
      clearContent: function() {
        this.container.innerHTML = '';
      },
      _hideVariantTitle: function() {
        $("#StoreAvailabilitiesModalProductTitle").hide();
      }
    });

    return StoreAvailability;
  })();

  theme.BackgroundImage = (function() {

    var selectors = {
      parallaxContainer: '.parallax-container'
    };

    function backgroundImage(container) {
      var $container = $(container);
      var sectionId = $container.attr('data-section-id');
      this.namespace = '.' + sectionId;

      if (!$container.length) {
        return;
      }

      if ($container.data('parallax')) {
        var $parallaxContainer = $container.find(selectors.parallaxContainer);
        var args = {
          namespace: this.namespace,
          desktopOnly: true
        };

        theme.parallaxSections[this.namespace] = new theme.Parallax($parallaxContainer,args);
      }
    }

    backgroundImage.prototype = Object.assign({},backgroundImage.prototype,{
      onUnload: function(evt) {
        theme.parallaxSections[this.namespace].destroy();
        delete theme.parallaxSections[this.namespace];
      }
    });

    return backgroundImage;
  })();

  // Medium breakpoint is also set in theme.scss.liquid and inline throughout some templates.
  // Do not change values unless you know what you're doing.
  theme.bp = {};
  theme.bp.smallUp = 769;
  theme.bp.small = theme.bp.smallUp - 1;

  theme.config = {
    bpSmall: false,
    hasSessionStorage: true,
    mediaQuerySmall: 'screen and (max-width: ' + theme.bp.small + 'px)',
    mediaQuerySmallUp: 'screen and (min-width: ' + theme.bp.smallUp + 'px)',
    youTubeReady: false,
    vimeoReady: false,
    vimeoLoading: false,
    isTouch: ('ontouchstart' in window) || window.DocumentTouch && window.document instanceof DocumentTouch || window.navigator.maxTouchPoints || window.navigator.msMaxTouchPoints ? true : false,
    isIpad: /ipad/.test(window.navigator.userAgent.toLowerCase()),
    stickyHeader: false,
    recentlyViewed: []
  };

  if (theme.config.isIpad) {
    document.documentElement.className += ' js-ipad';
  }

  theme.recentlyViewed = {
    recent: {}, // will store handle+url of recent products
    productInfo: {} // will store product data to reduce API calls
  };

  window.onYouTubeIframeAPIReady = function() {
    theme.config.youTubeReady = true;
    $('body').trigger('youTubeReady');
  };

  window.loadYouTube = function() {
    if (theme.config.youtubeReady) {
      return;
    }

    var tag = document.createElement('script');
    tag.src = "https://www.youtube.com/iframe_api";
    var firstScriptTag = document.getElementsByTagName('script')[0];
    firstScriptTag.parentNode.insertBefore(tag,firstScriptTag);
  };

  window.loadVimeo = function() {
    if (theme.config.vimeoLoading) {
      return;
    }

    if (!theme.config.vimeoReady) {
      theme.config.vimeoLoading = true;
      var tag = document.createElement('script');
      tag.src = "https://player.vimeo.com/api/player.js";
      var firstScriptTag = document.getElementsByTagName('script')[0];
      firstScriptTag.parentNode.insertBefore(tag,firstScriptTag);

      // Because there's no way to check for the Vimeo API being loaded
      // asynchronously, we use this terrible timeout to wait for it being ready
      checkIfVimeoIsReady()
        .then(function() {
          theme.config.vimeoReady = true;
          theme.config.vimeoLoading = false;
          $('body').trigger('vimeoReady');
        })
        .fail(function() {
          // No vimeo API to talk to
        });
    }
  };

  function checkIfVimeoIsReady() {
    var deferred = $.Deferred();
    var wait;
    var timeout;

    wait = setInterval(function() {
      if (!Vimeo) {
        return;
      }

      clearInterval(wait);
      clearTimeout(timeout);
      deferred.resolve();
    },500);

    timeout = setTimeout(function() {
      clearInterval(wait);
      deferred.reject();
    },4000); // subjective. test up to 8 times over 4 seconds

    return deferred;
  }

  theme.init = function() {
    theme.setGlobals();
    theme.pageTransitions();
    theme.collapsibles.init();
    slate.rte.init();

    AOS.init({
      easing: 'ease-out-quad',
      once: true,
      offset: 60,
      disableMutationObserver: true
    });

    $(document.documentElement).on('keyup.tab',function(evt) {
      if (evt.keyCode === 9) {
        $(document.documentElement).addClass('tab-outline');
        $(document.documentElement).off('keyup.tab');
      }
    });

    // Change email icon to submit text
    $('.footer__newsletter-input').on('keyup',function() {
      $(this).addClass('footer__newsletter-input--active');
    });
  };

  theme.initSecondary = function() {
    //theme.initQuickShop();
    //theme.collectionTemplate.init();
    theme.customerTemplates.init();
    theme.videoModal();
  };

  theme.setGlobals = function() {
    theme.config.hasSessionStorage = theme.isSessionStorageSupported();
    // theme.recentlyViewed.handleCookie = Cookies.get('theme-recent');
    // if (theme.recentlyViewed.handleCookie) {
    //   theme.recentlyViewed.recent = JSON.parse(theme.recentlyViewed.handleCookie);
    // }

    // theme.recentlyViewed.productInfo = theme.config.hasSessionStorage && sessionStorage['recent-products'] ? JSON.parse(sessionStorage['recent-products']) : {};

    if (theme.config.isTouch) {
      $('body').addClass('supports-touch');
    }

    enquire.register(theme.config.mediaQuerySmall,{
      match: function() {
        theme.config.bpSmall = true;
        $('body').trigger('matchSmall');
      },
      unmatch: function() {
        theme.config.bpSmall = false;
        $('body').trigger('unmatchSmall');
      }
    });

    enquire.register(theme.config.mediaQuerySmallUp,{
      match: function() {
        $('body').trigger('matchLarge');
      },
      unmatch: function() {
        $('body').trigger('unmatchLarge');
      }
    });
  };

  theme.loadImageSection = function($container) {
    // Wait until images inside container have lazyloaded class
    function setAsLoaded() {
      $container.removeClass('loading loading--delayed').addClass('loaded');
    }

    function checkForLazyloadedImage() {
      return $container.find('.lazyloaded').length;
    }

    // If it has SVGs it's in the onboarding state so set as loaded
    if ($container.find('svg').length) {
      setAsLoaded();
      return;
    };

    if (checkForLazyloadedImage() > 0) {
      setAsLoaded();
      return;
    }

    var interval = setInterval(function() {
      if (checkForLazyloadedImage() > 0) {
        clearInterval(interval);
        setAsLoaded();
      }
    },80);
  };

  theme.isSessionStorageSupported = function() {
    // Return false if we are in an iframe without access to sessionStorage
    if (window.self !== window.top) {
      return false;
    }

    var testKey = 'test';
    var storage = window.sessionStorage;
    try {
      storage.setItem(testKey,'1');
      storage.removeItem(testKey);
      return true;
    } catch (error) {
      return false;
    }
  };

  theme.isElementVisible = function($el,threshold) {
    var rect = $el[0].getBoundingClientRect();
    var windowHeight = window.innerHeight || document.documentElement.clientHeight;
    threshold = threshold ? threshold : 0;

    return (
      rect.bottom >= 0 &&
      rect.right >= 0 &&
      rect.top <= (windowHeight + threshold) &&
      rect.left <= (window.innerWidth || document.documentElement.clientWidth)
    );
  };

  theme.pageTransitions = function() {
    if ($('body').data('transitions') == true) {
      var namespace = '.page-transition';

      // Hack test to fix Safari page cache issue.
      // window.onpageshow doesn't always run when navigating
      // back to the page, so the unloading class remains, leaving
      // a white page. Setting a timeout to remove that class when leaving
      // the page actually finishes running when they come back.
      if (!!navigator.userAgent.match(/Version\/[\d\.]+.*Safari/)) {
        $('a').off(namespace).on('click' + namespace,function() {
          window.setTimeout(function() {
            $('body').removeClass('unloading');
          },1200);
        });
      }

      // Add disable transition class to malito, anchor, and YouTube links
      $('a[href^="mailto:"], a[href^="#"], a[target="_blank"], a[href*="youtube.com/watch"], a[href*="youtu.be/"]').each(function() {
        $(this).addClass('js-no-transition');
      });

      $('a:not(.js-no-transition)').off(namespace).on('click' + namespace,function(evt) {
        if (evt.metaKey) return true;
        evt.preventDefault();
        $('body').addClass('unloading');
        var src = $(this).attr('href');
        window.setTimeout(function() {
          location.href = src;
        },50);
      });

      // iOS caches the page state, so close the drawer when navigating away
      $('a.mobile-nav__link').off(namespace).on('click' + namespace,function() {
        theme.NavDrawer.close();
      });
    }
  };

  theme.reinitSection = function(section) {
    for (var i = 0; i < sections.instances.length; i++) {
      var instance = sections.instances[i];
      if (instance['type'] === section) {
        if (typeof instance.forceReload === 'function') {
          instance.forceReload();
        }
      }
    }
  };

  theme.reinitProductGridItem = function($scope) {
    if (AOS) {
      AOS.refreshHard();
    }

    // Refresh currency
    if (theme.settings.currenciesEnabled) {
      theme.currencySwitcher.ajaxrefresh();
    }

    // Reload quick shop buttons
    theme.initQuickShop(true);

    // Refresh reviews app
    if (window.SPR) {
      SPR.initDomEls(); SPR.loadBadges();
    }

    // Re-register product templates in quick view modals.
    // Will not double-register.
    sections.register('product-template',theme.Product,$scope);

    // Re-hook up collapsible box triggers
    theme.collapsibles.init();

  };
  function keeloLinks() {
    window.categories.forEach(element => {
      $('.keelodiv').append("<li class='tag'><a href='" + element.url + "'>" + element.name + "</a></li>");
    });
  }
  window.onpageshow = function(evt) {
    // Removes unload class when returning to page via history
    if (evt.persisted) {
      $('body').removeClass('unloading');
    }
  };

  $(document).ready(function() {
    if (window.location.href.indexOf("/orders/") == -1 && isMobileApp() && window.location.href.indexOf("/checkouts/") == -1) {
      $('div[data-section-id="header"]').hide();
      $('.site-footer').hide();
    }
    theme.init();
    window.sections = new theme.Sections();
    sections.register('header-section',theme.HeaderSection);
    sections.register('slideshow-section',theme.SlideshowSection);
    sections.register('video-section',theme.VideoSection);
    sections.register('background-image',theme.BackgroundImage);
    //sections.register('recently-viewed', theme.RecentlyViewed);
    //sections.register('product',theme.Product);
    //sections.register('product-recommendations', theme.Recommendations);
    sections.register('product-template',theme.Product);

    theme.initSecondary();

    //window.setTimeout(function() { observeAdPlacements(); },3500);
  });
})(theme.jQuery);

function observeAdPlacements() {
  let oAds = document.querySelectorAll('.ad-placement');
  oAds.forEach(ad => adsObserver.observe(ad));
}

function slScroll2(e,d,tileWidth) {
  let contentWidth = ($("#" + e).find(".grid__item_tile").length / 2) * tileWidth;
  var maxScroll = contentWidth - $("#" + e).width() - 46;
  let dir = d + "=" + $("#" + e).width();
  $("#" + e).animate({ scrollLeft: dir },500,"swing",function() {
    if ($("#" + e).scrollLeft() > 0) {
      $("#" + e).parent().find(".arrowLeft").show();
    }
    else {
      $("#" + e).parent().find(".arrowLeft").hide();
    }
    if ($("#" + e).scrollLeft() >= maxScroll) {
      $("#" + e).parent().find(".arrowRight").hide();
    }
    else {
      $("#" + e).parent().find(".arrowRight").show();
    }
  });
}

function isMobileApp() {
  if (navigator.userAgent.indexOf("com.branding") > -1 || navigator.userAgent.indexOf("com.shop") > -1)
    return true;
  return false;
}

// var adsObserver = new IntersectionObserver(handleAdsIntersection,{
//   root: null,
//   threshold: .5
// });
// function handleAdsIntersection(entries,observer) {
//   entries.forEach(entry => {
//     if (entry.intersectionRatio > 0) {
//       _satellite.track("AdPlacement_View",{ "locationId": entry.target.getAttribute('data-ad-placement-id') });
//       observer.unobserve(entry.target);
//     }
//   });
// }


function lookCategoryFilter(e)
{
  $("#looksHeadingTitle").remove();
  $("#lookCategoryFilterSel").remove();
  window.lookcurrentPage = 0;
  window.lookCurrentCategory = $(e).val();
  pLoadLooks();
}
function loadMoreLooks(e){
  $(e).parent().html("<div id='lookLoader'><div class='looksloader'></div></div>");
  window.lookcurrentPage++;
  let searchParams = new URLSearchParams(window.location.search);
  let cat = "";
  if (searchParams.has("occasion"))
  {
    cat = searchParams.get("occasion");
  }
  else if (searchParams.has("style"))
  {
    cat = searchParams.get("style");
  }
  //_satellite.track("LooksLoadMore_click", { "categoryId":cat });
  pLoadLooks();
}

  function loadLookCarousel(tid, elementId, title, location, type, carousel)
  {
    if (!window.lookcurrentPage)
      window.lookcurrentPage = 0;
    if (!window.lookCurrentCategory)
      window.lookCurrentCategory = "All";
    let idsToSuppress = "";
    let post = {"action":"loadlooksByCategory","category":tid.toString().replace(/'/g, "\\'")};
    if (location == "PDP")
      post = {"action":"loadPDPLooks","id":tid, "currentPage": window.lookcurrentPage, "numPerpage": 10};
    //if (location == "focus")
      //post = {"action":"loadLook","id":tid, "showOOS":true};

    let lcount = carousel == true ? 7 : 12;
    let isAdmin = false;
    if (location == "admin"){
      lcount = 12;
      isAdmin = true;
    }
    switch(type)
    {
      case "style":
        post = {"action":"loadlooksByStyle","style":tid, "currentPage": window.lookcurrentPage, "numPerpage": lcount, "carousel":carousel,"isAdmin": isAdmin};
        break;
      case "occasion":
        if (tid == "inspiredBy")
        {
          let recentlyViewed = getCookie("recentlyViewed");
          if (recentlyViewed == "")
            return;
          let j = [];
          for (let rv of JSON.parse(recentlyViewed).reverse())
          {
            if (!j.includes(rv.type))
              j.push(rv.type);
          }
          post = {"action":"loadInspiredBy","types":j.join(","),"currentPage": window.lookcurrentPage, "numPerpage": lcount, "carousel":carousel, "categoryFilter":window.lookCurrentCategory,"isAdmin": isAdmin};
        }
        else
        {
          post = {"action":"loadlooksByOccasion","occasion":tid, "currentPage": window.lookcurrentPage, "numPerpage": lcount, "carousel":carousel, "categoryFilter":window.lookCurrentCategory,"isAdmin": isAdmin};
        }
        break;
    }
    //console.log(JSON.stringify(post));
    $.get( window.lookURL+ "&tid=" + post.action + "&data=" + JSON.stringify(post))
    .done(function( data )
    {
      let originalTid = tid;
      tid = tid.toString().replace(/\s/g, '-').replace(/\'s/g, '');
      let parsed = JSON.parse(data);
      let count = 300;
      let hasSupressed = false;
      if(parsed && parsed.length > 0)
      {
        //console.log(JSON.stringify(parsed[0].Products));
        let initialSlide = 0;
        for (let p=0;p<parsed.length;p++)
        {
          if (idsToSuppress.includes(parsed[p].id))
          {
            hasSupressed=true;
            continue;
          }
          let html="";
          let herocheckedstyle = "";
          for (let x=0;x<6;x++)
          {
            let hero = "";
            let hero2 = "";
            if (x==0 && parsed[p].HeroEnabled)
            {
              hero=" lookheroimg";
              hero2=" lookInsideHero";
            }
            if (x==1 && parsed[p].HeroEnabled1)
            {
              hero=" lookheroimg";
              hero2=" lookInsideHero";
            }
            if (x==2 && parsed[p].HeroEnabled2)
            {
              hero=" lookheroimg";
              hero2=" lookInsideHero";
            }
            if (x==3 && parsed[p].HeroEnabled3)
            {
              hero=" lookheroimg";
              hero2=" lookInsideHero";
            }
            if (parsed[p].HeroEnabled1 && !parsed[p].HeroEnabled)
            {
              if (x==2)
                herocheckedstyle = " shortenafterhero";
              if (x==3 && !parsed[p].HeroEnabled2)
                herocheckedstyle = " clear-both";
            }
            if (parsed[p].HeroEnabled3 && !parsed[p].HeroEnabled2)
            {
              if (x==4)
                herocheckedstyle = " shortenafterhero";
              if (x==5)
                herocheckedstyle = " clear-both";
            }
            if (parsed[p].HeroEnabled2 && parsed[p].HeroEnabled)
            {
              if (x==3)
                herocheckedstyle = " shortenafterhero";
            }

            let gotOne = false;
            for (let item of parsed[p].Products)
            {
              if (item.Position.startsWith(x.toString()))
              {
                if (!gotOne){
                  html+=`<div class="${parsed[p].id+tid} lookInside${hero2}${herocheckedstyle}">`;
                  gotOne = true;
                }
                let mOpen = `LookPop('${item.Handle}',${item.Id}, '${parsed[p].id}', '${parsed[p].StylistId}', '${tid}',false,'${item.Brand.replace("'","")}');`;

                  if(item.Id == tid)
                    mOpen = `animateToTop();`;

                  let pstring = "<span class='lookprice'>$" + numberWithCommasLooks(Number(item.Price).toFixed(2)) + "</span>";
                  if (item.Price < item.MSRP)
                      pstring += "&nbsp;&nbsp;<span class='lookpricemsrp'>$" + numberWithCommasLooks(Number(item.MSRP).toFixed(2)) + "</span>";
                  if (!item.Active){
                    pstring = "Sold Out";
                    mOpen = "void(0);";
                  }
                  html+=`<a aria-disabled="true" href="javascript:${mOpen}" style="display:block;margin-bottom: 50px;" class="aa_look ${hero}" data-id="${item.Id}"><div class="lookWrap ${hero}" style="background-image:url('${item.Image}')"></div><div class="lookPDPbrand"><div style="overflow: hidden;max-height: 20px;">${item.Brand}</div>${pstring}</div></a>`;
                  continue;
              }
            }
            if (gotOne)
              html+="</div>";
            herocheckedstyle="";
          }
          let lclass = "";
          let mtf = "";
          if (location == "admin")
            mtf = `<span onclick='mtf("${parsed[p].id}", "look-${elementId}-${parsed[p].id}","${elementId}",this)' style="cursor:pointer">mtf</span>`;
          if (!carousel)
          {
            lclass = "noncarousellook";
          }
          $("#" + elementId).append(`<div class="lookPDPProducts ${lclass} zerovis" data-categories="${parsed[p].Category.join(",")}" id="look-${elementId}-${parsed[p].id}">${mtf}<div class='lookCardTitle'>${parsed[p].LookTitle}</div><div style="font-size: 13px;display:none">by <b>${parsed[p].StylistId}</b></div>${html}</div>`);

            //setTimeout(addSlickMini,count+200,parsed[p].id+tid,tid, parsed[p].id, parsed[p].StylistId);
        }

        if (hasSupressed && parsed.length == 1)
        {
        }
        else
        {
          if (window.lookcurrentPage == 0)
          {
            let gridTitle = carousel ? "lookTitle" : "looksGridTitle";
            let gridTitleSub = carousel ? "lookCarTitleSub1" : "lookCarTitleSub2";
            let hTitle = title + " Looks";
            if (title == "inspiredBy")
              hTitle = "Inspired by Your Browsing";
            $("#" + elementId).before(`<div class="nosto-heading" id="looksHeadingTitle"><h3 class="${gridTitle}">${hTitle}</h3><div class="${gridTitleSub}" id="lookTitleSubText">View a style for options and to see similar styles</div></div>`);
            if (!carousel && title != "inspiredBy")
            {
              let post = {"action":"categoriesByOccasionGet","occasion":originalTid};
              $.get( window.lookURL + "&data=" + JSON.stringify(post))
              .done(function( data )
              {
                data = JSON.parse(data);
                let s = "<div id='lookCategoryFilterSelWrap'>filter: <select onchange='lookCategoryFilter(this);' id='lookCategoryFilterSel'><option>All</option><div style='clear:both'></div>";
                for (let c of data)
                {
                    let selected = "";
                    if(window.lookCurrentCategory == c.category)
                      selected = " selected";
                    s+=`<option ${selected}>${c.category}</option>`;
                }
                s+="</select></div>";
                $("#lookTitleSubText").before(s);
              });
            }
          }

          if (carousel)
          {
            $("#" + elementId).after(`<a class="buttons prev slick-arrow slick-disabled look-arrow" href="#" onclick="lookCarouselArrowClick('${tid}')" data-category="${tid}" data-no-instant="true" aria-disabled="true" id="prev-${tid}"><div class="nosto-recommendation-arrow"><svg width="12" height="23" viewBox="0 0 12 23" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M12.0123 11.5123C12.01 11.777 11.9049 12.0305 11.7193 12.2193L1.71929 22.2193C1.53069 22.4014 1.27808 22.5022 1.01589 22.5C0.75369 22.4977 0.502878 22.3925 0.31747 22.2071C0.132062 22.0217 0.0268924 21.7709 0.0246139 21.5087C0.0223355 21.2465 0.12313 20.9939 0.305288 20.8053L9.59829 11.5123L0.305288 2.21929C0.209778 2.12704 0.133596 2.0167 0.0811869 1.89469C0.0287779 1.77269 0.00119157 1.64147 3.7757e-05 1.50869C-0.00111606 1.37591 0.0241854 1.24423 0.0744663 1.12134C0.124747 0.99844 0.199 0.886787 0.292893 0.792894C0.386786 0.699001 0.498438 0.624748 0.621334 0.574467C0.74423 0.524185 0.87591 0.498884 1.00869 0.500038C1.14147 0.501192 1.27269 0.52878 1.39469 0.581188C1.5167 0.633596 1.62704 0.709778 1.71929 0.805288L11.7193 10.8053C11.9049 10.9941 12.01 11.2475 12.0123 11.5123Z" fill="black"></path></svg></div></a><a class="buttons next slick-arrow look-arrow" href="#" onclick="lookCarouselArrowClick('${tid}')" data-category="${tid}" data-no-instant="true" aria-disabled="false" id="next-${tid}"><div class="nosto-recommendation-arrow"><svg width="12" height="23" viewBox="0 0 12 23" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M12.0123 11.5123C12.01 11.777 11.9049 12.0305 11.7193 12.2193L1.71929 22.2193C1.53069 22.4014 1.27808 22.5022 1.01589 22.5C0.75369 22.4977 0.502878 22.3925 0.31747 22.2071C0.132062 22.0217 0.0268924 21.7709 0.0246139 21.5087C0.0223355 21.2465 0.12313 20.9939 0.305288 20.8053L9.59829 11.5123L0.305288 2.21929C0.209778 2.12704 0.133596 2.0167 0.0811869 1.89469C0.0287779 1.77269 0.00119157 1.64147 3.7757e-05 1.50869C-0.00111606 1.37591 0.0241854 1.24423 0.0744663 1.12134C0.124747 0.99844 0.199 0.886787 0.292893 0.792894C0.386786 0.699001 0.498438 0.624748 0.621334 0.574467C0.74423 0.524185 0.87591 0.498884 1.00869 0.500038C1.14147 0.501192 1.27269 0.52878 1.39469 0.581188C1.5167 0.633596 1.62704 0.709778 1.71929 0.805288L11.7193 10.8053C11.9049 10.9941 12.01 11.2475 12.0123 11.5123Z" fill="black"></path></svg></div></a>`);
            if (parsed.length == lcount)
            {
              let t = `View All<br/>${post.occasion} Looks`;
              if (title == "inspiredBy")
              {
                t = `View All Looks<br/>Inspired by Your<br/>Browsing History`;
                $("#" + elementId).append(`<div class="lookPDPProducts looksMoreCard zerovis" style="padding:0px!important"><a href="/pages/look-focus?occasion=inspiredBy&carousel=false" style='margin: auto;width: 100%;text-align: center;top: 43%;font-weight:bold;position:absolute'>${t}</a></div>`);
              }
              else
              {
                $("#" + elementId).append(`<div class="lookPDPProducts looksMoreCard zerovis" style="padding:0px!important"><a href="/pages/look-focus?occasion=${title}&carousel=false" style='margin: auto;width: 100%;text-align: center;top: 43%;font-weight:bold;position:absolute'>${t}</a></div>`);
              }
            }
            if (location != "admin")
              setTimeout(addSlick,count,elementId, tid);
          }
        }
        $("#lookLoader").remove();
        if (parsed.length == lcount && !carousel)
        {
          $("#lookRecs").append("<div id='btnLoadMoreLooks' style='text-align:center;width:100%;position:relative'><button onclick='loadMoreLooks(this)' class='btn-secondary' style='margin:auto;width:225px'>Load More</button></div>");
        }

        count+=100;
  	  }
      if (parsed.length == 0 && !carousel)
      {
        if (title == "inspiredBy")
        {
          $("#lookRecs").append(`<div style='text-align:center;width:100%'>No more Inspired By Looks</div>`);
        }
        else
        {
          $("#lookRecs").append(`<div style='text-align:center;width:100%'>No more ${post.occasion} Looks</div>`);
        }
        $("#btnLoadMoreLooks").hide();
        $("#lookLoader").hide();
      }
      $(".zerovis").fadeTo( "slow" , 1, function() {
        $(this).removeClass("zerovis").addClass("totalVis");
      });
    });
  }
  function LookPop(handle,id,lookId,stylist,category,isrec,brand)
  {
    window.looksScrollY = window.scrollY;
    $("#PageContainer,.content").addClass("blur").css("position","fixed").css("top",-window.looksScrollY).css("width","100%");
    $("#lookModal").show();
    $.get( "/pages/pdpmodal?handle="+ handle, function( data ) {
      $( "#look-modal-body" ).html( data );
      $("#look-modal-body .read-more").remove();
      $( "#look-modal-body #sidebar-box" ).hide();
      if(category == "admin")
        $( "#look-modal-body #sidebar-box" ).after( `<div class="lookPopViewPDP"><a href='/products/${handle}'>See Full Details</a></div>` );
      $( "#look-modal-body #sidebar-box" ).after( `<div class="lookPopViewPDP" onclick="lookPopViewDetails(this)" style="padding-top:0px!important;cursor:pointer;text-decoration:underline;font-size:13px;margin-top:-16px">Show Product Details</div>` );
      $(".modal-look-content").show();
      $("#lookModal").show();
      //_satellite.track("LookProduct_Click", { "productId": id, "productHandle": handle, "lookId": lookId, "stylistId": stylist, "categoryId":category });
      $("#lookrecscroller").scrollLeft(0);
      if (isrec)
      {
        $(".hidelookrec").removeClass("hidelookrec");
        $("#lookrec-" + id).addClass("hidelookrec");
        //return;
      }
      $("#lookPopRecs").remove();
      //get the fzy data
      fetch('https://spo-partner-api.azure-api.net/search?Subscription-Key=662cff71ce7d49088924abf032a0785c&term=' + id)
      .then(function(response) {
        return response.json();
      })
      .then(function(data) {
        if (data.value.length == 1)
        {
          $("#lookPopRecs").remove();
          //console.log(data);
          brand = brand.replace("'","");
          let p = data.value[0];
          let pcolor = "";
          let filter="";
          if (false && p.Fzy_Category.length > 0 && p.ProductType.indexOf("activewear") == -1)
          {
            filter += "Fzy_Category%7C" + p.Fzy_Category[0];
          }
          else
          {
            filter += "ProductType%7C" + p.ProductType;
          }
          if (p.Fzy_Style.length > 0)
          {
            filter += "%2CFzy_Style%7C" + p.Fzy_Style[0];
          }
          // if (p.Fzy_Detail.length > 0)
          // {
          //   if (p.Fzy_Detail[0] == "logo" && p.ProductType.indexOf("/shoes") > -1)
          //   {
          //    //do nothing for now
          //   }
          //   else if (p.Fzy_Detail[0] != "piping" && p.Fzy_Detail[0] != "rib")
          //   {
          //     //filter += "%2CFzy_Detail%7C" + p.Fzy_Detail[0];
          //   }
          // }
          if (p.Fzy_Heel.length > 0)
          {
            filter += "%2CFzy_Heel%7C" + p.Fzy_Heel[0];
          }
          if (p.Fzy_Gender.length > 0)
          {
            filter += "%2CFzy_Gender%7C" + p.Fzy_Gender[0];
          }
          if (p.Fzy_LegStyle.length > 0)
          {
            filter += "%2CFzy_LegStyle%7C" + p.Fzy_LegStyle[0];
          }
          if (p.Fzy_Length.length > 0 && (p.ProductType.indexOf("/dresses") > -1 || p.ProductType.indexOf("/skirts") > -1))
          {
            filter += "%2CFzy_Length%7C" + p.Fzy_Length[0];
          }
          if (p.Fzy_SleeveLength.length > 0)
          {
            filter += "%2CFzy_SleeveLength%7C" + p.Fzy_SleeveLength[0];
          }
          if (p.Fzy_Neckline.length > 0 && p.ProductType.indexOf("/dresses") == -1)
          {
            filter += "%2CFzy_Neckline%7C" + p.Fzy_Neckline[0];
          }
          if (p.color.length == 1)
          {
            filter += "%2Ccolor%7C" + p.color[0];
            pcolor = p.color[0];
          }
          fetch(`https://spo-partner-api.azure-api.net/search?Subscription-Key=662cff71ce7d49088924abf032a0785c&filter=${filter}&pagesize=9&page=1`)
          .then(function(response) {
            return response.json();
          })
          .then(function(data) {
            $("#lookPopRecs").remove();
            //console.log(data);
            if (data.value.length <= 1)
              return;
            let s = `<div id='lookPopRecs'><div style="font-weight: bold;padding-bottom: 10px;padding-top:10px">Similar Styles</div><div style="overflow-x:scroll;margin-left: 10px;" id="lookrecscroller"><div id="ProductThumbs-lookrecs" style="display: flex;flex-direction: row;margin: auto;width: fit-content;padding-bottom: 20px;">`;
            let count = 0;
            for (let p of data.value)
            {
              let imgsrc = p.Images[0].replace(".jpg","_120x.jpg").replace(".webp","_120x.webp");
              if (id != p.ProductID && count < 8)
              {
                count++;
                if (pcolor != "")
                {
                  for (let v of p.Variants)
                  {
                    if (v.Color == pcolor)
                    {
                      imgsrc = v.Image.replace(".jpg","_120x.jpg").replace(".webp","_120x.webp");
                      break;
                    }
                  }
                }
                s+=`<div class="nosto-item nosto-item-car clearfix" id="lookrec-${p.ProductID}" style="margin: 0px 20px 0px 0px;overflow: hidden;width:120px"><div class="" onclick="LookPop('${p.Handle}',${p.ProductID}, '${lookId}', '${stylist}', '${category}',true,'${brand}')"><div class="lookreccontainer"><div class="pdp-img-overlay"></div><img class="lookreccontainerimg" src="${imgsrc}"></div></div><div class="lookPDPbrand"><div style="overflow: hidden;max-height: 20px;">${p.Brand}</div><span class="lookprice">$${p.Price}</span>&nbsp;&nbsp;<span class="lookpricemsrp">$${p.CompareAtPrice}</span></div></div>`;
              }
            }

            let fi = $("#look-modal-body .first-img-pdp").first().attr("srcset").split(",")[0].split(" ")[0].replace("360x","120x");
            let list = $("#look-modal-body .product__price--compare").first().html();
            s+=`<div class="nosto-item nosto-item-car clearfix hidelookrec" id="lookrec-${id}" style="margin: 0px 20px 0px 0px;overflow: hidden;width:120px"><div class="" onclick="LookPop('${handle}',${id}, '${lookId}', '${stylist}', '${category}',true,'${brand}')"><div class="lookreccontainer"><div class="pdp-img-overlay"></div><img class="lookreccontainerimg" src="${fi}"></div></div><div class="lookPDPbrand"><div style="overflow: hidden;max-height: 20px;">${brand}</div><span class="lookprice">$${dataLayerData.product.price}</span>&nbsp;&nbsp;<span class="lookpricemsrp">$${list}</span></div></div>`;
            s+="</div></div></div>";
            $( "#look-modal-body" ).prepend(s);
          });
        }
      });
    });
  }
  function closeLookModal(){
    $( "#look-modal-body" ).html( "" );
    $(".modal-look-content").hide();
    $("#PageContainer").removeClass("blur").css("position","relative").css("top",0);
    window.scroll(0, window.looksScrollY);
    $("#lookModal").hide();
  }
  function numberWithCommasLooks(num) {
    return num.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
  }

  function lookCarouselArrowClick(id)
  {
   //_satellite.track("LookCarousel_Swipe", { "categoryId":id });
  }
  function addSlick(elementId, category)
  {
    let tdots = window.innerWidth > 767 ? false : true;
    let nextArrow = $("#next-" + category);
    let prevArrow = $("#prev-" + category);

    $("#" + elementId).slick({
      infinite: false,
      dots: tdots,
      slidesToShow: 4.3,
      slidesToScroll: 4,
      nextArrow: nextArrow,
      prevArrow: prevArrow,
      adaptiveHeight: true,
      swipe: true,
      responsive: [
        {
          breakpoint: 1540,
          settings: {
            slidesToShow: 3.3,
            slidesToScroll: 3
          }
        },
        {
          breakpoint: 1024,
          settings: {
            slidesToShow: 2.3,
            slidesToScroll: 2
          }
        },
        {
          breakpoint: 769,
          settings: {
            slidesToShow: 2.3,
            slidesToScroll: 2
          }
        },
        {
          breakpoint: 768,
          settings: {
            slidesToShow: 1.15,
            slidesToScroll: 1
          }
        }
      ]
    }).on('swipe', function(event, slick, direction){
      //_satellite.track("LookCarousel_Swipe", { "categoryId":category });
    });
  }
  function lookPopViewDetails(e)
  {
    $(e).hide();
    $( "#look-modal-body #sidebar-box" ).show();
  }
  window.looksScrollY = 0;
  function addSlickMini(elementId,category,lookId,stylist)
  {
    $("." + elementId).slick({
      infinite: false,
      dots: true,
      slidesToShow: 1,
      slidesToScroll: 1,
      arrows: false,
      adaptiveHeight: true
    }).on('swipe', function(event, slick, direction){
      //console.log(category);
      //_satellite.track("LookProduct_Swipe", { "categoryId":category, "lookId": lookId, "stylistId": stylist });
    });

    if (location.href.indexOf("/products/") > -1)
    {
      window.setTimeout(function() {
          $(".lookInside").each(function(){
            	let i = $(this).find('.slick-slide[data-id="'+ category +'"]').data("slick-index");
          	$(this).slick('slickGoTo', i);
          });
        },200);
    }
    //console.log(elementId);
    $(".lookCarousel").css("visibility","visible");
  }
function animateToTop()
{
 $("html, body").animate({ scrollTop: "0" });
}
const prLeft = () => {
    $(".pinned-rec-row").animate({
      scrollLeft: '-=600'
    }, 300, 'swing');

    if ($(".pinned-rec-row").scrollLeft() < 0) {
        $(".pr-arrowLeft").hide();
    }
    else {
        $(".pr-arrowLeft").show();
    }
    if ($(".pinned-rec-row").scrollLeft() >= 3550) {
        $(".pr-arrowRightt").hide();
    }
    else {
        $(".pr-arrowRight").show();
    }
}

const prRight = () => {
   $(".pinned-rec-row").animate({
      scrollLeft: '+=600'
    }, 300, 'swing');

    if ($(".pinned-rec-row").scrollLeft() < 0) {
        $(".pr-arrowLeft").hide();
    }
    else {
        $(".pr-arrowLeft").show();
    }

    if ($(".pinned-rec-row").scrollLeft() >= 3550) {
        $(".pr-arrowRight").hide();
    }
    else {
        $(".pr-arrowRight").show();
    }
}

const prBagDrawerLeft = () => {
  $(".pinned-rec-row").animate({
    scrollLeft: '-=200'
  }, 300, 'swing');

  if ($(".pinned-rec-row").scrollLeft() === 200) {
      $(".pr-arrowLeft").hide();
  }
  else {
      $(".pr-arrowLeft").show();
  }
  if ($(".pinned-rec-row").scrollLeft() >= 2200) {
      $(".pr-arrowRight").hide();
  }
  else {
      $(".pr-arrowRight").show();
  }
}

const prBagDrawerRight = () => {
 $(".pinned-rec-row").animate({
    scrollLeft: '+=200'
  }, 300, 'swing');

  if ($(".pinned-rec-row").scrollLeft() < 0) {
      $(".pr-arrowLeft").hide();
  }
  else {
      $(".pr-arrowLeft").show();
  }

  if ($(".pinned-rec-row").scrollLeft() >= 2200) {
      $(".pr-arrowRight").hide();
  }
  else {
      $(".pr-arrowRight").show();
  }
}

function sleep(time) {
  return new Promise((resolve) => setTimeout(resolve,time));
}
function quickviewyo(handle,el)
{
  $('.discovery-modal').show();
  //window.scrollTo(0, 1000);  
  let id = $(el).data("varid");
  $('body,#PageContainer,.content').addClass('overflowHidden'); 
  
  $.get( `/pages/pdpmodal?handle=${handle}&variant=${id}`, function( data ) {
    $( ".discovery-modal-content-body" ).html( data ).scrollTop(0);    
      if ($(window).width() < 768) {        
        $('.discovery-modal').addClass('show-modal');        
      }
    else
      {
        window.setTimeout(function() {        
          $('.discovery-modal-content').addClass('discovery-modal-fade-in');
          $( ".discovery-modal .page-content" ).after( `<div class="lookPopViewPDP"><a href='/products/${handle}'>See Full Details</a></div>` );
        },200);         
      }
  });
}
function closeItem() { 
  $('body,#PageContainer,.content').removeClass('overflowHidden');
    $('.discovery-modal').removeClass('show-modal');
    if ($(window).width() < 768) {
      window.setTimeout(function() {        
        $('.discovery-modal').hide();
        $('.discovery-modal-content-body').empty();        
      },200); 
    } 
    else
    {
      $('.discovery-modal-content').removeClass('discovery-modal-fade-in');
      $('.discovery-modal-content').addClass('discovery-modal-fade-out');
      window.setTimeout(function() {        
        $('.discovery-modal').hide();
        $('.discovery-modal-content-body').empty();
        $('body,#PageContainer,.content').css('overflow-y', 'auto');
        $('.discovery-modal-content').removeClass('discovery-modal-fade-out');
      },50);      
    }
  }
const openSF = (b) => {
  location.href = `/collections/all?Brand=${encodeURIComponent(b)}&allBrands=1&cid=brandClick:pdp`;
}
function findSimilarPLP(id) {
    //_satellite.track("DiscoveryButtonClickPLP");
    imgSearchModal($(`#plp-p-${id}`).css('background-image').replace(/url\(("|')(.+)("|')\)/gi, '$2'));        
  }
